export const countries = [
  {
    code: '',
    name: '',
    phone: '',
    states: [
      {
        cities: [
          {
            name: '',
            zipCode: '',
          },
        ],
        name: '',
      },
    ],
  },
  {
    code: 'AF',
    name: 'Afghanistan',
    phone: '93',
  },
  {
    code: 'AL',
    name: 'Albania',
    phone: '355',
  },
  {
    code: 'DZ',
    name: 'Algeria',
    phone: '213',
  },
  {
    code: 'AX',
    name: 'Alland Islands',
    phone: '358',
  },
  {
    code: 'AS',
    name: 'American Samoa',
    phone: '1-684',
  },
  {
    code: 'AD',
    name: 'Andorra',
    phone: '376',
  },
  {
    code: 'AO',
    name: 'Angola',
    phone: '244',
  },
  {
    code: 'AI',
    name: 'Anguilla',
    phone: '1-264',
  },
  {
    code: 'AQ',
    name: 'Antarctica',
    phone: '672',
  },
  {
    code: 'AG',
    name: 'Antigua and Barbuda',
    phone: '1-268',
  },
  {
    code: 'AR',
    name: 'Argentina',
    phone: '54',
  },
  {
    code: 'AM',
    name: 'Armenia',
    phone: '374',
  },
  {
    code: 'AW',
    name: 'Aruba',
    phone: '297',
  },
  {
    code: 'AU',
    name: 'Australia',
    phone: '61',
    suggested: true,
  },
  {
    code: 'AT',
    name: 'Austria',
    phone: '43',
  },
  {
    code: 'AZ',
    name: 'Azerbaijan',
    phone: '994',
  },
  {
    code: 'BS',
    name: 'Bahamas',
    phone: '1-242',
  },
  {
    code: 'BH',
    name: 'Bahrain',
    phone: '973',
  },
  {
    code: 'BD',
    name: 'Bangladesh',
    phone: '880',
  },
  {
    code: 'BB',
    name: 'Barbados',
    phone: '1-246',
  },
  {
    code: 'BY',
    name: 'Belarus',
    phone: '375',
  },
  {
    code: 'BE',
    name: 'Belgium',
    phone: '32',
  },
  {
    code: 'BZ',
    name: 'Belize',
    phone: '501',
  },
  {
    code: 'BJ',
    name: 'Benin',
    phone: '229',
  },
  {
    code: 'BM',
    name: 'Bermuda',
    phone: '1-441',
  },
  {
    code: 'BT',
    name: 'Bhutan',
    phone: '975',
  },
  {
    code: 'BO',
    name: 'Bolivia',
    phone: '591',
  },
  {
    code: 'BA',
    name: 'Bosnia and Herzegovina',
    phone: '387',
  },
  {
    code: 'BW',
    name: 'Botswana',
    phone: '267',
  },
  {
    code: 'BV',
    name: 'Bouvet Island',
    phone: '47',
  },
  {
    code: 'BR',
    name: 'Brazil',
    phone: '55',
  },
  {
    code: 'IO',
    name: 'British Indian Ocean Territory',
    phone: '246',
  },
  {
    code: 'VG',
    name: 'British Virgin Islands',
    phone: '1-284',
  },
  {
    code: 'BN',
    name: 'Brunei Darussalam',
    phone: '673',
  },
  {
    code: 'BG',
    name: 'Bulgaria',
    phone: '359',
  },
  {
    code: 'BF',
    name: 'Burkina Faso',
    phone: '226',
  },
  {
    code: 'BI',
    name: 'Burundi',
    phone: '257',
  },
  {
    code: 'KH',
    name: 'Cambodia',
    phone: '855',
  },
  {
    code: 'CM',
    name: 'Cameroon',
    phone: '237',
  },
  {
    code: 'CA',
    name: 'Canada',
    phone: '1',
    suggested: true,
  },
  {
    code: 'CV',
    name: 'Cape Verde',
    phone: '238',
  },
  {
    code: 'KY',
    name: 'Cayman Islands',
    phone: '1-345',
  },
  {
    code: 'CF',
    name: 'Central African Republic',
    phone: '236',
  },
  {
    code: 'TD',
    name: 'Chad',
    phone: '235',
  },
  {
    code: 'CL',
    name: 'Chile',
    numberFormat: {
      code: 'es-CL',
      currency: 'CLP',
    },
    phone: '56',
    states: [
      {
        cities: [
          {
            name: 'Antofagasta',
            zipCode: '1240000',
          },
          {
            name: 'Calama',
            zipCode: '1390000',
          },
          {
            name: 'Maria Elena',
            zipCode: '1360000',
          },
          {
            name: 'Mejillones',
            zipCode: '1310000',
          },
          {
            name: 'Ollague',
            zipCode: '1420000',
          },
          {
            name: 'San Pedro De Atacama',
            zipCode: '1410000',
          },
          {
            name: 'Sierra Gorda',
            zipCode: '1320000',
          },
          {
            name: 'Taltal',
            zipCode: '1300000',
          },
          {
            name: 'Tocopilla',
            zipCode: '1340000',
          },
        ],
        name: 'Antofagasta',
      },
      {
        cities: [
          {
            name: 'Angol',
            zipCode: '4650000',
          },
          {
            name: 'Carahue',
            zipCode: '5010000',
          },
          {
            name: 'Chol Chol',
            zipCode: '5040000',
          },
          {
            name: 'Collipulli',
            zipCode: '4680000',
          },
          {
            name: 'Cunco',
            zipCode: '4890000',
          },
          {
            name: 'Curacautin',
            zipCode: '4700000',
          },
          {
            name: 'Curarrehue',
            zipCode: '4910000',
          },
          {
            name: 'Ercilla',
            zipCode: '4710000',
          },
          {
            name: 'Freire',
            zipCode: '4940000',
          },
          {
            name: 'Galvarino',
            zipCode: '5030000',
          },
          {
            name: 'Gorbea',
            zipCode: '4960000',
          },
          {
            name: 'Lautaro',
            zipCode: '4860000',
          },
          {
            name: 'Loncoche',
            zipCode: '4970000',
          },
          {
            name: 'Lonquimay',
            zipCode: '4690000',
          },
          {
            name: 'Los Sauces',
            zipCode: '4760000',
          },
          {
            name: 'Lumaco',
            zipCode: '4740000',
          },
          {
            name: 'Melipeuco',
            zipCode: '4900000',
          },
          {
            name: 'Nueva Imperial',
            zipCode: '5020000',
          },
          {
            name: 'Padre Las Casas',
            zipCode: '4850000',
          },
          {
            name: 'Perquenco',
            zipCode: '4870000',
          },
          {
            name: 'Pitrufquen',
            zipCode: '4950000',
          },
          {
            name: 'Pucon',
            zipCode: '4920000',
          },
          {
            name: 'Puren',
            zipCode: '4750000',
          },
          {
            name: 'Renaico',
            zipCode: '4670000',
          },
          {
            name: 'Saavedra',
            zipCode: '5000000',
          },
          {
            name: 'Temuco',
            zipCode: '4780000',
          },
          {
            name: 'Teodoro Schmidt',
            zipCode: '4990000',
          },
          {
            name: 'Tolten',
            zipCode: '4980000',
          },
          {
            name: 'Traiguen',
            zipCode: '4730000',
          },
          {
            name: 'Victoria',
            zipCode: '4720000',
          },
          {
            name: 'Vilcun',
            zipCode: '4880000',
          },
          {
            name: 'Villarrica',
            zipCode: '4930000',
          },
        ],
        name: 'Araucania',
      },
      {
        cities: [
          {
            name: 'Arica',
            zipCode: '1000000',
          },
          {
            name: 'Camarones',
            zipCode: '1040000',
          },
          {
            name: 'General Lagos',
            zipCode: '1080000',
          },
          {
            name: 'Putre',
            zipCode: '1070000',
          },
        ],
        name: 'Arica y Parinacota',
      },
      {
        cities: [
          {
            name: 'Alto Del Carmen',
            zipCode: '1650000',
          },
          {
            name: 'Caldera',
            zipCode: '1570000',
          },
          {
            name: 'Chanaral',
            zipCode: '1490000',
          },
          {
            name: 'Copiapo',
            zipCode: '1530000',
          },
          {
            name: 'Diego De Almagro',
            zipCode: '1500000',
          },
          {
            name: 'Freirina',
            zipCode: '1630000',
          },
          {
            name: 'Huasco',
            zipCode: '1640000',
          },
          {
            name: 'Tierra Amarilla',
            zipCode: '1580000',
          },
          {
            name: 'Vallenar',
            zipCode: '1610000',
          },
        ],
        name: 'Atacama',
      },
      {
        cities: [
          {
            name: 'Aysen',
            zipCode: '6000000',
          },
          {
            name: 'Chile Chico',
            zipCode: '6050000',
          },
          {
            name: 'Cisnes',
            zipCode: '6010000',
          },
          {
            name: 'Cochrane',
            zipCode: '6100000',
          },
          {
            name: 'Coyhaique',
            zipCode: '5950000',
          },
          {
            name: 'Guaitecas',
            zipCode: '6020000',
          },
          {
            name: 'Lago Verde',
            zipCode: '5960000',
          },
          {
            name: 'Ohiggins',
            zipCode: '6110000',
          },
          {
            name: 'Rio Ibanez',
            zipCode: '6060000',
          },
          {
            name: 'Tortel',
            zipCode: '6120000',
          },
        ],
        name: 'Aysen',
      },
      {
        cities: [
          {
            name: 'Alto Biobio',
            zipCode: '3690000',
          },
          {
            name: 'Antuco',
            zipCode: '3720000',
          },
          {
            name: 'Arauco',
            zipCode: '3610000',
          },
          {
            name: 'Cabrero',
            zipCode: '3560000',
          },
          {
            name: 'Canete',
            zipCode: '3570000',
          },
          {
            name: 'Chiguayante',
            zipCode: '3340000',
          },
          {
            name: 'Concepcion',
            zipCode: '3540000',
          },
          {
            name: 'Contulmo',
            zipCode: '3400000',
          },
          {
            name: 'Coronel',
            zipCode: '3410000',
          },
          {
            name: 'Curanilahue',
            zipCode: '3580000',
          },
          {
            name: 'Florida',
            zipCode: '3620000',
          },
          {
            keywords: ['Hualpén'],
            name: 'Hualpen',
            zipCode: '3530000',
          },
          {
            name: 'Hualqui',
            zipCode: '3380000',
          },
          {
            name: 'Laja',
            zipCode: '3630000',
          },
          {
            name: 'Lebu',
            zipCode: '3500000',
          },
          {
            name: 'Los Alamos',
            zipCode: '3710000',
          },
          {
            name: 'Los Angeles',
            zipCode: '3550000',
          },
          {
            name: 'Lota',
            zipCode: '3430000',
          },
          {
            name: 'Mulchen',
            zipCode: '3640000',
          },
          {
            name: 'Nacimiento',
            zipCode: '3510000',
          },
          {
            name: 'Negrete',
            zipCode: '3370000',
          },
          {
            name: 'Niquen',
            zipCode: '3390000',
          },
          {
            name: 'Penco',
            zipCode: '3520000',
          },
          {
            name: 'Quilaco',
            zipCode: '3660000',
          },
          {
            name: 'Quilleco',
            zipCode: '3490000',
          },
          {
            name: 'San Pedro De La Paz',
            zipCode: '3460000',
          },
          {
            name: 'San Rosendo',
            zipCode: '3360000',
          },
          {
            name: 'Santa Barbara',
            zipCode: '3420000',
          },
          {
            name: 'Santa Juana',
            zipCode: '3650000',
          },
          {
            name: 'Talcahuano',
            zipCode: '3600000',
          },
          {
            name: 'Tirua',
            zipCode: '3110000',
          },
          {
            name: 'Tome',
            zipCode: '3150000',
          },
          {
            name: 'Tucapel',
            zipCode: '2960000',
          },
          {
            name: 'Yumbel',
            zipCode: '2820000',
          },
        ],
        keywords: ['Bío Bío'],
        name: 'Bio Bio',
      },
      {
        cities: [
          {
            name: 'Andacollo',
            zipCode: '1750000',
          },
          {
            name: 'Canela',
            zipCode: '1960000',
          },
          {
            name: 'Combarbala',
            zipCode: '1890000',
          },
          {
            name: 'Coquimbo',
            zipCode: '1780000',
          },
          {
            name: 'Illapel',
            zipCode: '1930000',
          },
          {
            name: 'La Higuera',
            zipCode: '1740000',
          },
          {
            name: 'La Serena',
            zipCode: '1700000',
          },
          {
            name: 'Los Vilos',
            zipCode: '1940000',
          },
          {
            name: 'Monte Patria',
            zipCode: '1880000',
          },
          {
            name: 'Ovalle',
            zipCode: '1840000',
          },
          {
            name: 'Paihuano',
            zipCode: '1770000',
          },
          {
            name: 'Punitaqui',
            zipCode: '1900000',
          },
          {
            name: 'Rio Hurtado',
            zipCode: '1870000',
          },
          {
            name: 'Salamanca',
            zipCode: '1950000',
          },
          {
            name: 'Vicuna',
            zipCode: '1760000',
          },
        ],
        name: 'Coquimbo',
      },
      {
        cities: [
          {
            name: 'Ancud',
            zipCode: '5710000',
          },
          {
            name: 'Calbuco',
            zipCode: '5570000',
          },
          {
            name: 'Castro',
            zipCode: '5700000',
          },
          {
            name: 'Chaiten',
            zipCode: '5850000',
          },
          {
            name: 'Chonchi',
            zipCode: '5770000',
          },
          {
            name: 'Cochamo',
            zipCode: '5560000',
          },
          {
            name: 'Curaco De Velez',
            zipCode: '5740000',
          },
          {
            name: 'Dalcahue',
            zipCode: '5730000',
          },
          {
            name: 'Fresia',
            zipCode: '5600000',
          },
          {
            name: 'Frutillar',
            zipCode: '5620000',
          },
          {
            name: 'Futaleufu',
            zipCode: '5870000',
          },
          {
            name: 'Hualaihue',
            zipCode: '5860000',
          },
          {
            name: 'Llanquihue',
            zipCode: '5610000',
          },
          {
            name: 'Los Muermos',
            zipCode: '5590000',
          },
          {
            name: 'Maullin',
            zipCode: '5580000',
          },
          {
            name: 'Osorno',
            zipCode: '5290000',
          },
          {
            name: 'Palena',
            zipCode: '5880000',
          },
          {
            name: 'Puerto Montt',
            zipCode: '5480000',
          },
          {
            name: 'Puerto Octay',
            zipCode: '5370000',
          },
          {
            name: 'Puerto Varas',
            zipCode: '5550000',
          },
          {
            name: 'Puqueldon',
            zipCode: '5760000',
          },
          {
            name: 'Purranque',
            zipCode: '5380000',
          },
          {
            name: 'Puyehue',
            zipCode: '5360000',
          },
          {
            name: 'Queilen',
            zipCode: '5780000',
          },
          {
            name: 'Quellon',
            zipCode: '5790000',
          },
          {
            name: 'Quemchi',
            zipCode: '5720000',
          },
          {
            name: 'Quinchao',
            zipCode: '5750000',
          },
          {
            name: 'Rio Negro',
            zipCode: '5390000',
          },
          {
            name: 'San Juan De La Costa',
            zipCode: '5400000',
          },
          {
            name: 'San Pablo',
            zipCode: '5350000',
          },
        ],
        name: 'Los Lagos',
      },
      {
        cities: [
          {
            name: 'Corral',
            zipCode: '5190000',
          },
          {
            name: 'Futrono',
            zipCode: '5180000',
          },
          {
            name: 'La Union',
            zipCode: '5220000',
          },
          {
            name: 'Lago Ranco',
            zipCode: '5250000',
          },
          {
            name: 'Lanco',
            zipCode: '5160000',
          },
          {
            name: 'Los Lagos',
            zipCode: '5170000',
          },
          {
            name: 'Mafil',
            zipCode: '5200000',
          },
          {
            name: 'Mariquina',
            zipCode: '5150000',
          },
          {
            name: 'Paillaco',
            zipCode: '5230000',
          },
          {
            name: 'Panguipulli',
            zipCode: '5210000',
          },
          {
            name: 'Rio Bueno',
            zipCode: '5240000',
          },
          {
            name: 'Valdivia',
            zipCode: '5090000',
          },
        ],
        name: 'Los Rios',
      },
      {
        cities: [
          {
            name: 'Antartica',
            zipCode: '6360000',
          },
          {
            name: 'Cabo De Hornos',
            zipCode: '6350000',
          },
          {
            name: 'Laguna Blanca',
            zipCode: '6250000',
          },
          {
            name: 'Natales',
            zipCode: '6160000',
          },
          {
            name: 'Porvenir',
            zipCode: '6300000',
          },
          {
            name: 'Primavera',
            zipCode: '6310000',
          },
          {
            name: 'Punta Arenas',
            zipCode: '6200000',
          },
          {
            name: 'Rio Verde',
            zipCode: '6240000',
          },
          {
            name: 'San Gregorio',
            zipCode: '6260000',
          },
          {
            name: 'Timaukel',
            zipCode: '6320000',
          },
          {
            name: 'Torres Del Paine',
            zipCode: '6170000',
          },
        ],
        name: 'Magallanes y la Antartica Chilena',
      },
      {
        cities: [
          {
            name: 'Aduana',
            zipCode: '3380000',
          },
          {
            name: 'Aduana Pejerrey',
            zipCode: '3580000',
          },
          {
            name: 'Ajial',
            zipCode: '3630000',
          },
          {
            name: 'Arbolillo',
            zipCode: '3650000',
          },
          {
            name: 'Armerillo',
            zipCode: '3520000',
          },
          {
            name: 'Astillero',
            zipCode: '3500000',
          },
          {
            name: 'Aurora',
            zipCode: '3520000',
          },
          {
            name: 'Barrera',
            zipCode: '3610000',
          },
          {
            name: 'Batuco',
            zipCode: '3550000',
          },
          {
            name: 'Bobadilla',
            zipCode: '3660000',
          },
          {
            name: 'Botalcura',
            zipCode: '3460000',
          },
          {
            name: 'Bullilleo',
            zipCode: '3630000',
          },
          {
            name: 'Campamento Ancoa',
            zipCode: '3580000',
          },
          {
            name: 'Cauquenes',
            zipCode: '3690000',
          },
          {
            name: 'Chanco',
            zipCode: '3720000',
          },
          {
            name: 'Coipue',
            zipCode: '3550000',
          },
          {
            name: 'Colbun',
            zipCode: '3610000',
          },
          {
            name: 'Colin',
            zipCode: '3460000',
          },
          {
            name: 'Constitucion',
            zipCode: '3560000',
          },
          {
            name: 'Corinto',
            zipCode: '3460000',
          },
          {
            name: 'Corralones',
            zipCode: '3520000',
          },
          {
            name: 'Culenar',
            zipCode: '3360000',
          },
          {
            name: 'Cumpeo',
            zipCode: '3510000',
          },
          {
            name: 'Curanipe',
            zipCode: '3720000',
          },
          {
            name: 'Curepto',
            zipCode: '3570000',
          },
          {
            name: 'Curico',
            zipCode: '3340000',
          },
          {
            name: 'Curtiduria',
            zipCode: '3460000',
          },
          {
            name: 'Duao',
            zipCode: '3530000',
          },
          {
            name: 'El Colorado',
            zipCode: '3520000',
          },
          {
            name: 'El Manzano',
            zipCode: '3360000',
          },
          {
            name: 'El Penon',
            zipCode: '3630000',
          },
          {
            name: 'El Planchon',
            zipCode: '3370000',
          },
          {
            name: 'El Salto',
            zipCode: '3580000',
          },
          {
            name: 'El Transito',
            zipCode: '3620000',
          },
          {
            name: 'Empedrado',
            zipCode: '3540000',
          },
          {
            name: 'Endesa',
            zipCode: '3520000',
          },
          {
            name: 'Gualleco',
            zipCode: '3550000',
          },
          {
            name: 'Hualane',
            zipCode: '3400000',
          },
          {
            name: 'Hualve',
            zipCode: '3690000',
          },
          {
            name: 'Iloca',
            zipCode: '3420000',
          },
          {
            name: 'Itahue',
            zipCode: '3510000',
          },
          {
            name: 'Junquillar',
            zipCode: '3560000',
          },
          {
            name: 'La Lora',
            zipCode: '3570000',
          },
          {
            name: 'La Mina',
            zipCode: '3520000',
          },
          {
            name: 'La Montana',
            zipCode: '3360000',
          },
          {
            name: 'La Trinchera',
            zipCode: '3420000',
          },
          {
            name: 'Las Campanas',
            zipCode: '3650000',
          },
          {
            name: 'Las Garzas',
            zipCode: '3520000',
          },
          {
            name: 'Licanten',
            zipCode: '3410000',
          },
          {
            name: 'Linares',
            zipCode: '3580000',
          },
          {
            name: 'Lipimavida',
            zipCode: '3420000',
          },
          {
            name: 'Litu',
            zipCode: '3490000',
          },
          {
            name: 'Llepo',
            zipCode: '3580000',
          },
          {
            name: 'Llico',
            zipCode: '3420000',
          },
          {
            name: 'Longavi',
            zipCode: '3620000',
          },
          {
            name: 'Lontue',
            zipCode: '3380000',
          },
          {
            name: 'Los Cristales',
            zipCode: '3620000',
          },
          {
            name: 'Los Nabos',
            zipCode: '3690000',
          },
          {
            name: 'Los Niches',
            zipCode: '3340000',
          },
          {
            name: 'Los Perales',
            zipCode: '3690000',
          },
          {
            name: 'Los Quenes',
            zipCode: '3370000',
          },
          {
            name: 'Los Rabones',
            zipCode: '3580000',
          },
          {
            name: 'Maule',
            zipCode: '3530000',
          },
          {
            name: 'Melado',
            zipCode: '3580000',
          },
          {
            name: 'Melao',
            zipCode: '3620000',
          },
          {
            name: 'Melozal',
            zipCode: '3650000',
          },
          {
            name: 'Mesamavida',
            zipCode: '3620000',
          },
          {
            name: 'Miraflores',
            zipCode: '3580000',
          },
          {
            name: 'Molina',
            zipCode: '3380000',
          },
          {
            name: 'Monte Oscuro',
            zipCode: '3340000',
          },
          {
            name: 'Nirivilo',
            zipCode: '3540000',
          },
          {
            name: 'Palmilla',
            zipCode: '3580000',
          },
          {
            name: 'Palquibuda',
            zipCode: '3430000',
          },
          {
            name: 'Panimavida',
            zipCode: '3600000',
          },
          {
            name: 'Parral',
            zipCode: '3630000',
          },
          {
            name: 'Paso Hondo',
            zipCode: '3690000',
          },
          {
            name: 'Paso Nevado',
            zipCode: '3520000',
          },
          {
            name: 'Pelarco',
            zipCode: '3500000',
          },
          {
            name: 'Pelluhue',
            zipCode: '3710000',
          },
          {
            name: 'Pencahue',
            zipCode: '3550000',
          },
          {
            name: 'Perquilauquen',
            zipCode: '3630000',
          },
          {
            name: 'Pichaman',
            zipCode: '3550000',
          },
          {
            name: 'Pichibudi',
            zipCode: '3420000',
          },
          {
            name: 'Potrero Grande',
            zipCode: '3340000',
          },
          {
            name: 'Potrero Grande Chico',
            zipCode: '3370000',
          },
          {
            name: 'Putu',
            zipCode: '3560000',
          },
          {
            name: 'Quebrada Honda',
            zipCode: '3340000',
          },
          {
            name: 'Quella',
            zipCode: '3690000',
          },
          {
            name: 'Quinchimavida',
            zipCode: '3630000',
          },
          {
            name: 'Quinmavida',
            zipCode: '3600000',
          },
          {
            name: 'Quivolgo',
            zipCode: '3560000',
          },
          {
            name: 'Radal',
            zipCode: '3380000',
          },
          {
            name: 'Rauco',
            zipCode: '3430000',
          },
          {
            name: 'Rebeca',
            zipCode: '3360000',
          },
          {
            name: 'Retiro',
            zipCode: '3640000',
          },
          {
            name: 'Rio Claro',
            zipCode: '3510000',
          },
          {
            name: 'Robleria',
            zipCode: '3580000',
          },
          {
            name: 'Romeral',
            zipCode: '3370000',
          },
          {
            name: 'Sagrada Familia',
            zipCode: '3390000',
          },
          {
            name: 'San Clemente',
            zipCode: '3520000',
          },
          {
            name: 'San Javier',
            zipCode: '3660000',
          },
          {
            name: 'San Pablo',
            zipCode: '3630000',
          },
          {
            name: 'San Rafael',
            zipCode: '3490000',
          },
          {
            name: 'Santa Ana',
            zipCode: '3610000',
          },
          {
            name: 'Talca',
            zipCode: '3460000',
          },
          {
            name: 'Teno',
            zipCode: '3360000',
          },
          {
            name: 'Termas De Catillo',
            zipCode: '3630000',
          },
          {
            name: 'Trincao',
            zipCode: '3430000',
          },
          {
            name: 'Unicaven',
            zipCode: '3690000',
          },
          {
            name: 'Upeo',
            zipCode: '3340000',
          },
          {
            name: 'Vichuquen',
            zipCode: '3420000',
          },
          {
            name: 'Villa Alegre',
            zipCode: '3650000',
          },
          {
            name: 'Villa Prat',
            zipCode: '3390000',
          },
          {
            name: 'Villa Rosas',
            zipCode: '3630000',
          },
          {
            name: 'Villa Seca',
            zipCode: '3620000',
          },
          {
            name: 'Yacel',
            zipCode: '3380000',
          },
          {
            name: 'Yerbas Buenas',
            zipCode: '3600000',
          },
        ],
        name: 'Maule',
      },
      {
        cities: [
          {
            name: 'Alhue',
            zipCode: '9650000',
          },
          {
            name: 'Buin',
            zipCode: '9500000',
          },
          {
            name: 'Calera de Tango',
            zipCode: '9560000',
          },
          {
            name: 'Cerrillos',
            zipCode: '9200000',
          },
          {
            name: 'Cerro Navia',
            zipCode: '9080000',
          },
          {
            name: 'Colina',
            zipCode: '9340000',
          },
          {
            name: 'Conchali',
            zipCode: '8540000',
          },
          {
            name: 'Curacavi',
            zipCode: '9630000',
          },
          {
            name: 'El Bosque',
            zipCode: '8010000',
          },
          {
            name: 'El Monte',
            zipCode: '9810000',
          },
          {
            name: 'Estacion Central',
            zipCode: '9160000',
          },
          {
            name: 'Huechuraba',
            zipCode: '8580000',
          },
          {
            name: 'Independencia',
            zipCode: '8380000',
          },
          {
            name: 'Isla de Maipo',
            zipCode: '9790000',
          },
          {
            name: 'La Cisterna',
            zipCode: '7970000',
          },
          {
            name: 'La Florida',
            zipCode: '8240000',
          },
          {
            name: 'La Granja',
            zipCode: '8780000',
          },
          {
            name: 'La Pintana',
            zipCode: '8820000',
          },
          {
            name: 'La Reina',
            zipCode: '7850000',
          },
          {
            name: 'Lampa',
            zipCode: '9380000',
          },
          {
            name: 'Las Condes',
            zipCode: '7550000',
          },
          {
            name: 'Lo Barnechea',
            zipCode: '7690000',
          },
          {
            name: 'Lo Espejo',
            zipCode: '9120000',
          },
          {
            name: 'Lo Prado',
            zipCode: '8980000',
          },
          {
            name: 'Macul',
            zipCode: '7810000',
          },
          {
            name: 'Maipu',
            zipCode: '9250000',
          },
          {
            name: 'Maria Pinto',
            zipCode: '9620000',
          },
          {
            name: 'Melipilla',
            zipCode: '9580000',
          },
          {
            name: 'Padre Hurtado',
            zipCode: '9710000',
          },
          {
            name: 'Paine',
            zipCode: '9540000',
          },
          {
            name: 'Pedro Aguirre Cerda',
            zipCode: '8460000',
          },
          {
            name: 'Peñaflor',
            zipCode: '9750000',
          },
          {
            keywords: ['Penalolen', 'Peñalolén'],
            name: 'Peñalolen',
            zipCode: '7910000',
          },
          {
            name: 'Pirque',
            zipCode: '9480000',
          },
          {
            name: 'Providencia',
            zipCode: '7500000',
          },
          {
            name: 'Pudahuel',
            zipCode: '9020000',
          },
          {
            name: 'Puente Alto',
            zipCode: '8150000',
          },
          {
            name: 'Quilicura',
            zipCode: '8700000',
          },
          {
            name: 'Quinta Normal',
            zipCode: '8500000',
          },
          {
            name: 'Recoleta',
            zipCode: '8420000',
          },
          {
            name: 'Renca',
            zipCode: '8640000',
          },
          {
            name: 'San Bernardo',
            zipCode: '8050000',
          },
          {
            name: 'San Joaquin',
            zipCode: '8940000',
          },
          {
            name: 'San Jose de Maipo',
            zipCode: '9460000',
          },
          {
            name: 'San Miguel',
            zipCode: '8900000',
          },
          {
            name: 'San Pedro',
            zipCode: '9660000',
          },
          {
            name: 'San Ramon',
            zipCode: '8860000',
          },
          {
            keywords: ['Santiago'],
            name: 'Santiago de Chile',
            zipCode: '8320000',
          },
          {
            name: 'Talagante',
            zipCode: '9670000',
          },
          {
            name: 'Tiltil',
            zipCode: '9420000',
          },
          {
            name: 'Vitacura',
            zipCode: '7630000',
          },
          {
            name: 'Ñuñoa',
            zipCode: '7750000',
          },
        ],
        keywords: ['Región Metropolitana'],
        name: 'Metropolitana de Santiago',
      },
      {
        cities: [
          {
            name: 'Chepica',
            zipCode: '3120000',
          },
          {
            name: 'Chimbarongo',
            zipCode: '3090000',
          },
          {
            name: 'Codegua',
            zipCode: '2900000',
          },
          {
            name: 'Coinco',
            zipCode: '3010000',
          },
          {
            name: 'Coltauco',
            zipCode: '3000000',
          },
          {
            name: 'Donihue',
            zipCode: '3020000',
          },
          {
            name: 'Graneros',
            zipCode: '2880000',
          },
          {
            name: 'La Estrella',
            zipCode: '3250000',
          },
          {
            name: 'Las Cabras',
            zipCode: '3030000',
          },
          {
            name: 'Litueche',
            zipCode: '3240000',
          },
          {
            name: 'Lolol',
            zipCode: '3140000',
          },
          {
            name: 'Machali',
            zipCode: '2910000',
          },
          {
            name: 'Malloa',
            zipCode: '2950000',
          },
          {
            name: 'Marchihue',
            zipCode: '3260000',
          },
          {
            name: 'Mostazal',
            zipCode: '2890000',
          },
          {
            name: 'Nancagua',
            zipCode: '3110000',
          },
          {
            name: 'Navidad',
            zipCode: '3230000',
          },
          {
            name: 'Olivar',
            zipCode: '2920000',
          },
          {
            name: 'Palmilla',
            zipCode: '3160000',
          },
          {
            name: 'Paredones',
            zipCode: '3270000',
          },
          {
            name: 'Peralillo',
            zipCode: '3170000',
          },
          {
            name: 'Peumo',
            zipCode: '2990000',
          },
          {
            name: 'Pichidegua',
            zipCode: '2980000',
          },
          {
            name: 'Pichilemu',
            zipCode: '3220000',
          },
          {
            name: 'Placilla',
            zipCode: '3100000',
          },
          {
            name: 'Pumanque',
            zipCode: '3150000',
          },
          {
            name: 'Quinta De Tilcoco',
            zipCode: '2960000',
          },
          {
            name: 'Rancagua',
            zipCode: '2820000',
          },
          {
            name: 'Rengo',
            zipCode: '2940000',
          },
          {
            name: 'Requinoa',
            zipCode: '2930000',
          },
          {
            name: 'San Fernando',
            zipCode: '3070000',
          },
          {
            name: 'San Vicente',
            zipCode: '2970000',
          },
          {
            name: 'Santa Cruz',
            zipCode: '3130000',
          },
        ],
        name: 'OHiggins',
      },
      {
        cities: [
          {
            name: 'Alto Hospicio',
            zipCode: '1130000',
          },
          {
            name: 'Camina',
            zipCode: '1150000',
          },
          {
            name: 'Colchane',
            zipCode: '1160000',
          },
          {
            name: 'Huara',
            zipCode: '1140000',
          },
          {
            name: 'Iquique',
            zipCode: '1100000',
          },
          {
            name: 'Pica',
            zipCode: '1170000',
          },
          {
            name: 'Pozo Almonte',
            zipCode: '1180000',
          },
        ],
        name: 'Tarapaca',
      },
      {
        cities: [
          {
            name: 'Algarrobo',
            zipCode: '2710000',
          },
          {
            name: 'Cabildo',
            zipCode: '2050000',
          },
          {
            name: 'Calera',
            zipCode: '2290000',
          },
          {
            name: 'Calle Larga',
            zipCode: '2130000',
          },
          {
            name: 'Cartagena',
            zipCode: '2680000',
          },
          {
            name: 'Casablanca',
            zipCode: '2480000',
          },
          {
            name: 'Catemu',
            zipCode: '2230000',
          },
          {
            name: 'Concon',
            zipCode: '2510000',
          },
          {
            name: 'El Quisco',
            zipCode: '2700000',
          },
          {
            name: 'El Tabo',
            zipCode: '2690000',
          },
          {
            name: 'Hijuelas',
            zipCode: '2310000',
          },
          {
            name: 'Isla de Pascua',
            zipCode: '2770000',
          },
          {
            name: 'Juan Fernandez',
            zipCode: '2600000',
          },
          {
            name: 'La Cruz',
            zipCode: '2280000',
          },
          {
            name: 'La Ligua',
            zipCode: '2040000',
          },
          {
            name: 'Limache',
            zipCode: '2240000',
          },
          {
            name: 'Llaillay',
            zipCode: '2220000',
          },
          {
            name: 'Los Andes',
            zipCode: '2100000',
          },
          {
            name: 'Nogales',
            zipCode: '2300000',
          },
          {
            name: 'Olmue',
            zipCode: '2330000',
          },
          {
            name: 'Panquehue',
            zipCode: '2210000',
          },
          {
            name: 'Papudo',
            zipCode: '2070000',
          },
          {
            name: 'Petorca',
            zipCode: '2030000',
          },
          {
            name: 'Puchuncavi',
            zipCode: '2500000',
          },
          {
            name: 'Putaendo',
            zipCode: '2190000',
          },
          {
            name: 'Quillota',
            zipCode: '2260000',
          },
          {
            name: 'Quilpue',
            zipCode: '2430000',
          },
          {
            name: 'Quintero',
            zipCode: '2490000',
          },
          {
            name: 'Rinconada',
            zipCode: '2490000',
          },
          {
            name: 'San Antonio',
            zipCode: '2140000',
          },
          {
            name: 'San Esteban',
            zipCode: '2660000',
          },
          {
            name: 'San Felipe',
            zipCode: '2120000',
          },
          {
            name: 'Santa Maria',
            zipCode: '2170000',
          },
          {
            name: 'Santo Domingo',
            zipCode: '2200000',
          },
          {
            name: 'Valparaiso',
            zipCode: '2720000',
          },
          {
            name: 'Villa Alemana',
            zipCode: '2340000',
          },
          {
            name: 'Viña del Mar',
            zipCode: '6500000',
          },
          {
            name: 'Zapallar',
            zipCode: '2520000',
          },
        ],
        name: 'Valparaiso',
      },
      {
        cities: [
          {
            name: 'Bulnes',
            zipCode: '3930000',
          },
          {
            keywords: ['Chillán', 'Las Mariposas'],
            name: 'Chillan',
            zipCode: '3780000',
          },
          {
            keywords: ['Chillán Viejo'],
            name: 'Chillan Viejo',
            zipCode: '3820000',
          },
          {
            name: 'Cobquecura',
            zipCode: '3990000',
          },
          {
            name: 'Coelemu',
            zipCode: '3970000',
          },
          {
            name: 'Coihueco',
            zipCode: '3870000',
          },
          {
            name: 'El Carmen',
            zipCode: '3900000',
          },
          {
            name: 'Ninhue',
            zipCode: '4010000',
          },
          {
            name: 'Pemuco',
            zipCode: '3910000',
          },
          {
            name: 'Pemuco',
            zipCode: '4920000',
          },
          {
            name: 'Pinto',
            zipCode: '3880000',
          },
          {
            name: 'Portezuelo',
            zipCode: '3960000',
          },
          {
            name: 'Quillon',
            zipCode: '3940000',
          },
          {
            name: 'Quirihue',
            zipCode: '4000000',
          },
          {
            name: 'Ranquil',
            zipCode: '3950000',
          },
          {
            name: 'San Carlos',
            zipCode: '3840000',
          },
          {
            name: 'San Fabian',
            zipCode: '3860000',
          },
          {
            name: 'San Ignacio',
            zipCode: '3890000',
          },
          {
            name: 'San Nicolas',
            zipCode: '4020000',
          },
          {
            name: 'Treguaco',
            zipCode: '3980000',
          },
          {
            name: 'Yungay',
            zipCode: '3920000',
          },
        ],
        name: 'Ñuble',
      },
    ],
  },
  {
    code: 'CN',
    name: 'China',
    numberFormat: {
      code: 'zh-CN',
      currency: 'CNY',
    },
    phone: '86',
  },
  {
    code: 'CX',
    name: 'Christmas Island',
    phone: '61',
  },
  {
    code: 'CC',
    name: 'Cocos (Keeling) Islands',
    phone: '61',
  },
  {
    code: 'CO',
    name: 'Colombia',
    numberFormat: {
      code: 'es-CO',
      currency: 'COP',
    },
    phone: '57',
    states: [
      {
        cities: [
          {
            name: 'El Encanto',
            zipCode: '91263',
          },
          {
            name: 'La Chorrera',
            zipCode: '91405',
          },
          {
            name: 'La Pedrera',
            zipCode: '91407',
          },
          {
            name: 'La Victoria',
            zipCode: '91430',
          },
          {
            name: 'Leticia',
            zipCode: '91001',
          },
          {
            name: 'Miriti - Parana',
            zipCode: '91460',
          },
          {
            name: 'Puerto Alegria',
            zipCode: '91530',
          },
          {
            name: 'Puerto Arica',
            zipCode: '91536',
          },
          {
            name: 'Puerto Nariño',
            zipCode: '91540',
          },
          {
            name: 'Puerto Santander',
            zipCode: '91669',
          },
          {
            name: 'Tarapaca',
            zipCode: '91798',
          },
        ],
        name: 'Amazonas',
      },
      {
        cities: [
          {
            name: 'Abejorral',
            zipCode: '5002',
          },
          {
            name: 'Abriaqui',
            zipCode: '5004',
          },
          {
            name: 'Alejandria',
            zipCode: '5021',
          },
          {
            name: 'Amaga',
            zipCode: '5030',
          },
          {
            name: 'Amalfi',
            zipCode: '5031',
          },
          {
            name: 'Andes',
            zipCode: '5034',
          },
          {
            name: 'Angelopolis',
            zipCode: '5036',
          },
          {
            name: 'Angostura',
            zipCode: '5038',
          },
          {
            name: 'Anori',
            zipCode: '5040',
          },
          {
            name: 'Anza',
            zipCode: '5044',
          },
          {
            name: 'Apartado',
            zipCode: '5045',
          },
          {
            name: 'Arboletes',
            zipCode: '5051',
          },
          {
            name: 'Argelia',
            zipCode: '5055',
          },
          {
            name: 'Armenia',
            zipCode: '5059',
          },
          {
            name: 'Barbosa',
            zipCode: '5079',
          },
          {
            name: 'Bello',
            zipCode: '5088',
          },
          {
            name: 'Belmira',
            zipCode: '5086',
          },
          {
            name: 'Betania',
            zipCode: '5091',
          },
          {
            name: 'Betulia',
            zipCode: '5093',
          },
          {
            name: 'Briceño',
            zipCode: '5107',
          },
          {
            name: 'Buritica',
            zipCode: '5113',
          },
          {
            name: 'Caceres',
            zipCode: '5120',
          },
          {
            name: 'Caicedo',
            zipCode: '5125',
          },
          {
            name: 'Caldas',
            zipCode: '5129',
          },
          {
            name: 'Campamento',
            zipCode: '5134',
          },
          {
            name: 'Caracoli',
            zipCode: '5142',
          },
          {
            name: 'Caramanta',
            zipCode: '5145',
          },
          {
            name: 'Carepa',
            zipCode: '5147',
          },
          {
            name: 'Carolina',
            zipCode: '5150',
          },
          {
            name: 'Caucasia',
            zipCode: '5154',
          },
          {
            name: 'Cañasgordas',
            zipCode: '5138',
          },
          {
            name: 'Chigorodo',
            zipCode: '5172',
          },
          {
            name: 'Cisneros',
            zipCode: '5190',
          },
          {
            name: 'Ciudad Bolivar',
            zipCode: '5101',
          },
          {
            name: 'Cocorna',
            zipCode: '5197',
          },
          {
            name: 'Concepcion',
            zipCode: '5206',
          },
          {
            name: 'Concordia',
            zipCode: '5209',
          },
          {
            name: 'Copacabana',
            zipCode: '5212',
          },
          {
            name: 'Dabeiba',
            zipCode: '5234',
          },
          {
            name: 'Donmatias',
            zipCode: '5237',
          },
          {
            name: 'Ebejico',
            zipCode: '5240',
          },
          {
            name: 'El Bagre',
            zipCode: '5250',
          },
          {
            name: 'El Carmen De Viboral',
            zipCode: '5148',
          },
          {
            name: 'El Santuario',
            zipCode: '5697',
          },
          {
            name: 'Entrerrios',
            zipCode: '5264',
          },
          {
            name: 'Envigado',
            zipCode: '5266',
          },
          {
            name: 'Fredonia',
            zipCode: '5282',
          },
          {
            name: 'Frontino',
            zipCode: '5284',
          },
          {
            name: 'Giraldo',
            zipCode: '5306',
          },
          {
            name: 'Girardota',
            zipCode: '5308',
          },
          {
            name: 'Gomez Plata',
            zipCode: '5310',
          },
          {
            name: 'Granada',
            zipCode: '5313',
          },
          {
            name: 'Guadalupe',
            zipCode: '5315',
          },
          {
            name: 'Guarne',
            zipCode: '5318',
          },
          {
            name: 'Guatape',
            zipCode: '5321',
          },
          {
            name: 'Heliconia',
            zipCode: '5347',
          },
          {
            name: 'Hispania',
            zipCode: '5353',
          },
          {
            name: 'Itagui',
            zipCode: '5360',
          },
          {
            name: 'Ituango',
            zipCode: '5361',
          },
          {
            name: 'Jardin',
            zipCode: '5364',
          },
          {
            name: 'Jerico',
            zipCode: '5368',
          },
          {
            name: 'La Ceja',
            zipCode: '5376',
          },
          {
            name: 'La Estrella',
            zipCode: '5380',
          },
          {
            name: 'La Pintada',
            zipCode: '5390',
          },
          {
            name: 'La Union',
            zipCode: '5400',
          },
          {
            name: 'Liborina',
            zipCode: '5411',
          },
          {
            name: 'Maceo',
            zipCode: '5425',
          },
          {
            name: 'Marinilla',
            zipCode: '5440',
          },
          {
            name: 'Medellin',
            zipCode: '5001',
          },
          {
            name: 'Montebello',
            zipCode: '5467',
          },
          {
            name: 'Murindo',
            zipCode: '5475',
          },
          {
            name: 'Mutata',
            zipCode: '5480',
          },
          {
            name: 'Nariño',
            zipCode: '5483',
          },
          {
            name: 'Nechi',
            zipCode: '5495',
          },
          {
            name: 'Necocli',
            zipCode: '5490',
          },
          {
            name: 'Olaya',
            zipCode: '5501',
          },
          {
            name: 'Peque',
            zipCode: '5543',
          },
          {
            name: 'Peñol',
            zipCode: '5541',
          },
          {
            name: 'Pueblorrico',
            zipCode: '5576',
          },
          {
            name: 'Puerto Berrio',
            zipCode: '5579',
          },
          {
            name: 'Puerto Nare',
            zipCode: '5585',
          },
          {
            name: 'Puerto Triunfo',
            zipCode: '5591',
          },
          {
            name: 'Remedios',
            zipCode: '5604',
          },
          {
            name: 'Retiro',
            zipCode: '5607',
          },
          {
            name: 'Rionegro',
            zipCode: '5615',
          },
          {
            name: 'Sabanalarga',
            zipCode: '5628',
          },
          {
            name: 'Sabaneta',
            zipCode: '5631',
          },
          {
            name: 'Salgar',
            zipCode: '5642',
          },
          {
            name: 'San Andres De Cuerquia',
            zipCode: '5647',
          },
          {
            name: 'San Carlos',
            zipCode: '5649',
          },
          {
            name: 'San Francisco',
            zipCode: '5652',
          },
          {
            name: 'San Jeronimo',
            zipCode: '5656',
          },
          {
            name: 'San Jose De La Montaña',
            zipCode: '5658',
          },
          {
            name: 'San Juan De Uraba',
            zipCode: '5659',
          },
          {
            name: 'San Luis',
            zipCode: '5660',
          },
          {
            name: 'San Pedro De Los Milagros',
            zipCode: '5664',
          },
          {
            name: 'San Pedro De Uraba',
            zipCode: '5665',
          },
          {
            name: 'San Rafael',
            zipCode: '5667',
          },
          {
            name: 'San Roque',
            zipCode: '5670',
          },
          {
            name: 'San Vicente',
            zipCode: '5674',
          },
          {
            name: 'Santa Barbara',
            zipCode: '5679',
          },
          {
            name: 'Santa Rosa De Osos',
            zipCode: '5686',
          },
          {
            name: 'Santafe De Antioquia',
            zipCode: '5042',
          },
          {
            name: 'Santo Domingo',
            zipCode: '5690',
          },
          {
            name: 'Segovia',
            zipCode: '5736',
          },
          {
            name: 'Sonson',
            zipCode: '5756',
          },
          {
            name: 'Sopetran',
            zipCode: '5761',
          },
          {
            name: 'Tamesis',
            zipCode: '5789',
          },
          {
            name: 'Taraza',
            zipCode: '5790',
          },
          {
            name: 'Tarso',
            zipCode: '5792',
          },
          {
            name: 'Titiribi',
            zipCode: '5809',
          },
          {
            name: 'Toledo',
            zipCode: '5819',
          },
          {
            name: 'Turbo',
            zipCode: '5837',
          },
          {
            name: 'Uramita',
            zipCode: '5842',
          },
          {
            name: 'Urrao',
            zipCode: '5847',
          },
          {
            name: 'Valdivia',
            zipCode: '5854',
          },
          {
            name: 'Valparaiso',
            zipCode: '5856',
          },
          {
            name: 'Vegachi',
            zipCode: '5858',
          },
          {
            name: 'Venecia',
            zipCode: '5861',
          },
          {
            name: 'Vigia Del Fuerte',
            zipCode: '5873',
          },
          {
            name: 'Yali',
            zipCode: '5885',
          },
          {
            name: 'Yarumal',
            zipCode: '5887',
          },
          {
            name: 'Yolombo',
            zipCode: '5890',
          },
          {
            name: 'Yondo',
            zipCode: '5893',
          },
          {
            name: 'Zaragoza',
            zipCode: '5895',
          },
        ],
        name: 'Antioquia',
      },
      {
        cities: [
          {
            name: 'Arauca',
            zipCode: '81001',
          },
          {
            name: 'Arauquita',
            zipCode: '81065',
          },
          {
            name: 'Cravo Norte',
            zipCode: '81220',
          },
          {
            name: 'Fortul',
            zipCode: '81300',
          },
          {
            name: 'Puerto Rondon',
            zipCode: '81591',
          },
          {
            name: 'Saravena',
            zipCode: '81736',
          },
          {
            name: 'Tame',
            zipCode: '81794',
          },
        ],
        name: 'Arauca',
      },
      {
        cities: [
          {
            name: 'Baranoa',
            zipCode: '8078',
          },
          {
            name: 'Barranquilla',
            zipCode: '8001',
          },
          {
            name: 'Campo De La Cruz',
            zipCode: '8137',
          },
          {
            name: 'Candelaria',
            zipCode: '8141',
          },
          {
            name: 'Galapa',
            zipCode: '8296',
          },
          {
            name: 'Juan De Acosta',
            zipCode: '8372',
          },
          {
            name: 'Luruaco',
            zipCode: '8421',
          },
          {
            name: 'Malambo',
            zipCode: '8433',
          },
          {
            name: 'Manati',
            zipCode: '8436',
          },
          {
            name: 'Palmar De Varela',
            zipCode: '8520',
          },
          {
            name: 'Piojo',
            zipCode: '8549',
          },
          {
            name: 'Polonuevo',
            zipCode: '8558',
          },
          {
            name: 'Ponedera',
            zipCode: '8560',
          },
          {
            name: 'Puerto Colombia',
            zipCode: '8573',
          },
          {
            name: 'Repelon',
            zipCode: '8606',
          },
          {
            name: 'Sabanagrande',
            zipCode: '8634',
          },
          {
            name: 'Sabanalarga',
            zipCode: '8638',
          },
          {
            name: 'Santa Lucia',
            zipCode: '8675',
          },
          {
            name: 'Santo Tomas',
            zipCode: '8685',
          },
          {
            name: 'Soledad',
            zipCode: '8758',
          },
          {
            name: 'Suan',
            zipCode: '8770',
          },
          {
            name: 'Tubara',
            zipCode: '8832',
          },
          {
            name: 'Usiacuri',
            zipCode: '8849',
          },
        ],
        name: 'Atlantico',
      },
      {
        cities: [
          {
            name: 'Bogota',
            zipCode: '11001',
          },
        ],
        name: 'Bogota',
      },
      {
        cities: [
          {
            name: 'Achi',
            zipCode: '13006',
          },
          {
            name: 'Altos Del Rosario',
            zipCode: '13030',
          },
          {
            name: 'Arenal',
            zipCode: '13042',
          },
          {
            name: 'Arjona',
            zipCode: '13052',
          },
          {
            name: 'Arroyohondo',
            zipCode: '13062',
          },
          {
            name: 'Barranco De Loba',
            zipCode: '13074',
          },
          {
            name: 'Calamar',
            zipCode: '13140',
          },
          {
            name: 'Cantagallo',
            zipCode: '13160',
          },
          {
            name: 'Cartagena',
            zipCode: '13001',
          },
          {
            name: 'Cicuco',
            zipCode: '13188',
          },
          {
            name: 'Clemencia',
            zipCode: '13222',
          },
          {
            name: 'Cordoba',
            zipCode: '13212',
          },
          {
            name: 'El Carmen De Bolivar',
            zipCode: '13244',
          },
          {
            name: 'El Guamo',
            zipCode: '13248',
          },
          {
            name: 'El Peñon',
            zipCode: '13268',
          },
          {
            name: 'Hatillo De Loba',
            zipCode: '13300',
          },
          {
            name: 'Magangue',
            zipCode: '13430',
          },
          {
            name: 'Mahates',
            zipCode: '13433',
          },
          {
            name: 'Margarita',
            zipCode: '13440',
          },
          {
            name: 'Maria La Baja',
            zipCode: '13442',
          },
          {
            name: 'Mompos',
            zipCode: '13468',
          },
          {
            name: 'Montecristo',
            zipCode: '13458',
          },
          {
            name: 'Morales',
            zipCode: '13473',
          },
          {
            name: 'Norosi',
            zipCode: '13490',
          },
          {
            name: 'Pinillos',
            zipCode: '13549',
          },
          {
            name: 'Regidor',
            zipCode: '13580',
          },
          {
            name: 'Rio Viejo',
            zipCode: '13600',
          },
          {
            name: 'San Cristobal',
            zipCode: '13620',
          },
          {
            name: 'San Estanislao',
            zipCode: '13647',
          },
          {
            name: 'San Fernando',
            zipCode: '13650',
          },
          {
            name: 'San Jacinto',
            zipCode: '13654',
          },
          {
            name: 'San Jacinto Del Cauca',
            zipCode: '13655',
          },
          {
            name: 'San Juan Nepomuceno',
            zipCode: '13657',
          },
          {
            name: 'San Martin De Loba',
            zipCode: '13667',
          },
          {
            name: 'San Pablo',
            zipCode: '13670',
          },
          {
            name: 'Santa Catalina',
            zipCode: '13673',
          },
          {
            name: 'Santa Rosa',
            zipCode: '13683',
          },
          {
            name: 'Santa Rosa Del Sur',
            zipCode: '13688',
          },
          {
            name: 'Simiti',
            zipCode: '13744',
          },
          {
            name: 'Soplaviento',
            zipCode: '13760',
          },
          {
            name: 'Talaigua Nuevo',
            zipCode: '13780',
          },
          {
            name: 'Tiquisio',
            zipCode: '13810',
          },
          {
            name: 'Turbaco',
            zipCode: '13836',
          },
          {
            name: 'Turbana',
            zipCode: '13838',
          },
          {
            name: 'Villanueva',
            zipCode: '13873',
          },
          {
            name: 'Zambrano',
            zipCode: '13894',
          },
        ],
        name: 'Bolivar',
      },
      {
        cities: [
          {
            name: 'Almeida',
            zipCode: '15022',
          },
          {
            name: 'Aquitania',
            zipCode: '15047',
          },
          {
            name: 'Arcabuco',
            zipCode: '15051',
          },
          {
            name: 'Belen',
            zipCode: '15087',
          },
          {
            name: 'Berbeo',
            zipCode: '15090',
          },
          {
            name: 'Beteitiva',
            zipCode: '15092',
          },
          {
            name: 'Boavita',
            zipCode: '15097',
          },
          {
            name: 'Boyaca',
            zipCode: '15104',
          },
          {
            name: 'Briceño',
            zipCode: '15106',
          },
          {
            name: 'Buenavista',
            zipCode: '15109',
          },
          {
            name: 'Busbanza',
            zipCode: '15114',
          },
          {
            name: 'Caldas',
            zipCode: '15131',
          },
          {
            name: 'Campohermoso',
            zipCode: '15135',
          },
          {
            name: 'Cerinza',
            zipCode: '15162',
          },
          {
            name: 'Chinavita',
            zipCode: '15172',
          },
          {
            name: 'Chiquinquira',
            zipCode: '15176',
          },
          {
            name: 'Chiquiza',
            zipCode: '15232',
          },
          {
            name: 'Chiscas',
            zipCode: '15180',
          },
          {
            name: 'Chita',
            zipCode: '15183',
          },
          {
            name: 'Chitaraque',
            zipCode: '15185',
          },
          {
            name: 'Chivata',
            zipCode: '15187',
          },
          {
            name: 'Chivor',
            zipCode: '15236',
          },
          {
            name: 'Cienega',
            zipCode: '15189',
          },
          {
            name: 'Combita',
            zipCode: '15204',
          },
          {
            name: 'Coper',
            zipCode: '15212',
          },
          {
            name: 'Corrales',
            zipCode: '15215',
          },
          {
            name: 'Covarachia',
            zipCode: '15218',
          },
          {
            name: 'Cubara',
            zipCode: '15223',
          },
          {
            name: 'Cucaita',
            zipCode: '15224',
          },
          {
            name: 'Cuitiva',
            zipCode: '15226',
          },
          {
            name: 'Duitama',
            zipCode: '15238',
          },
          {
            name: 'El Cocuy',
            zipCode: '15244',
          },
          {
            name: 'El Espino',
            zipCode: '15248',
          },
          {
            name: 'Firavitoba',
            zipCode: '15272',
          },
          {
            name: 'Floresta',
            zipCode: '15276',
          },
          {
            name: 'Gachantiva',
            zipCode: '15293',
          },
          {
            name: 'Gameza',
            zipCode: '15296',
          },
          {
            name: 'Garagoa',
            zipCode: '15299',
          },
          {
            name: 'Guacamayas',
            zipCode: '15317',
          },
          {
            name: 'Guateque',
            zipCode: '15322',
          },
          {
            name: 'Guayata',
            zipCode: '15325',
          },
          {
            name: 'Güican',
            zipCode: '15332',
          },
          {
            name: 'Iza',
            zipCode: '15362',
          },
          {
            name: 'Jenesano',
            zipCode: '15367',
          },
          {
            name: 'Jerico',
            zipCode: '15368',
          },
          {
            name: 'La Capilla',
            zipCode: '15380',
          },
          {
            name: 'La Uvita',
            zipCode: '15403',
          },
          {
            name: 'La Victoria',
            zipCode: '15401',
          },
          {
            name: 'Labranzagrande',
            zipCode: '15377',
          },
          {
            name: 'Macanal',
            zipCode: '15425',
          },
          {
            name: 'Maripi',
            zipCode: '15442',
          },
          {
            name: 'Miraflores',
            zipCode: '15455',
          },
          {
            name: 'Mongua',
            zipCode: '15464',
          },
          {
            name: 'Mongui',
            zipCode: '15466',
          },
          {
            name: 'Moniquira',
            zipCode: '15469',
          },
          {
            name: 'Motavita',
            zipCode: '15476',
          },
          {
            name: 'Muzo',
            zipCode: '15480',
          },
          {
            name: 'Nobsa',
            zipCode: '15491',
          },
          {
            name: 'Nuevo Colon',
            zipCode: '15494',
          },
          {
            name: 'Oicata',
            zipCode: '15500',
          },
          {
            name: 'Otanche',
            zipCode: '15507',
          },
          {
            name: 'Pachavita',
            zipCode: '15511',
          },
          {
            name: 'Paez',
            zipCode: '15514',
          },
          {
            name: 'Paipa',
            zipCode: '15516',
          },
          {
            name: 'Pajarito',
            zipCode: '15518',
          },
          {
            name: 'Panqueba',
            zipCode: '15522',
          },
          {
            name: 'Pauna',
            zipCode: '15531',
          },
          {
            name: 'Paya',
            zipCode: '15533',
          },
          {
            name: 'Paz De Rio',
            zipCode: '15537',
          },
          {
            name: 'Pesca',
            zipCode: '15542',
          },
          {
            name: 'Pisba',
            zipCode: '15550',
          },
          {
            name: 'Puerto Boyaca',
            zipCode: '15572',
          },
          {
            name: 'Quipama',
            zipCode: '15580',
          },
          {
            name: 'Ramiriqui',
            zipCode: '15599',
          },
          {
            name: 'Raquira',
            zipCode: '15600',
          },
          {
            name: 'Rondon',
            zipCode: '15621',
          },
          {
            name: 'Saboya',
            zipCode: '15632',
          },
          {
            name: 'Sachica',
            zipCode: '15638',
          },
          {
            name: 'Samaca',
            zipCode: '15646',
          },
          {
            name: 'San Eduardo',
            zipCode: '15660',
          },
          {
            name: 'San Jose De Pare',
            zipCode: '15664',
          },
          {
            name: 'San Luis De Gaceno',
            zipCode: '15667',
          },
          {
            name: 'San Mateo',
            zipCode: '15673',
          },
          {
            name: 'San Miguel De Sema',
            zipCode: '15676',
          },
          {
            name: 'San Pablo De Borbur',
            zipCode: '15681',
          },
          {
            name: 'Santa Maria',
            zipCode: '15690',
          },
          {
            name: 'Santa Rosa De Viterbo',
            zipCode: '15693',
          },
          {
            name: 'Santa Sofia',
            zipCode: '15696',
          },
          {
            name: 'Santana',
            zipCode: '15686',
          },
          {
            name: 'Sativanorte',
            zipCode: '15720',
          },
          {
            name: 'Sativasur',
            zipCode: '15723',
          },
          {
            name: 'Siachoque',
            zipCode: '15740',
          },
          {
            name: 'Soata',
            zipCode: '15753',
          },
          {
            name: 'Socha',
            zipCode: '15757',
          },
          {
            name: 'Socota',
            zipCode: '15755',
          },
          {
            name: 'Sogamoso',
            zipCode: '15759',
          },
          {
            name: 'Somondoco',
            zipCode: '15761',
          },
          {
            name: 'Sora',
            zipCode: '15762',
          },
          {
            name: 'Soraca',
            zipCode: '15764',
          },
          {
            name: 'Sotaquira',
            zipCode: '15763',
          },
          {
            name: 'Susacon',
            zipCode: '15774',
          },
          {
            name: 'Sutamarchan',
            zipCode: '15776',
          },
          {
            name: 'Sutatenza',
            zipCode: '15778',
          },
          {
            name: 'Tasco',
            zipCode: '15790',
          },
          {
            name: 'Tenza',
            zipCode: '15798',
          },
          {
            name: 'Tibana',
            zipCode: '15804',
          },
          {
            name: 'Tibasosa',
            zipCode: '15806',
          },
          {
            name: 'Tinjaca',
            zipCode: '15808',
          },
          {
            name: 'Tipacoque',
            zipCode: '15810',
          },
          {
            name: 'Toca',
            zipCode: '15814',
          },
          {
            name: 'Togüi',
            zipCode: '15816',
          },
          {
            name: 'Topaga',
            zipCode: '15820',
          },
          {
            name: 'Tota',
            zipCode: '15822',
          },
          {
            name: 'Tunja',
            zipCode: '15001',
          },
          {
            name: 'Tunungua',
            zipCode: '15832',
          },
          {
            name: 'Turmeque',
            zipCode: '15835',
          },
          {
            name: 'Tuta',
            zipCode: '15837',
          },
          {
            name: 'Tutaza',
            zipCode: '15839',
          },
          {
            name: 'Umbita',
            zipCode: '15842',
          },
          {
            name: 'Ventaquemada',
            zipCode: '15861',
          },
          {
            name: 'Villa De Leyva',
            zipCode: '15407',
          },
          {
            name: 'Viracacha',
            zipCode: '15879',
          },
          {
            name: 'Zetaquira',
            zipCode: '15897',
          },
        ],
        name: 'Boyaca',
      },
      {
        cities: [
          {
            name: 'Aguadas',
            zipCode: '17013',
          },
          {
            name: 'Anserma',
            zipCode: '17042',
          },
          {
            name: 'Aranzazu',
            zipCode: '17050',
          },
          {
            name: 'Belalcazar',
            zipCode: '17088',
          },
          {
            name: 'Chinchina',
            zipCode: '17174',
          },
          {
            name: 'Filadelfia',
            zipCode: '17272',
          },
          {
            name: 'La Dorada',
            zipCode: '17380',
          },
          {
            name: 'La Merced',
            zipCode: '17388',
          },
          {
            name: 'Manizales',
            zipCode: '17001',
          },
          {
            name: 'Manzanares',
            zipCode: '17433',
          },
          {
            name: 'Marmato',
            zipCode: '17442',
          },
          {
            name: 'Marquetalia',
            zipCode: '17444',
          },
          {
            name: 'Marulanda',
            zipCode: '17446',
          },
          {
            name: 'Neira',
            zipCode: '17486',
          },
          {
            name: 'Norcasia',
            zipCode: '17495',
          },
          {
            name: 'Pacora',
            zipCode: '17513',
          },
          {
            name: 'Palestina',
            zipCode: '17524',
          },
          {
            name: 'Pensilvania',
            zipCode: '17541',
          },
          {
            name: 'Riosucio',
            zipCode: '17614',
          },
          {
            name: 'Risaralda',
            zipCode: '17616',
          },
          {
            name: 'Salamina',
            zipCode: '17653',
          },
          {
            name: 'Samana',
            zipCode: '17662',
          },
          {
            name: 'San Jose',
            zipCode: '17665',
          },
          {
            name: 'Supia',
            zipCode: '17777',
          },
          {
            name: 'Victoria',
            zipCode: '17867',
          },
          {
            name: 'Villamaria',
            zipCode: '17873',
          },
          {
            name: 'Viterbo',
            zipCode: '17877',
          },
        ],
        name: 'Caldas',
      },
      {
        cities: [
          {
            name: 'Albania',
            zipCode: '18029',
          },
          {
            name: 'Belen De Los Andaquies',
            zipCode: '18094',
          },
          {
            name: 'Cartagena Del Chaira',
            zipCode: '18150',
          },
          {
            name: 'Curillo',
            zipCode: '18205',
          },
          {
            name: 'El Doncello',
            zipCode: '18247',
          },
          {
            name: 'El Paujil',
            zipCode: '18256',
          },
          {
            name: 'Florencia',
            zipCode: '18001',
          },
          {
            name: 'La Montañita',
            zipCode: '18410',
          },
          {
            name: 'Milan',
            zipCode: '18460',
          },
          {
            name: 'Morelia',
            zipCode: '18479',
          },
          {
            name: 'Puerto Rico',
            zipCode: '18592',
          },
          {
            name: 'San Jose Del Fragua',
            zipCode: '18610',
          },
          {
            name: 'San Vicente Del Caguan',
            zipCode: '18753',
          },
          {
            name: 'Solano',
            zipCode: '18756',
          },
          {
            name: 'Solita',
            zipCode: '18785',
          },
          {
            name: 'Valparaiso',
            zipCode: '18860',
          },
        ],
        name: 'Caqueta',
      },
      {
        cities: [
          {
            name: 'Aguazul',
            zipCode: '85010',
          },
          {
            name: 'Chameza',
            zipCode: '85015',
          },
          {
            name: 'Hato Corozal',
            zipCode: '85125',
          },
          {
            name: 'La Salina',
            zipCode: '85136',
          },
          {
            name: 'Mani',
            zipCode: '85139',
          },
          {
            name: 'Monterrey',
            zipCode: '85162',
          },
          {
            name: 'Nunchia',
            zipCode: '85225',
          },
          {
            name: 'Orocue',
            zipCode: '85230',
          },
          {
            name: 'Paz De Ariporo',
            zipCode: '85250',
          },
          {
            name: 'Pore',
            zipCode: '85263',
          },
          {
            name: 'Recetor',
            zipCode: '85279',
          },
          {
            name: 'Sabanalarga',
            zipCode: '85300',
          },
          {
            name: 'Sacama',
            zipCode: '85315',
          },
          {
            name: 'San Luis De Palenque',
            zipCode: '85325',
          },
          {
            name: 'Tamara',
            zipCode: '85400',
          },
          {
            name: 'Tauramena',
            zipCode: '85410',
          },
          {
            name: 'Trinidad',
            zipCode: '85430',
          },
          {
            name: 'Villanueva',
            zipCode: '85440',
          },
          {
            name: 'Yopal',
            zipCode: '85001',
          },
        ],
        name: 'Casanare',
      },
      {
        cities: [
          {
            name: 'Almaguer',
            zipCode: '19022',
          },
          {
            name: 'Argelia',
            zipCode: '19050',
          },
          {
            name: 'Balboa',
            zipCode: '19075',
          },
          {
            name: 'Bolivar',
            zipCode: '19100',
          },
          {
            name: 'Buenos Aires',
            zipCode: '19110',
          },
          {
            name: 'Cajibio',
            zipCode: '19130',
          },
          {
            name: 'Caldono',
            zipCode: '19137',
          },
          {
            name: 'Caloto',
            zipCode: '19142',
          },
          {
            name: 'Corinto',
            zipCode: '19212',
          },
          {
            name: 'El Tambo',
            zipCode: '19256',
          },
          {
            name: 'Florencia',
            zipCode: '19290',
          },
          {
            name: 'Guachene',
            zipCode: '19300',
          },
          {
            name: 'Guapi',
            zipCode: '19318',
          },
          {
            name: 'Inza',
            zipCode: '19355',
          },
          {
            name: 'Jambalo',
            zipCode: '19364',
          },
          {
            name: 'La Sierra',
            zipCode: '19392',
          },
          {
            name: 'La Vega',
            zipCode: '19397',
          },
          {
            name: 'Lopez',
            zipCode: '19418',
          },
          {
            name: 'Mercaderes',
            zipCode: '19450',
          },
          {
            name: 'Miranda',
            zipCode: '19455',
          },
          {
            name: 'Morales',
            zipCode: '19473',
          },
          {
            name: 'Padilla',
            zipCode: '19513',
          },
          {
            name: 'Paez',
            zipCode: '19517',
          },
          {
            name: 'Patia',
            zipCode: '19532',
          },
          {
            name: 'Piamonte',
            zipCode: '19533',
          },
          {
            name: 'Piendamo',
            zipCode: '19548',
          },
          {
            name: 'Popayan',
            zipCode: '19001',
          },
          {
            name: 'Puerto Tejada',
            zipCode: '19573',
          },
          {
            name: 'Purace',
            zipCode: '19585',
          },
          {
            name: 'Rosas',
            zipCode: '19622',
          },
          {
            name: 'San Sebastian',
            zipCode: '19693',
          },
          {
            name: 'Santa Rosa',
            zipCode: '19701',
          },
          {
            name: 'Santander De Quilichao',
            zipCode: '19698',
          },
          {
            name: 'Silvia',
            zipCode: '19743',
          },
          {
            name: 'Sotara',
            zipCode: '19760',
          },
          {
            name: 'Suarez',
            zipCode: '19780',
          },
          {
            name: 'Sucre',
            zipCode: '19785',
          },
          {
            name: 'Timbio',
            zipCode: '19807',
          },
          {
            name: 'Timbiqui',
            zipCode: '19809',
          },
          {
            name: 'Toribio',
            zipCode: '19821',
          },
          {
            name: 'Totoro',
            zipCode: '19824',
          },
          {
            name: 'Villa Rica',
            zipCode: '19845',
          },
        ],
        name: 'Cauca',
      },
      {
        cities: [
          {
            name: 'Aguachica',
            zipCode: '20011',
          },
          {
            name: 'Agustin Codazzi',
            zipCode: '20013',
          },
          {
            name: 'Astrea',
            zipCode: '20032',
          },
          {
            name: 'Becerril',
            zipCode: '20045',
          },
          {
            name: 'Bosconia',
            zipCode: '20060',
          },
          {
            name: 'Chimichagua',
            zipCode: '20175',
          },
          {
            name: 'Chiriguana',
            zipCode: '20178',
          },
          {
            name: 'Curumani',
            zipCode: '20228',
          },
          {
            name: 'El Copey',
            zipCode: '20238',
          },
          {
            name: 'El Paso',
            zipCode: '20250',
          },
          {
            name: 'Gamarra',
            zipCode: '20295',
          },
          {
            name: 'Gonzalez',
            zipCode: '20310',
          },
          {
            name: 'La Gloria',
            zipCode: '20383',
          },
          {
            name: 'La Jagua De Ibirico',
            zipCode: '20400',
          },
          {
            name: 'Manaure',
            zipCode: '20443',
          },
          {
            name: 'Pailitas',
            zipCode: '20517',
          },
          {
            name: 'Pelaya',
            zipCode: '20550',
          },
          {
            name: 'Pueblo Bello',
            zipCode: '20570',
          },
          {
            name: 'Rio De Oro',
            zipCode: '20614',
          },
          {
            name: 'San Alberto',
            zipCode: '20621',
          },
          {
            name: 'San Diego',
            zipCode: '20710',
          },
          {
            name: 'San Martin',
            zipCode: '20750',
          },
          {
            name: 'Tamalameque',
            zipCode: '20770',
          },
          {
            name: 'Valencia',
            zipCode: '20787',
          },
          {
            name: 'Valledupar',
            zipCode: '20001',
          },
        ],
        name: 'Cesar',
      },
      {
        cities: [
          {
            name: 'Acandi',
            zipCode: '27006',
          },
          {
            name: 'Alto Baudo',
            zipCode: '27025',
          },
          {
            name: 'Atrato',
            zipCode: '27050',
          },
          {
            name: 'Bagado',
            zipCode: '27073',
          },
          {
            name: 'Bahia Solano',
            zipCode: '27075',
          },
          {
            name: 'Bajo Baudo',
            zipCode: '27077',
          },
          {
            name: 'Bojaya',
            zipCode: '27099',
          },
          {
            name: 'Carmen Del Darien',
            zipCode: '27150',
          },
          {
            name: 'Certegui',
            zipCode: '27160',
          },
          {
            name: 'Condoto',
            zipCode: '27205',
          },
          {
            name: 'El Canton Del San Pablo',
            zipCode: '27135',
          },
          {
            name: 'El Carmen De Atrato',
            zipCode: '27245',
          },
          {
            name: 'El Litoral Del San Juan',
            zipCode: '27250',
          },
          {
            name: 'Istmina',
            zipCode: '27361',
          },
          {
            name: 'Jurado',
            zipCode: '27372',
          },
          {
            name: 'Lloro',
            zipCode: '27413',
          },
          {
            name: 'Medio Atrato',
            zipCode: '27425',
          },
          {
            name: 'Medio Baudo',
            zipCode: '27430',
          },
          {
            name: 'Medio San Juan',
            zipCode: '27450',
          },
          {
            name: 'Novita',
            zipCode: '27491',
          },
          {
            name: 'Nuqui',
            zipCode: '27495',
          },
          {
            name: 'Quibdo',
            zipCode: '27001',
          },
          {
            name: 'Rio Iro',
            zipCode: '27580',
          },
          {
            name: 'Rio Quito',
            zipCode: '27600',
          },
          {
            name: 'Riosucio',
            zipCode: '27615',
          },
          {
            name: 'San Jose Del Palmar',
            zipCode: '27660',
          },
          {
            name: 'Sipi',
            zipCode: '27745',
          },
          {
            name: 'Tado',
            zipCode: '27787',
          },
          {
            name: 'Unguia',
            zipCode: '27800',
          },
          {
            name: 'Union Panamericana',
            zipCode: '27810',
          },
        ],
        name: 'Choco',
      },
      {
        cities: [
          {
            name: 'Ayapel',
            zipCode: '23068',
          },
          {
            name: 'Buenavista',
            zipCode: '23079',
          },
          {
            name: 'Canalete',
            zipCode: '23090',
          },
          {
            name: 'Cerete',
            zipCode: '23162',
          },
          {
            name: 'Chima',
            zipCode: '23168',
          },
          {
            name: 'Chinu',
            zipCode: '23182',
          },
          {
            name: 'Cienaga De Oro',
            zipCode: '23189',
          },
          {
            name: 'Cotorra',
            zipCode: '23300',
          },
          {
            name: 'La Apartada',
            zipCode: '23350',
          },
          {
            name: 'Lorica',
            zipCode: '23417',
          },
          {
            name: 'Los Cordobas',
            zipCode: '23419',
          },
          {
            name: 'Momil',
            zipCode: '23464',
          },
          {
            name: 'Montelibano',
            zipCode: '23466',
          },
          {
            name: 'Monteria',
            zipCode: '23001',
          },
          {
            name: 'Moñitos',
            zipCode: '23500',
          },
          {
            name: 'Planeta Rica',
            zipCode: '23555',
          },
          {
            name: 'Pueblo Nuevo',
            zipCode: '23570',
          },
          {
            name: 'Puerto Escondido',
            zipCode: '23574',
          },
          {
            name: 'Puerto Libertador',
            zipCode: '23580',
          },
          {
            name: 'Purisima',
            zipCode: '23586',
          },
          {
            name: 'Sahagun',
            zipCode: '23660',
          },
          {
            name: 'San Andres Sotavento',
            zipCode: '23670',
          },
          {
            name: 'San Antero',
            zipCode: '23672',
          },
          {
            name: 'San Bernardo Del Viento',
            zipCode: '23675',
          },
          {
            name: 'San Carlos',
            zipCode: '23678',
          },
          {
            name: 'San Jose De Ure',
            zipCode: '23682',
          },
          {
            name: 'San Pelayo',
            zipCode: '23686',
          },
          {
            name: 'Tierralta',
            zipCode: '23807',
          },
          {
            name: 'Tuchin',
            zipCode: '23815',
          },
          {
            name: 'Valencia',
            zipCode: '23855',
          },
        ],
        name: 'Cordoba',
      },
      {
        cities: [
          {
            name: 'Agua De Dios',
            zipCode: '25001',
          },
          {
            name: 'Alban',
            zipCode: '25019',
          },
          {
            name: 'Anapoima',
            zipCode: '25035',
          },
          {
            name: 'Anolaima',
            zipCode: '25040',
          },
          {
            name: 'Apulo',
            zipCode: '25599',
          },
          {
            name: 'Arbelaez',
            zipCode: '25053',
          },
          {
            name: 'Beltran',
            zipCode: '25086',
          },
          {
            name: 'Bituima',
            zipCode: '25095',
          },
          {
            name: 'Bojaca',
            zipCode: '25099',
          },
          {
            name: 'Cabrera',
            zipCode: '25120',
          },
          {
            name: 'Cachipay',
            zipCode: '25123',
          },
          {
            name: 'Cajica',
            zipCode: '25126',
          },
          {
            name: 'Caparrapi',
            zipCode: '25148',
          },
          {
            name: 'Caqueza',
            zipCode: '25151',
          },
          {
            name: 'Carmen De Carupa',
            zipCode: '25154',
          },
          {
            name: 'Chaguani',
            zipCode: '25168',
          },
          {
            name: 'Chia',
            zipCode: '25175',
          },
          {
            name: 'Chipaque',
            zipCode: '25178',
          },
          {
            name: 'Choachi',
            zipCode: '25181',
          },
          {
            name: 'Choconta',
            zipCode: '25183',
          },
          {
            name: 'Cogua',
            zipCode: '25200',
          },
          {
            name: 'Cota',
            zipCode: '25214',
          },
          {
            name: 'Cucunuba',
            zipCode: '25224',
          },
          {
            name: 'El Colegio',
            zipCode: '25245',
          },
          {
            name: 'El Peñon',
            zipCode: '25258',
          },
          {
            name: 'El Rosal',
            zipCode: '25260',
          },
          {
            name: 'Facatativa',
            zipCode: '25269',
          },
          {
            name: 'Fomeque',
            zipCode: '25279',
          },
          {
            name: 'Fosca',
            zipCode: '25281',
          },
          {
            name: 'Funza',
            zipCode: '25286',
          },
          {
            name: 'Fuquene',
            zipCode: '25288',
          },
          {
            name: 'Fusagasuga',
            zipCode: '25290',
          },
          {
            name: 'Gachala',
            zipCode: '25293',
          },
          {
            name: 'Gachancipa',
            zipCode: '25295',
          },
          {
            name: 'Gacheta',
            zipCode: '25297',
          },
          {
            name: 'Gama',
            zipCode: '25299',
          },
          {
            name: 'Girardot',
            zipCode: '25307',
          },
          {
            name: 'Granada',
            zipCode: '25312',
          },
          {
            name: 'Guacheta',
            zipCode: '25317',
          },
          {
            name: 'Guaduas',
            zipCode: '25320',
          },
          {
            name: 'Guasca',
            zipCode: '25322',
          },
          {
            name: 'Guataqui',
            zipCode: '25324',
          },
          {
            name: 'Guatavita',
            zipCode: '25326',
          },
          {
            name: 'Guayabal De Siquima',
            zipCode: '25328',
          },
          {
            name: 'Guayabetal',
            zipCode: '25335',
          },
          {
            name: 'Gutierrez',
            zipCode: '25339',
          },
          {
            name: 'Jerusalen',
            zipCode: '25368',
          },
          {
            name: 'Junin',
            zipCode: '25372',
          },
          {
            name: 'La Calera',
            zipCode: '25377',
          },
          {
            name: 'La Mesa',
            zipCode: '25386',
          },
          {
            name: 'La Palma',
            zipCode: '25394',
          },
          {
            name: 'La Peña',
            zipCode: '25398',
          },
          {
            name: 'La Vega',
            zipCode: '25402',
          },
          {
            name: 'Lenguazaque',
            zipCode: '25407',
          },
          {
            name: 'Macheta',
            zipCode: '25426',
          },
          {
            name: 'Madrid',
            zipCode: '25430',
          },
          {
            name: 'Manta',
            zipCode: '25436',
          },
          {
            name: 'Medina',
            zipCode: '25438',
          },
          {
            name: 'Mosquera',
            zipCode: '25473',
          },
          {
            name: 'Nariño',
            zipCode: '25483',
          },
          {
            name: 'Nemocon',
            zipCode: '25486',
          },
          {
            name: 'Nilo',
            zipCode: '25488',
          },
          {
            name: 'Nimaima',
            zipCode: '25489',
          },
          {
            name: 'Nocaima',
            zipCode: '25491',
          },
          {
            name: 'Pacho',
            zipCode: '25513',
          },
          {
            name: 'Paime',
            zipCode: '25518',
          },
          {
            name: 'Pandi',
            zipCode: '25524',
          },
          {
            name: 'Paratebueno',
            zipCode: '25530',
          },
          {
            name: 'Pasca',
            zipCode: '25535',
          },
          {
            name: 'Puerto Salgar',
            zipCode: '25572',
          },
          {
            name: 'Puli',
            zipCode: '25580',
          },
          {
            name: 'Quebradanegra',
            zipCode: '25592',
          },
          {
            name: 'Quetame',
            zipCode: '25594',
          },
          {
            name: 'Quipile',
            zipCode: '25596',
          },
          {
            name: 'Ricaurte',
            zipCode: '25612',
          },
          {
            name: 'San Antonio Del Tequendama',
            zipCode: '25645',
          },
          {
            name: 'San Bernardo',
            zipCode: '25649',
          },
          {
            name: 'San Cayetano',
            zipCode: '25653',
          },
          {
            name: 'San Francisco',
            zipCode: '25658',
          },
          {
            name: 'San Juan De Rio Seco',
            zipCode: '25662',
          },
          {
            name: 'Sasaima',
            zipCode: '25718',
          },
          {
            name: 'Sesquile',
            zipCode: '25736',
          },
          {
            name: 'Sibate',
            zipCode: '25740',
          },
          {
            name: 'Silvania',
            zipCode: '25743',
          },
          {
            name: 'Simijaca',
            zipCode: '25745',
          },
          {
            name: 'Soacha',
            zipCode: '25754',
          },
          {
            name: 'Sopo',
            zipCode: '25758',
          },
          {
            name: 'Subachoque',
            zipCode: '25769',
          },
          {
            name: 'Suesca',
            zipCode: '25772',
          },
          {
            name: 'Supata',
            zipCode: '25777',
          },
          {
            name: 'Susa',
            zipCode: '25779',
          },
          {
            name: 'Sutatausa',
            zipCode: '25781',
          },
          {
            name: 'Tabio',
            zipCode: '25785',
          },
          {
            name: 'Tausa',
            zipCode: '25793',
          },
          {
            name: 'Tena',
            zipCode: '25797',
          },
          {
            name: 'Tenjo',
            zipCode: '25799',
          },
          {
            name: 'Tibacuy',
            zipCode: '25805',
          },
          {
            name: 'Tibirita',
            zipCode: '25807',
          },
          {
            name: 'Tocaima',
            zipCode: '25815',
          },
          {
            name: 'Tocancipa',
            zipCode: '25817',
          },
          {
            name: 'Topaipi',
            zipCode: '25823',
          },
          {
            name: 'Ubala',
            zipCode: '25839',
          },
          {
            name: 'Ubaque',
            zipCode: '25841',
          },
          {
            name: 'Une',
            zipCode: '25845',
          },
          {
            name: 'Utica',
            zipCode: '25851',
          },
          {
            name: 'Venecia',
            zipCode: '25506',
          },
          {
            name: 'Vergara',
            zipCode: '25862',
          },
          {
            name: 'Viani',
            zipCode: '25867',
          },
          {
            name: 'Villa De San Diego De Ubate',
            zipCode: '25843',
          },
          {
            name: 'Villagomez',
            zipCode: '25871',
          },
          {
            name: 'Villapinzon',
            zipCode: '25873',
          },
          {
            name: 'Villeta',
            zipCode: '25875',
          },
          {
            name: 'Viota',
            zipCode: '25878',
          },
          {
            name: 'Yacopi',
            zipCode: '25885',
          },
          {
            name: 'Zipacon',
            zipCode: '25898',
          },
          {
            name: 'Zipaquira',
            zipCode: '25899',
          },
        ],
        name: 'Cundinamarca',
      },
      {
        cities: [
          {
            name: 'Barranco Minas',
            zipCode: '94343',
          },
          {
            name: 'Cacahual',
            zipCode: '94886',
          },
          {
            name: 'Inirida',
            zipCode: '94001',
          },
          {
            name: 'La Guadalupe',
            zipCode: '94885',
          },
          {
            name: 'Mapiripana',
            zipCode: '94663',
          },
          {
            name: 'Morichal',
            zipCode: '94888',
          },
          {
            name: 'Pana Pana',
            zipCode: '94887',
          },
          {
            name: 'Puerto Colombia',
            zipCode: '94884',
          },
          {
            name: 'San Felipe',
            zipCode: '94883',
          },
        ],
        name: 'Guainia',
      },
      {
        cities: [
          {
            name: 'Calamar',
            zipCode: '95015',
          },
          {
            name: 'El Retorno',
            zipCode: '95025',
          },
          {
            name: 'Miraflores',
            zipCode: '95200',
          },
          {
            name: 'San Jose Del Guaviare',
            zipCode: '95001',
          },
        ],
        name: 'Guaviare',
      },
      {
        cities: [
          {
            name: 'Acevedo',
            zipCode: '41006',
          },
          {
            name: 'Agrado',
            zipCode: '41013',
          },
          {
            name: 'Aipe',
            zipCode: '41016',
          },
          {
            name: 'Algeciras',
            zipCode: '41020',
          },
          {
            name: 'Altamira',
            zipCode: '41026',
          },
          {
            name: 'Baraya',
            zipCode: '41078',
          },
          {
            name: 'Campoalegre',
            zipCode: '41132',
          },
          {
            name: 'Colombia',
            zipCode: '41206',
          },
          {
            name: 'Elias',
            zipCode: '41244',
          },
          {
            name: 'Garzon',
            zipCode: '41298',
          },
          {
            name: 'Gigante',
            zipCode: '41306',
          },
          {
            name: 'Guadalupe',
            zipCode: '41319',
          },
          {
            name: 'Hobo',
            zipCode: '41349',
          },
          {
            name: 'Iquira',
            zipCode: '41357',
          },
          {
            name: 'Isnos',
            zipCode: '41359',
          },
          {
            name: 'La Argentina',
            zipCode: '41378',
          },
          {
            name: 'La Plata',
            zipCode: '41396',
          },
          {
            name: 'Nataga',
            zipCode: '41483',
          },
          {
            name: 'Neiva',
            zipCode: '41001',
          },
          {
            name: 'Oporapa',
            zipCode: '41503',
          },
          {
            name: 'Paicol',
            zipCode: '41518',
          },
          {
            name: 'Palermo',
            zipCode: '41524',
          },
          {
            name: 'Palestina',
            zipCode: '41530',
          },
          {
            name: 'Pital',
            zipCode: '41548',
          },
          {
            name: 'Pitalito',
            zipCode: '41551',
          },
          {
            name: 'Rivera',
            zipCode: '41615',
          },
          {
            name: 'Saladoblanco',
            zipCode: '41660',
          },
          {
            name: 'San Agustin',
            zipCode: '41668',
          },
          {
            name: 'Santa Maria',
            zipCode: '41676',
          },
          {
            name: 'Suaza',
            zipCode: '41770',
          },
          {
            name: 'Tarqui',
            zipCode: '41791',
          },
          {
            name: 'Tello',
            zipCode: '41799',
          },
          {
            name: 'Teruel',
            zipCode: '41801',
          },
          {
            name: 'Tesalia',
            zipCode: '41797',
          },
          {
            name: 'Timana',
            zipCode: '41807',
          },
          {
            name: 'Villavieja',
            zipCode: '41872',
          },
          {
            name: 'Yaguara',
            zipCode: '41885',
          },
        ],
        name: 'Huila',
      },
      {
        cities: [
          {
            name: 'Albania',
            zipCode: '44035',
          },
          {
            name: 'Barrancas',
            zipCode: '44078',
          },
          {
            name: 'Dibulla',
            zipCode: '44090',
          },
          {
            name: 'Distraccion',
            zipCode: '44098',
          },
          {
            name: 'El Molino',
            zipCode: '44110',
          },
          {
            name: 'Fonseca',
            zipCode: '44279',
          },
          {
            name: 'Hatonuevo',
            zipCode: '44378',
          },
          {
            name: 'La Jagua Del Pilar',
            zipCode: '44420',
          },
          {
            name: 'Maicao',
            zipCode: '44430',
          },
          {
            name: 'Manaure',
            zipCode: '44560',
          },
          {
            name: 'Riohacha',
            zipCode: '44001',
          },
          {
            name: 'San Juan Del Cesar',
            zipCode: '44650',
          },
          {
            name: 'Uribia',
            zipCode: '44847',
          },
          {
            name: 'Urumita',
            zipCode: '44855',
          },
          {
            name: 'Villanueva',
            zipCode: '44874',
          },
        ],
        name: 'La Guajira',
      },
      {
        cities: [
          {
            name: 'Algarrobo',
            zipCode: '47030',
          },
          {
            name: 'Aracataca',
            zipCode: '47053',
          },
          {
            name: 'Ariguani',
            zipCode: '47058',
          },
          {
            name: 'Cerro San Antonio',
            zipCode: '47161',
          },
          {
            name: 'Chivolo',
            zipCode: '47170',
          },
          {
            name: 'Cienaga',
            zipCode: '47189',
          },
          {
            name: 'Concordia',
            zipCode: '47205',
          },
          {
            name: 'El Banco',
            zipCode: '47245',
          },
          {
            name: 'El Piñon',
            zipCode: '47258',
          },
          {
            name: 'El Reten',
            zipCode: '47268',
          },
          {
            name: 'Fundacion',
            zipCode: '47288',
          },
          {
            name: 'Guamal',
            zipCode: '47318',
          },
          {
            name: 'Nueva Granada',
            zipCode: '47460',
          },
          {
            name: 'Pedraza',
            zipCode: '47541',
          },
          {
            name: 'Pijiño Del Carmen',
            zipCode: '47545',
          },
          {
            name: 'Pivijay',
            zipCode: '47551',
          },
          {
            name: 'Plato',
            zipCode: '47555',
          },
          {
            name: 'Puebloviejo',
            zipCode: '47570',
          },
          {
            name: 'Remolino',
            zipCode: '47605',
          },
          {
            name: 'Sabanas De San Angel',
            zipCode: '47660',
          },
          {
            name: 'Salamina',
            zipCode: '47675',
          },
          {
            name: 'San Sebastian De Buenavista',
            zipCode: '47692',
          },
          {
            name: 'San Zenon',
            zipCode: '47703',
          },
          {
            name: 'Santa Ana',
            zipCode: '47707',
          },
          {
            name: 'Santa Barbara De Pinto',
            zipCode: '47720',
          },
          {
            name: 'Santa Marta',
            zipCode: '47001',
          },
          {
            name: 'Sitionuevo',
            zipCode: '47745',
          },
          {
            name: 'Tenerife',
            zipCode: '47798',
          },
          {
            name: 'Zapayan',
            zipCode: '47960',
          },
          {
            name: 'Zona Bananera',
            zipCode: '47980',
          },
        ],
        name: 'Magdalena',
      },
      {
        cities: [
          {
            name: 'Acacias',
            zipCode: '50006',
          },
          {
            name: 'Barranca De Upia',
            zipCode: '50110',
          },
          {
            name: 'Cabuyaro',
            zipCode: '50124',
          },
          {
            name: 'Castilla La Nueva',
            zipCode: '50150',
          },
          {
            name: 'Cubarral',
            zipCode: '50223',
          },
          {
            name: 'Cumaral',
            zipCode: '50226',
          },
          {
            name: 'El Calvario',
            zipCode: '50245',
          },
          {
            name: 'El Castillo',
            zipCode: '50251',
          },
          {
            name: 'El Dorado',
            zipCode: '50270',
          },
          {
            name: 'Fuente De Oro',
            zipCode: '50287',
          },
          {
            name: 'Granada',
            zipCode: '50313',
          },
          {
            name: 'Guamal',
            zipCode: '50318',
          },
          {
            name: 'La Macarena',
            zipCode: '50350',
          },
          {
            name: 'Lejanias',
            zipCode: '50400',
          },
          {
            name: 'Mapiripan',
            zipCode: '50325',
          },
          {
            name: 'Mesetas',
            zipCode: '50330',
          },
          {
            name: 'Puerto Concordia',
            zipCode: '50450',
          },
          {
            name: 'Puerto Gaitan',
            zipCode: '50568',
          },
          {
            name: 'Puerto Lleras',
            zipCode: '50577',
          },
          {
            name: 'Puerto Lopez',
            zipCode: '50573',
          },
          {
            name: 'Puerto Rico',
            zipCode: '50590',
          },
          {
            name: 'Restrepo',
            zipCode: '50606',
          },
          {
            name: 'San Carlos De Guaroa',
            zipCode: '50680',
          },
          {
            name: 'San Juan De Arama',
            zipCode: '50683',
          },
          {
            name: 'San Juanito',
            zipCode: '50686',
          },
          {
            name: 'San Martin',
            zipCode: '50689',
          },
          {
            name: 'Uribe',
            zipCode: '50370',
          },
          {
            name: 'Villavicencio',
            zipCode: '50001',
          },
          {
            name: 'Vistahermosa',
            zipCode: '50711',
          },
        ],
        name: 'Meta',
      },
      {
        cities: [
          {
            name: 'Alban',
            zipCode: '52019',
          },
          {
            name: 'Aldana',
            zipCode: '52022',
          },
          {
            name: 'Ancuya',
            zipCode: '52036',
          },
          {
            name: 'Arboleda',
            zipCode: '52051',
          },
          {
            name: 'Barbacoas',
            zipCode: '52079',
          },
          {
            name: 'Belen',
            zipCode: '52083',
          },
          {
            name: 'Buesaco',
            zipCode: '52110',
          },
          {
            name: 'Chachagüi',
            zipCode: '52240',
          },
          {
            name: 'Colon',
            zipCode: '52203',
          },
          {
            name: 'Consaca',
            zipCode: '52207',
          },
          {
            name: 'Contadero',
            zipCode: '52210',
          },
          {
            name: 'Cordoba',
            zipCode: '52215',
          },
          {
            name: 'Cuaspud',
            zipCode: '52224',
          },
          {
            name: 'Cumbal',
            zipCode: '52227',
          },
          {
            name: 'Cumbitara',
            zipCode: '52233',
          },
          {
            name: 'El Charco',
            zipCode: '52250',
          },
          {
            name: 'El Peñol',
            zipCode: '52254',
          },
          {
            name: 'El Rosario',
            zipCode: '52256',
          },
          {
            name: 'El Tablon De Gomez',
            zipCode: '52258',
          },
          {
            name: 'El Tambo',
            zipCode: '52260',
          },
          {
            name: 'Francisco Pizarro',
            zipCode: '52520',
          },
          {
            name: 'Funes',
            zipCode: '52287',
          },
          {
            name: 'Guachucal',
            zipCode: '52317',
          },
          {
            name: 'Guaitarilla',
            zipCode: '52320',
          },
          {
            name: 'Gualmatan',
            zipCode: '52323',
          },
          {
            name: 'Iles',
            zipCode: '52352',
          },
          {
            name: 'Imues',
            zipCode: '52354',
          },
          {
            name: 'Ipiales',
            zipCode: '52356',
          },
          {
            name: 'La Cruz',
            zipCode: '52378',
          },
          {
            name: 'La Florida',
            zipCode: '52381',
          },
          {
            name: 'La Llanada',
            zipCode: '52385',
          },
          {
            name: 'La Tola',
            zipCode: '52390',
          },
          {
            name: 'La Union',
            zipCode: '52399',
          },
          {
            name: 'Leiva',
            zipCode: '52405',
          },
          {
            name: 'Linares',
            zipCode: '52411',
          },
          {
            name: 'Los Andes',
            zipCode: '52418',
          },
          {
            name: 'Magüi',
            zipCode: '52427',
          },
          {
            name: 'Mallama',
            zipCode: '52435',
          },
          {
            name: 'Mosquera',
            zipCode: '52473',
          },
          {
            name: 'Nariño',
            zipCode: '52480',
          },
          {
            name: 'Olaya Herrera',
            zipCode: '52490',
          },
          {
            name: 'Ospina',
            zipCode: '52506',
          },
          {
            name: 'Pasto',
            zipCode: '52001',
          },
          {
            name: 'Policarpa',
            zipCode: '52540',
          },
          {
            name: 'Potosi',
            zipCode: '52560',
          },
          {
            name: 'Providencia',
            zipCode: '52565',
          },
          {
            name: 'Puerres',
            zipCode: '52573',
          },
          {
            name: 'Pupiales',
            zipCode: '52585',
          },
          {
            name: 'Ricaurte',
            zipCode: '52612',
          },
          {
            name: 'Roberto Payan',
            zipCode: '52621',
          },
          {
            name: 'Samaniego',
            zipCode: '52678',
          },
          {
            name: 'San Andres De Tumaco',
            zipCode: '52835',
          },
          {
            name: 'San Bernardo',
            zipCode: '52685',
          },
          {
            name: 'San Lorenzo',
            zipCode: '52687',
          },
          {
            name: 'San Pablo',
            zipCode: '52693',
          },
          {
            name: 'San Pedro De Cartago',
            zipCode: '52694',
          },
          {
            name: 'Sandona',
            zipCode: '52683',
          },
          {
            name: 'Santa Barbara',
            zipCode: '52696',
          },
          {
            name: 'Santacruz',
            zipCode: '52699',
          },
          {
            name: 'Sapuyes',
            zipCode: '52720',
          },
          {
            name: 'Taminango',
            zipCode: '52786',
          },
          {
            name: 'Tangua',
            zipCode: '52788',
          },
          {
            name: 'Tuquerres',
            zipCode: '52838',
          },
          {
            name: 'Yacuanquer',
            zipCode: '52885',
          },
        ],
        name: 'Nariño',
      },
      {
        cities: [
          {
            name: 'Abrego',
            zipCode: '54003',
          },
          {
            name: 'Arboledas',
            zipCode: '54051',
          },
          {
            name: 'Bochalema',
            zipCode: '54099',
          },
          {
            name: 'Bucarasica',
            zipCode: '54109',
          },
          {
            name: 'Cachira',
            zipCode: '54128',
          },
          {
            name: 'Cacota',
            zipCode: '54125',
          },
          {
            name: 'Chinacota',
            zipCode: '54172',
          },
          {
            name: 'Chitaga',
            zipCode: '54174',
          },
          {
            name: 'Convencion',
            zipCode: '54206',
          },
          {
            name: 'Cucuta',
            zipCode: '54001',
          },
          {
            name: 'Cucutilla',
            zipCode: '54223',
          },
          {
            name: 'Durania',
            zipCode: '54239',
          },
          {
            name: 'El Carmen',
            zipCode: '54245',
          },
          {
            name: 'El Tarra',
            zipCode: '54250',
          },
          {
            name: 'El Zulia',
            zipCode: '54261',
          },
          {
            name: 'Gramalote',
            zipCode: '54313',
          },
          {
            name: 'Hacari',
            zipCode: '54344',
          },
          {
            name: 'Herran',
            zipCode: '54347',
          },
          {
            name: 'La Esperanza',
            zipCode: '54385',
          },
          {
            name: 'La Playa',
            zipCode: '54398',
          },
          {
            name: 'Labateca',
            zipCode: '54377',
          },
          {
            name: 'Los Patios',
            zipCode: '54405',
          },
          {
            name: 'Lourdes',
            zipCode: '54418',
          },
          {
            name: 'Mutiscua',
            zipCode: '54480',
          },
          {
            name: 'Ocaña',
            zipCode: '54498',
          },
          {
            name: 'Pamplona',
            zipCode: '54518',
          },
          {
            name: 'Pamplonita',
            zipCode: '54520',
          },
          {
            name: 'Puerto Santander',
            zipCode: '54553',
          },
          {
            name: 'Ragonvalia',
            zipCode: '54599',
          },
          {
            name: 'Salazar',
            zipCode: '54660',
          },
          {
            name: 'San Calixto',
            zipCode: '54670',
          },
          {
            name: 'San Cayetano',
            zipCode: '54673',
          },
          {
            name: 'Santiago',
            zipCode: '54680',
          },
          {
            name: 'Sardinata',
            zipCode: '54720',
          },
          {
            name: 'Silos',
            zipCode: '54743',
          },
          {
            name: 'Teorama',
            zipCode: '54800',
          },
          {
            name: 'Tibu',
            zipCode: '54810',
          },
          {
            name: 'Toledo',
            zipCode: '54820',
          },
          {
            name: 'Villa Caro',
            zipCode: '54871',
          },
          {
            name: 'Villa Del Rosario',
            zipCode: '54874',
          },
        ],
        name: 'Norte de Santander',
      },
      {
        cities: [
          {
            name: 'Colon',
            zipCode: '86219',
          },
          {
            name: 'Mocoa',
            zipCode: '86001',
          },
          {
            name: 'Orito',
            zipCode: '86320',
          },
          {
            name: 'Puerto Asis',
            zipCode: '86568',
          },
          {
            name: 'Puerto Caicedo',
            zipCode: '86569',
          },
          {
            name: 'Puerto Guzman',
            zipCode: '86571',
          },
          {
            name: 'Puerto Leguizamo',
            zipCode: '86573',
          },
          {
            name: 'San Francisco',
            zipCode: '86755',
          },
          {
            name: 'San Miguel',
            zipCode: '86757',
          },
          {
            name: 'Santiago',
            zipCode: '86760',
          },
          {
            name: 'Sibundoy',
            zipCode: '86749',
          },
          {
            name: 'Valle Del Guamuez',
            zipCode: '86865',
          },
          {
            name: 'Villagarzon',
            zipCode: '86885',
          },
        ],
        name: 'Putumayo',
      },
      {
        cities: [
          {
            name: 'Armenia',
            zipCode: '63001',
          },
          {
            name: 'Buenavista',
            zipCode: '63111',
          },
          {
            name: 'Calarca',
            zipCode: '63130',
          },
          {
            name: 'Circasia',
            zipCode: '63190',
          },
          {
            name: 'Cordoba',
            zipCode: '63212',
          },
          {
            name: 'Filandia',
            zipCode: '63272',
          },
          {
            name: 'Genova',
            zipCode: '63302',
          },
          {
            name: 'La Tebaida',
            zipCode: '63401',
          },
          {
            name: 'Montenegro',
            zipCode: '63470',
          },
          {
            name: 'Pijao',
            zipCode: '63548',
          },
          {
            name: 'Quimbaya',
            zipCode: '63594',
          },
          {
            name: 'Salento',
            zipCode: '63690',
          },
        ],
        name: 'Quindio',
      },
      {
        cities: [
          {
            name: 'Apia',
            zipCode: '66045',
          },
          {
            name: 'Balboa',
            zipCode: '66075',
          },
          {
            name: 'Belen De Umbria',
            zipCode: '66088',
          },
          {
            name: 'Dosquebradas',
            zipCode: '66170',
          },
          {
            name: 'Guatica',
            zipCode: '66318',
          },
          {
            name: 'La Celia',
            zipCode: '66383',
          },
          {
            name: 'La Virginia',
            zipCode: '66400',
          },
          {
            name: 'Marsella',
            zipCode: '66440',
          },
          {
            name: 'Mistrato',
            zipCode: '66456',
          },
          {
            name: 'Pereira',
            zipCode: '66001',
          },
          {
            name: 'Pueblo Rico',
            zipCode: '66572',
          },
          {
            name: 'Quinchia',
            zipCode: '66594',
          },
          {
            name: 'Santa Rosa De Cabal',
            zipCode: '66682',
          },
          {
            name: 'Santuario',
            zipCode: '66687',
          },
        ],
        name: 'Risaralda',
      },
      {
        cities: [
          {
            name: 'Providencia',
            zipCode: '88564',
          },
          {
            name: 'San Andres',
            zipCode: '88001',
          },
        ],
        name: 'San Andres y Providencia',
      },
      {
        cities: [
          {
            name: 'Aguada',
            zipCode: '68013',
          },
          {
            name: 'Albania',
            zipCode: '68020',
          },
          {
            name: 'Aratoca',
            zipCode: '68051',
          },
          {
            name: 'Barbosa',
            zipCode: '68077',
          },
          {
            name: 'Barichara',
            zipCode: '68079',
          },
          {
            name: 'Barrancabermeja',
            zipCode: '68081',
          },
          {
            name: 'Betulia',
            zipCode: '68092',
          },
          {
            name: 'Bolivar',
            zipCode: '68101',
          },
          {
            name: 'Bucaramanga',
            zipCode: '68001',
          },
          {
            name: 'Cabrera',
            zipCode: '68121',
          },
          {
            name: 'California',
            zipCode: '68132',
          },
          {
            name: 'Capitanejo',
            zipCode: '68147',
          },
          {
            name: 'Carcasi',
            zipCode: '68152',
          },
          {
            name: 'Cepita',
            zipCode: '68160',
          },
          {
            name: 'Cerrito',
            zipCode: '68162',
          },
          {
            name: 'Charala',
            zipCode: '68167',
          },
          {
            name: 'Charta',
            zipCode: '68169',
          },
          {
            name: 'Chima',
            zipCode: '68176',
          },
          {
            name: 'Chipata',
            zipCode: '68179',
          },
          {
            name: 'Cimitarra',
            zipCode: '68190',
          },
          {
            name: 'Concepcion',
            zipCode: '68207',
          },
          {
            name: 'Confines',
            zipCode: '68209',
          },
          {
            name: 'Contratacion',
            zipCode: '68211',
          },
          {
            name: 'Coromoro',
            zipCode: '68217',
          },
          {
            name: 'Curiti',
            zipCode: '68229',
          },
          {
            name: 'El Carmen De Chucuri',
            zipCode: '68235',
          },
          {
            name: 'El Guacamayo',
            zipCode: '68245',
          },
          {
            name: 'El Peñon',
            zipCode: '68250',
          },
          {
            name: 'El Playon',
            zipCode: '68255',
          },
          {
            name: 'Encino',
            zipCode: '68264',
          },
          {
            name: 'Enciso',
            zipCode: '68266',
          },
          {
            name: 'Florian',
            zipCode: '68271',
          },
          {
            name: 'Floridablanca',
            zipCode: '68276',
          },
          {
            name: 'Galan',
            zipCode: '68296',
          },
          {
            name: 'Gambita',
            zipCode: '68298',
          },
          {
            name: 'Giron',
            zipCode: '68307',
          },
          {
            name: 'Guaca',
            zipCode: '68318',
          },
          {
            name: 'Guadalupe',
            zipCode: '68320',
          },
          {
            name: 'Guapota',
            zipCode: '68322',
          },
          {
            name: 'Guavata',
            zipCode: '68324',
          },
          {
            name: 'Güepsa',
            zipCode: '68327',
          },
          {
            name: 'Hato',
            zipCode: '68344',
          },
          {
            name: 'Jesus Maria',
            zipCode: '68368',
          },
          {
            name: 'Jordan',
            zipCode: '68370',
          },
          {
            name: 'La Belleza',
            zipCode: '68377',
          },
          {
            name: 'La Paz',
            zipCode: '68397',
          },
          {
            name: 'Landazuri',
            zipCode: '68385',
          },
          {
            name: 'Lebrija',
            zipCode: '68406',
          },
          {
            name: 'Los Santos',
            zipCode: '68418',
          },
          {
            name: 'Macaravita',
            zipCode: '68425',
          },
          {
            name: 'Malaga',
            zipCode: '68432',
          },
          {
            name: 'Matanza',
            zipCode: '68444',
          },
          {
            name: 'Mogotes',
            zipCode: '68464',
          },
          {
            name: 'Molagavita',
            zipCode: '68468',
          },
          {
            name: 'Ocamonte',
            zipCode: '68498',
          },
          {
            name: 'Oiba',
            zipCode: '68500',
          },
          {
            name: 'Onzaga',
            zipCode: '68502',
          },
          {
            name: 'Palmar',
            zipCode: '68522',
          },
          {
            name: 'Palmas Del Socorro',
            zipCode: '68524',
          },
          {
            name: 'Paramo',
            zipCode: '68533',
          },
          {
            name: 'Piedecuesta',
            zipCode: '68547',
          },
          {
            name: 'Pinchote',
            zipCode: '68549',
          },
          {
            name: 'Puente Nacional',
            zipCode: '68572',
          },
          {
            name: 'Puerto Parra',
            zipCode: '68573',
          },
          {
            name: 'Puerto Wilches',
            zipCode: '68575',
          },
          {
            name: 'Rionegro',
            zipCode: '68615',
          },
          {
            name: 'Sabana De Torres',
            zipCode: '68655',
          },
          {
            name: 'San Andres',
            zipCode: '68669',
          },
          {
            name: 'San Benito',
            zipCode: '68673',
          },
          {
            name: 'San Gil',
            zipCode: '68679',
          },
          {
            name: 'San Joaquin',
            zipCode: '68682',
          },
          {
            name: 'San Jose De Miranda',
            zipCode: '68684',
          },
          {
            name: 'San Miguel',
            zipCode: '68686',
          },
          {
            name: 'San Vicente De Chucuri',
            zipCode: '68689',
          },
          {
            name: 'Santa Barbara',
            zipCode: '68705',
          },
          {
            name: 'Santa Helena Del Opon',
            zipCode: '68720',
          },
          {
            name: 'Simacota',
            zipCode: '68745',
          },
          {
            name: 'Socorro',
            zipCode: '68755',
          },
          {
            name: 'Suaita',
            zipCode: '68770',
          },
          {
            name: 'Sucre',
            zipCode: '68773',
          },
          {
            name: 'Surata',
            zipCode: '68780',
          },
          {
            name: 'Tona',
            zipCode: '68820',
          },
          {
            name: 'Valle De San Jose',
            zipCode: '68855',
          },
          {
            name: 'Velez',
            zipCode: '68861',
          },
          {
            name: 'Vetas',
            zipCode: '68867',
          },
          {
            name: 'Villanueva',
            zipCode: '68872',
          },
          {
            name: 'Zapatoca',
            zipCode: '68895',
          },
        ],
        name: 'Santander',
      },
      {
        cities: [
          {
            name: 'Buenavista',
            zipCode: '70110',
          },
          {
            name: 'Caimito',
            zipCode: '70124',
          },
          {
            name: 'Chalan',
            zipCode: '70230',
          },
          {
            name: 'Coloso',
            zipCode: '70204',
          },
          {
            name: 'Corozal',
            zipCode: '70215',
          },
          {
            name: 'Coveñas',
            zipCode: '70221',
          },
          {
            name: 'El Roble',
            zipCode: '70233',
          },
          {
            name: 'Galeras',
            zipCode: '70235',
          },
          {
            name: 'Guaranda',
            zipCode: '70265',
          },
          {
            name: 'La Union',
            zipCode: '70400',
          },
          {
            name: 'Los Palmitos',
            zipCode: '70418',
          },
          {
            name: 'Majagual',
            zipCode: '70429',
          },
          {
            name: 'Morroa',
            zipCode: '70473',
          },
          {
            name: 'Ovejas',
            zipCode: '70508',
          },
          {
            name: 'Palmito',
            zipCode: '70523',
          },
          {
            name: 'Sampues',
            zipCode: '70670',
          },
          {
            name: 'San Benito Abad',
            zipCode: '70678',
          },
          {
            name: 'San Juan De Betulia',
            zipCode: '70702',
          },
          {
            name: 'San Luis De Since',
            zipCode: '70742',
          },
          {
            name: 'San Marcos',
            zipCode: '70708',
          },
          {
            name: 'San Onofre',
            zipCode: '70713',
          },
          {
            name: 'San Pedro',
            zipCode: '70717',
          },
          {
            name: 'Santiago De Tolu',
            zipCode: '70820',
          },
          {
            name: 'Sincelejo',
            zipCode: '70001',
          },
          {
            name: 'Sucre',
            zipCode: '70771',
          },
          {
            name: 'Tolu Viejo',
            zipCode: '70823',
          },
        ],
        name: 'Sucre',
      },
      {
        cities: [
          {
            name: 'Alpujarra',
            zipCode: '73024',
          },
          {
            name: 'Alvarado',
            zipCode: '73026',
          },
          {
            name: 'Ambalema',
            zipCode: '73030',
          },
          {
            name: 'Anzoategui',
            zipCode: '73043',
          },
          {
            name: 'Armero',
            zipCode: '73055',
          },
          {
            name: 'Ataco',
            zipCode: '73067',
          },
          {
            name: 'Cajamarca',
            zipCode: '73124',
          },
          {
            name: 'Carmen De Apicala',
            zipCode: '73148',
          },
          {
            name: 'Casabianca',
            zipCode: '73152',
          },
          {
            name: 'Chaparral',
            zipCode: '73168',
          },
          {
            name: 'Coello',
            zipCode: '73200',
          },
          {
            name: 'Coyaima',
            zipCode: '73217',
          },
          {
            name: 'Cunday',
            zipCode: '73226',
          },
          {
            name: 'Dolores',
            zipCode: '73236',
          },
          {
            name: 'Espinal',
            zipCode: '73268',
          },
          {
            name: 'Falan',
            zipCode: '73270',
          },
          {
            name: 'Flandes',
            zipCode: '73275',
          },
          {
            name: 'Fresno',
            zipCode: '73283',
          },
          {
            name: 'Guamo',
            zipCode: '73319',
          },
          {
            name: 'Herveo',
            zipCode: '73347',
          },
          {
            name: 'Honda',
            zipCode: '73349',
          },
          {
            name: 'Ibague',
            zipCode: '73001',
          },
          {
            name: 'Icononzo',
            zipCode: '73352',
          },
          {
            name: 'Lerida',
            zipCode: '73408',
          },
          {
            name: 'Libano',
            zipCode: '73411',
          },
          {
            name: 'Melgar',
            zipCode: '73449',
          },
          {
            name: 'Murillo',
            zipCode: '73461',
          },
          {
            name: 'Natagaima',
            zipCode: '73483',
          },
          {
            name: 'Ortega',
            zipCode: '73504',
          },
          {
            name: 'Palocabildo',
            zipCode: '73520',
          },
          {
            name: 'Piedras',
            zipCode: '73547',
          },
          {
            name: 'Planadas',
            zipCode: '73555',
          },
          {
            name: 'Prado',
            zipCode: '73563',
          },
          {
            name: 'Purificacion',
            zipCode: '73585',
          },
          {
            name: 'Rioblanco',
            zipCode: '73616',
          },
          {
            name: 'Roncesvalles',
            zipCode: '73622',
          },
          {
            name: 'Rovira',
            zipCode: '73624',
          },
          {
            name: 'Saldaña',
            zipCode: '73671',
          },
          {
            name: 'San Antonio',
            zipCode: '73675',
          },
          {
            name: 'San Luis',
            zipCode: '73678',
          },
          {
            name: 'San Sebastian De Mariquita',
            zipCode: '73443',
          },
          {
            name: 'Santa Isabel',
            zipCode: '73686',
          },
          {
            name: 'Suarez',
            zipCode: '73770',
          },
          {
            name: 'Valle De San Juan',
            zipCode: '73854',
          },
          {
            name: 'Venadillo',
            zipCode: '73861',
          },
          {
            name: 'Villahermosa',
            zipCode: '73870',
          },
          {
            name: 'Villarrica',
            zipCode: '73873',
          },
        ],
        name: 'Tolima',
      },
      {
        cities: [
          {
            name: 'Alcala',
            zipCode: '76020',
          },
          {
            name: 'Andalucia',
            zipCode: '76036',
          },
          {
            name: 'Ansermanuevo',
            zipCode: '76041',
          },
          {
            name: 'Argelia',
            zipCode: '76054',
          },
          {
            name: 'Bolivar',
            zipCode: '76100',
          },
          {
            name: 'Buenaventura',
            zipCode: '76109',
          },
          {
            name: 'Bugalagrande',
            zipCode: '76113',
          },
          {
            name: 'Caicedonia',
            zipCode: '76122',
          },
          {
            name: 'Cali',
            zipCode: '76001',
          },
          {
            name: 'Calima',
            zipCode: '76126',
          },
          {
            name: 'Candelaria',
            zipCode: '76130',
          },
          {
            name: 'Cartago',
            zipCode: '76147',
          },
          {
            name: 'Dagua',
            zipCode: '76233',
          },
          {
            name: 'El Aguila',
            zipCode: '76243',
          },
          {
            name: 'El Cairo',
            zipCode: '76246',
          },
          {
            name: 'El Cerrito',
            zipCode: '76248',
          },
          {
            name: 'El Dovio',
            zipCode: '76250',
          },
          {
            name: 'Florida',
            zipCode: '76275',
          },
          {
            name: 'Ginebra',
            zipCode: '76306',
          },
          {
            name: 'Guacari',
            zipCode: '76318',
          },
          {
            name: 'Guadalajara De Buga',
            zipCode: '76111',
          },
          {
            name: 'Jamundi',
            zipCode: '76364',
          },
          {
            name: 'La Cumbre',
            zipCode: '76377',
          },
          {
            name: 'La Union',
            zipCode: '76400',
          },
          {
            name: 'La Victoria',
            zipCode: '76403',
          },
          {
            name: 'Obando',
            zipCode: '76497',
          },
          {
            name: 'Palmira',
            zipCode: '76520',
          },
          {
            name: 'Pradera',
            zipCode: '76563',
          },
          {
            name: 'Restrepo',
            zipCode: '76606',
          },
          {
            name: 'Riofrio',
            zipCode: '76616',
          },
          {
            name: 'Roldanillo',
            zipCode: '76622',
          },
          {
            name: 'San Pedro',
            zipCode: '76670',
          },
          {
            name: 'Sevilla',
            zipCode: '76736',
          },
          {
            name: 'Toro',
            zipCode: '76823',
          },
          {
            name: 'Trujillo',
            zipCode: '76828',
          },
          {
            name: 'Tulua',
            zipCode: '76834',
          },
          {
            name: 'Ulloa',
            zipCode: '76845',
          },
          {
            name: 'Versalles',
            zipCode: '76863',
          },
          {
            name: 'Vijes',
            zipCode: '76869',
          },
          {
            name: 'Yotoco',
            zipCode: '76890',
          },
          {
            name: 'Yumbo',
            zipCode: '76892',
          },
          {
            name: 'Zarzal',
            zipCode: '76895',
          },
        ],
        name: 'Valle del Cauca',
      },
      {
        cities: [
          {
            name: 'Caruru',
            zipCode: '97161',
          },
          {
            name: 'Mitu',
            zipCode: '97001',
          },
          {
            name: 'Pacoa',
            zipCode: '97511',
          },
          {
            name: 'Papunaua',
            zipCode: '97777',
          },
          {
            name: 'Taraira',
            zipCode: '97666',
          },
          {
            name: 'Yavarate',
            zipCode: '97889',
          },
        ],
        name: 'Vaupes',
      },
      {
        cities: [
          {
            name: 'Cumaribo',
            zipCode: '99773',
          },
          {
            name: 'La Primavera',
            zipCode: '99524',
          },
          {
            name: 'Puerto Carreño',
            zipCode: '99001',
          },
          {
            name: 'Santa Rosalia',
            zipCode: '99624',
          },
        ],
        name: 'Vichada',
      },
    ],
  },
  {
    code: 'KM',
    name: 'Comoros',
    phone: '269',
  },
  {
    code: 'CD',
    name: 'Congo, Democratic Republic of the',
    phone: '243',
  },
  {
    code: 'CG',
    name: 'Congo, Republic of the',
    phone: '242',
  },
  {
    code: 'CK',
    name: 'Cook Islands',
    phone: '682',
  },
  {
    code: 'CR',
    name: 'Costa Rica',
    phone: '506',
  },
  {
    code: 'CI',
    name: "Cote d'Ivoire",
    phone: '225',
  },
  {
    code: 'HR',
    name: 'Croatia',
    phone: '385',
  },
  {
    code: 'CU',
    name: 'Cuba',
    phone: '53',
  },
  {
    code: 'CW',
    name: 'Curacao',
    phone: '599',
  },
  {
    code: 'CY',
    name: 'Cyprus',
    phone: '357',
  },
  {
    code: 'CZ',
    name: 'Czech Republic',
    phone: '420',
  },
  {
    code: 'DK',
    name: 'Denmark',
    phone: '45',
  },
  {
    code: 'DJ',
    name: 'Djibouti',
    phone: '253',
  },
  {
    code: 'DM',
    name: 'Dominica',
    phone: '1-767',
  },
  {
    code: 'DO',
    name: 'Dominican Republic',
    phone: '1-809',
  },
  {
    code: 'EC',
    name: 'Ecuador',
    phone: '593',
  },
  {
    code: 'EG',
    name: 'Egypt',
    phone: '20',
  },
  {
    code: 'SV',
    name: 'El Salvador',
    phone: '503',
  },
  {
    code: 'GQ',
    name: 'Equatorial Guinea',
    phone: '240',
  },
  {
    code: 'ER',
    name: 'Eritrea',
    phone: '291',
  },
  {
    code: 'EE',
    name: 'Estonia',
    phone: '372',
  },
  {
    code: 'ET',
    name: 'Ethiopia',
    phone: '251',
  },
  {
    code: 'FK',
    name: 'Falkland Islands (Malvinas)',
    phone: '500',
  },
  {
    code: 'FO',
    name: 'Faroe Islands',
    phone: '298',
  },
  {
    code: 'FJ',
    name: 'Fiji',
    phone: '679',
  },
  {
    code: 'FI',
    name: 'Finland',
    phone: '358',
  },
  {
    code: 'FR',
    name: 'France',
    numberFormat: {
      code: 'fr-FR',
      currency: 'EUR',
    },
    phone: '33',
    suggested: true,
  },
  {
    code: 'GF',
    name: 'French Guiana',
    phone: '594',
  },
  {
    code: 'PF',
    name: 'French Polynesia',
    phone: '689',
  },
  {
    code: 'TF',
    name: 'French Southern Territories',
    phone: '262',
  },
  {
    code: 'GA',
    name: 'Gabon',
    phone: '241',
  },
  {
    code: 'GM',
    name: 'Gambia',
    phone: '220',
  },
  {
    code: 'GE',
    name: 'Georgia',
    phone: '995',
  },
  {
    code: 'DE',
    name: 'Germany',
    numberFormat: {
      code: 'de-DE',
      currency: 'EUR',
    },
    phone: '49',
    suggested: true,
  },
  {
    code: 'GH',
    name: 'Ghana',
    phone: '233',
  },
  {
    code: 'GI',
    name: 'Gibraltar',
    phone: '350',
  },
  {
    code: 'GR',
    name: 'Greece',
    numberFormat: {
      code: 'el-GR',
      currency: 'EUR',
    },
    phone: '30',
  },
  {
    code: 'GL',
    name: 'Greenland',
    phone: '299',
  },
  {
    code: 'GD',
    name: 'Grenada',
    phone: '1-473',
  },
  {
    code: 'GP',
    name: 'Guadeloupe',
    phone: '590',
  },
  {
    code: 'GU',
    name: 'Guam',
    phone: '1-671',
  },
  {
    code: 'GT',
    name: 'Guatemala',
    phone: '502',
  },
  {
    code: 'GG',
    name: 'Guernsey',
    phone: '44',
  },
  {
    code: 'GN',
    name: 'Guinea',
    phone: '224',
  },
  {
    code: 'GW',
    name: 'Guinea-Bissau',
    phone: '245',
  },
  {
    code: 'GY',
    name: 'Guyana',
    phone: '592',
  },
  {
    code: 'HT',
    name: 'Haiti',
    phone: '509',
  },
  {
    code: 'HM',
    name: 'Heard Island and McDonald Islands',
    phone: '672',
  },
  {
    code: 'VA',
    name: 'Holy See (Vatican City State)',
    phone: '379',
  },
  {
    code: 'HN',
    name: 'Honduras',
    phone: '504',
  },
  {
    code: 'HK',
    name: 'Hong Kong',
    phone: '852',
  },
  {
    code: 'HU',
    name: 'Hungary',
    phone: '36',
  },
  {
    code: 'IS',
    name: 'Iceland',
    phone: '354',
  },
  {
    code: 'IN',
    name: 'India',
    phone: '91',
  },
  {
    code: 'ID',
    name: 'Indonesia',
    phone: '62',
  },
  {
    code: 'IR',
    name: 'Iran, Islamic Republic of',
    phone: '98',
  },
  {
    code: 'IQ',
    name: 'Iraq',
    phone: '964',
  },
  {
    code: 'IE',
    name: 'Ireland',
    phone: '353',
  },
  {
    code: 'IM',
    name: 'Isle of Man',
    phone: '44',
  },
  {
    code: 'IL',
    name: 'Israel',
    phone: '972',
  },
  {
    code: 'IT',
    name: 'Italy',
    numberFormat: {
      code: 'it-IT',
      currency: 'EUR',
    },
    phone: '39',
  },
  {
    code: 'JM',
    name: 'Jamaica',
    phone: '1-876',
  },
  {
    code: 'JP',
    name: 'Japan',
    numberFormat: {
      code: 'ja-JP',
      currency: 'JPY',
    },
    phone: '81',
    suggested: true,
  },
  {
    code: 'JE',
    name: 'Jersey',
    phone: '44',
  },
  {
    code: 'JO',
    name: 'Jordan',
    phone: '962',
  },
  {
    code: 'KZ',
    name: 'Kazakhstan',
    phone: '7',
  },
  {
    code: 'KE',
    name: 'Kenya',
    phone: '254',
  },
  {
    code: 'KI',
    name: 'Kiribati',
    phone: '686',
  },
  {
    code: 'KP',
    name: "Korea, Democratic People's Republic of",
    phone: '850',
  },
  {
    code: 'KR',
    name: 'Korea, Republic of',
    phone: '82',
  },
  {
    code: 'XK',
    name: 'Kosovo',
    phone: '383',
  },
  {
    code: 'KW',
    name: 'Kuwait',
    phone: '965',
  },
  {
    code: 'KG',
    name: 'Kyrgyzstan',
    phone: '996',
  },
  {
    code: 'LA',
    name: "Lao People's Democratic Republic",
    phone: '856',
  },
  {
    code: 'LV',
    name: 'Latvia',
    phone: '371',
  },
  {
    code: 'LB',
    name: 'Lebanon',
    phone: '961',
  },
  {
    code: 'LS',
    name: 'Lesotho',
    phone: '266',
  },
  {
    code: 'LR',
    name: 'Liberia',
    phone: '231',
  },
  {
    code: 'LY',
    name: 'Libya',
    phone: '218',
  },
  {
    code: 'LI',
    name: 'Liechtenstein',
    phone: '423',
  },
  {
    code: 'LT',
    name: 'Lithuania',
    phone: '370',
  },
  {
    code: 'LU',
    name: 'Luxembourg',
    phone: '352',
  },
  {
    code: 'MO',
    name: 'Macao',
    phone: '853',
  },
  {
    code: 'MK',
    name: 'Macedonia, the Former Yugoslav Republic of',
    phone: '389',
  },
  {
    code: 'MG',
    name: 'Madagascar',
    phone: '261',
  },
  {
    code: 'MW',
    name: 'Malawi',
    phone: '265',
  },
  {
    code: 'MY',
    name: 'Malaysia',
    phone: '60',
  },
  {
    code: 'MV',
    name: 'Maldives',
    phone: '960',
  },
  {
    code: 'ML',
    name: 'Mali',
    phone: '223',
  },
  {
    code: 'MT',
    name: 'Malta',
    phone: '356',
  },
  {
    code: 'MH',
    name: 'Marshall Islands',
    phone: '692',
  },
  {
    code: 'MQ',
    name: 'Martinique',
    phone: '596',
  },
  {
    code: 'MR',
    name: 'Mauritania',
    phone: '222',
  },
  {
    code: 'MU',
    name: 'Mauritius',
    phone: '230',
  },
  {
    code: 'YT',
    name: 'Mayotte',
    phone: '262',
  },
  {
    code: 'MX',
    name: 'Mexico',
    phone: '52',
  },
  {
    code: 'FM',
    name: 'Micronesia, Federated States of',
    phone: '691',
  },
  {
    code: 'MD',
    name: 'Moldova, Republic of',
    phone: '373',
  },
  {
    code: 'MC',
    name: 'Monaco',
    phone: '377',
  },
  {
    code: 'MN',
    name: 'Mongolia',
    phone: '976',
  },
  {
    code: 'ME',
    name: 'Montenegro',
    phone: '382',
  },
  {
    code: 'MS',
    name: 'Montserrat',
    phone: '1-664',
  },
  {
    code: 'MA',
    name: 'Morocco',
    phone: '212',
  },
  {
    code: 'MZ',
    name: 'Mozambique',
    phone: '258',
  },
  {
    code: 'MM',
    name: 'Myanmar',
    phone: '95',
  },
  {
    code: 'NA',
    name: 'Namibia',
    phone: '264',
  },
  {
    code: 'NR',
    name: 'Nauru',
    phone: '674',
  },
  {
    code: 'NP',
    name: 'Nepal',
    phone: '977',
  },
  {
    code: 'NL',
    name: 'Netherlands',
    phone: '31',
  },
  {
    code: 'NC',
    name: 'New Caledonia',
    phone: '687',
  },
  {
    code: 'NZ',
    name: 'New Zealand',
    phone: '64',
  },
  {
    code: 'NI',
    name: 'Nicaragua',
    phone: '505',
  },
  {
    code: 'NE',
    name: 'Niger',
    phone: '227',
  },
  {
    code: 'NG',
    name: 'Nigeria',
    phone: '234',
  },
  {
    code: 'NU',
    name: 'Niue',
    phone: '683',
  },
  {
    code: 'NF',
    name: 'Norfolk Island',
    phone: '672',
  },
  {
    code: 'MP',
    name: 'Northern Mariana Islands',
    phone: '1-670',
  },
  {
    code: 'NO',
    name: 'Norway',
    phone: '47',
  },
  {
    code: 'OM',
    name: 'Oman',
    phone: '968',
  },
  {
    code: 'PK',
    name: 'Pakistan',
    phone: '92',
  },
  {
    code: 'PW',
    name: 'Palau',
    phone: '680',
  },
  {
    code: 'PS',
    name: 'Palestine, State of',
    phone: '970',
  },
  {
    code: 'PA',
    name: 'Panama',
    phone: '507',
  },
  {
    code: 'PG',
    name: 'Papua New Guinea',
    phone: '675',
  },
  {
    code: 'PY',
    name: 'Paraguay',
    phone: '595',
  },
  {
    code: 'PE',
    keywords: ['Peru'],
    name: 'Perú',
    numberFormat: {
      code: 'es-PE',
      currency: 'PEN',
    },
    phone: '51',
    states: [
      {
        cities: [
          {
            name: 'Aramango',
            zipCode: '01800',
          },
          {
            name: 'Asuncion',
            zipCode: '01230',
          },
          {
            name: 'Bagua',
            zipCode: '01720',
          },
          {
            name: 'Bagua Grande',
            zipCode: '01620',
          },
          {
            name: 'Balsas',
            zipCode: '01475',
          },
          {
            name: 'Cajaruro',
            zipCode: '01700',
          },
          {
            name: 'Camporredondo',
            zipCode: '01550',
          },
          {
            name: 'Chachapoyas',
            zipCode: '01001',
          },
          {
            name: 'Cheto',
            zipCode: '01315',
          },
          {
            name: 'Chiliquin',
            zipCode: '01220',
          },
          {
            name: 'Chiriaco',
            zipCode: '01810',
          },
          {
            name: 'Chirimoto',
            zipCode: '01380',
          },
          {
            name: 'Chisquilla',
            zipCode: '01260',
          },
          {
            name: 'Chuquibamba',
            zipCode: '01470',
          },
          {
            name: 'Churuja',
            zipCode: '01110',
          },
          {
            name: 'Cocabamba',
            zipCode: '01480',
          },
          {
            name: 'Cochamal',
            zipCode: '01350',
          },
          {
            name: 'Cohechan',
            zipCode: '01530',
          },
          {
            name: 'Colcamar',
            zipCode: '01420',
          },
          {
            name: 'Collonce',
            zipCode: '01535',
          },
          {
            name: 'Copallin',
            zipCode: '01710',
          },
          {
            name: 'Corosha',
            zipCode: '01270',
          },
          {
            name: 'Cuispes',
            zipCode: '01140',
          },
          {
            name: 'Cumba',
            zipCode: '01565',
          },
          {
            name: 'Daguas',
            zipCode: '01310',
          },
          {
            name: 'Duraznopampa',
            zipCode: '01455',
          },
          {
            name: 'El Milagro',
            zipCode: '01630',
          },
          {
            name: 'El Parco',
            zipCode: '01730',
          },
          {
            name: 'Florida',
            zipCode: '01150',
          },
          {
            name: 'Granada',
            zipCode: '01200',
          },
          {
            name: 'Huambo',
            zipCode: '01355',
          },
          {
            name: 'Huampami',
            zipCode: '01820',
          },
          {
            name: 'Huancas',
            zipCode: '01000',
          },
          {
            name: 'Inguilpata',
            zipCode: '01505',
          },
          {
            name: 'Jamalca',
            zipCode: '01610',
          },
          {
            name: 'Jumbilla',
            zipCode: '01250',
          },
          {
            name: 'La Jalca',
            zipCode: '01440',
          },
          {
            name: 'La Peca',
            zipCode: '01740',
          },
          {
            name: 'Lamud',
            zipCode: '01515',
          },
          {
            name: 'Leimebamba',
            zipCode: '01465',
          },
          {
            name: 'Levanto',
            zipCode: '01400',
          },
          {
            name: 'Limabamba',
            zipCode: '01370',
          },
          {
            name: 'Longar',
            zipCode: '01345',
          },
          {
            name: 'Longuita',
            zipCode: '01425',
          },
          {
            name: 'Lonya Chico',
            zipCode: '01500',
          },
          {
            name: 'Lonya Grande',
            zipCode: '01555',
          },
          {
            name: 'Luya',
            zipCode: '01510',
          },
          {
            name: 'Luya Viejo',
            zipCode: '01575',
          },
          {
            name: 'Magdalena',
            zipCode: '01410',
          },
          {
            name: 'Maino',
            zipCode: '01405',
          },
          {
            name: 'Maria',
            zipCode: '01430',
          },
          {
            name: 'Mariscal Benavides',
            zipCode: '01330',
          },
          {
            name: 'Mendoza',
            zipCode: '01335',
          },
          {
            name: 'Milpuc',
            zipCode: '01375',
          },
          {
            name: 'Molinopampa',
            zipCode: '01320',
          },
          {
            name: 'Montevideo',
            zipCode: '01460',
          },
          {
            name: 'Ocalli',
            zipCode: '01545',
          },
          {
            name: 'Olleros',
            zipCode: '01280',
          },
          {
            name: 'Olto',
            zipCode: '01520',
          },
          {
            name: 'Omia',
            zipCode: '01340',
          },
          {
            name: 'Paclas',
            zipCode: '01525',
          },
          {
            name: 'Pedro Ruiz Gallo',
            zipCode: '01130',
          },
          {
            name: 'Providencia',
            zipCode: '01540',
          },
          {
            name: 'Puerto Galilea',
            zipCode: '01840',
          },
          {
            name: 'Quinjalca',
            zipCode: '01210',
          },
          {
            name: 'Recta',
            zipCode: '01240',
          },
          {
            name: 'San Carlos',
            zipCode: '01120',
          },
          {
            name: 'San Francisco del Yeso',
            zipCode: '01450',
          },
          {
            name: 'San Juan de Lopecancha',
            zipCode: '01435',
          },
          {
            name: 'San Juan de Sonche',
            zipCode: '01300',
          },
          {
            name: 'Santa Catalina',
            zipCode: '01580',
          },
          {
            name: 'Santa Maria de Nieva',
            zipCode: '01830',
          },
          {
            name: 'Santa Rosa de Huayabamba',
            zipCode: '01360',
          },
          {
            name: 'Santo Tomas',
            zipCode: '01445',
          },
          {
            name: 'Shipasbamba',
            zipCode: '01600',
          },
          {
            name: 'Soloco',
            zipCode: '01305',
          },
          {
            name: 'Tingo',
            zipCode: '01415',
          },
          {
            name: 'Totora',
            zipCode: '01365',
          },
          {
            name: 'Trita',
            zipCode: '01570',
          },
          {
            name: 'Valera',
            zipCode: '01100',
          },
          {
            name: 'Vista Alegre',
            zipCode: '01325',
          },
          {
            name: 'Yambrasbamba',
            zipCode: '01160',
          },
          {
            name: 'Yamon',
            zipCode: '01560',
          },
          {
            name: 'Yomblon',
            zipCode: '01485',
          },
        ],
        name: 'Amazonas',
      },
      {
        cities: [
          {
            name: 'Acas',
            zipCode: '02470',
          },
          {
            name: 'Aco',
            zipCode: '02115',
          },
          {
            name: 'Acobamba',
            zipCode: '02235',
          },
          {
            name: 'Acochaca',
            zipCode: '02314',
          },
          {
            name: 'Acopampa',
            zipCode: '02123',
          },
          {
            name: 'Aczo',
            zipCode: '02340',
          },
          {
            name: 'Aija',
            zipCode: '02610',
          },
          {
            name: 'Amashca',
            zipCode: '02130',
          },
          {
            name: 'Anra',
            zipCode: '02358',
          },
          {
            name: 'Anta',
            zipCode: '02105',
          },
          {
            name: 'Aquia',
            zipCode: '02420',
          },
          {
            name: 'Bambas',
            zipCode: '02205',
          },
          {
            name: 'Bolognesi',
            zipCode: '02830',
          },
          {
            name: 'Buena Vista Alta',
            zipCode: '02670',
          },
          {
            name: 'Buenos Aires',
            zipCode: '02710',
          },
          {
            name: 'Cabana',
            zipCode: '02850',
          },
          {
            name: 'Cajacay',
            zipCode: '02485',
          },
          {
            name: 'Cajamarquilla',
            zipCode: '02603',
          },
          {
            name: 'Cajay',
            zipCode: '02305',
          },
          {
            name: 'Caleta Culebras',
            zipCode: '02655',
          },
          {
            name: 'Canis',
            zipCode: '02445',
          },
          {
            name: 'Caraz',
            zipCode: '02165',
          },
          {
            name: 'Carhuac',
            zipCode: '02139',
          },
          {
            name: 'Carhuaz',
            zipCode: '02125',
          },
          {
            name: 'Casca',
            zipCode: '02264',
          },
          {
            name: 'Cascapara',
            zipCode: '02145',
          },
          {
            name: 'Cashapampa',
            zipCode: '02225',
          },
          {
            name: 'Casma',
            zipCode: '02660',
          },
          {
            name: 'Catac',
            zipCode: '02410',
          },
          {
            name: 'Centenario',
            zipCode: '02000',
          },
          {
            name: 'Chacas',
            zipCode: '02315',
          },
          {
            name: 'Chaccho',
            zipCode: '02348',
          },
          {
            name: 'Chana',
            zipCode: '02333',
          },
          {
            name: 'Chasquitambo',
            zipCode: '02500',
          },
          {
            name: 'Chavin de Huantar',
            zipCode: '02395',
          },
          {
            name: 'Chimbote',
            zipCode: '02800',
          },
          {
            name: 'Chingalpo',
            zipCode: '02240',
          },
          {
            name: 'Chingas',
            zipCode: '02342',
          },
          {
            name: 'Chiquian',
            zipCode: '02413',
          },
          {
            name: 'Chullin',
            zipCode: '02249',
          },
          {
            name: 'Cochabamba',
            zipCode: '02690',
          },
          {
            name: 'Cochapeti',
            zipCode: '02630',
          },
          {
            name: 'Coishco',
            zipCode: '02810',
          },
          {
            name: 'Colcabamba',
            zipCode: '02695',
          },
          {
            name: 'Conchucos',
            zipCode: '02875',
          },
          {
            name: 'Congas',
            zipCode: '02530',
          },
          {
            name: 'Copa',
            zipCode: '02520',
          },
          {
            name: 'Coris',
            zipCode: '02621',
          },
          {
            name: 'Corongo',
            zipCode: '02218',
          },
          {
            name: 'Corpanqui',
            zipCode: '02432',
          },
          {
            name: 'Cotaparaco',
            zipCode: '02633',
          },
          {
            name: 'Cusca',
            zipCode: '02210',
          },
          {
            name: 'Gorgorillo',
            zipCode: '02440',
          },
          {
            name: 'Huacachi',
            zipCode: '02355',
          },
          {
            name: 'Huacaschuque',
            zipCode: '02860',
          },
          {
            name: 'Huacchis',
            zipCode: '02380',
          },
          {
            name: 'Huachis',
            zipCode: '02320',
          },
          {
            name: 'Huacllan',
            zipCode: '02625',
          },
          {
            name: 'Huallanca',
            zipCode: '02422',
          },
          {
            name: 'Huanchay',
            zipCode: '02607',
          },
          {
            name: 'Huandoval',
            zipCode: '02855',
          },
          {
            name: 'Huantar',
            zipCode: '02300',
          },
          {
            name: 'Huaraz',
            zipCode: '02001',
          },
          {
            name: 'Huari',
            zipCode: '02303',
          },
          {
            name: 'Huaripampa',
            zipCode: '02174',
          },
          {
            name: 'Huarmey',
            zipCode: '02650',
          },
          {
            name: 'Huasta',
            zipCode: '02415',
          },
          {
            name: 'Huata',
            zipCode: '02175',
          },
          {
            name: 'Huayan',
            zipCode: '02618',
          },
          {
            name: 'Huaylas',
            zipCode: '02185',
          },
          {
            name: 'Huayllabamba',
            zipCode: '02230',
          },
          {
            name: 'Huayllacayan',
            zipCode: '02510',
          },
          {
            name: 'Huayllan',
            zipCode: '02295',
          },
          {
            name: 'Huayllapampa',
            zipCode: '02495',
          },
          {
            name: 'Jangas',
            zipCode: '02100',
          },
          {
            name: 'Jimbe',
            zipCode: '02740',
          },
          {
            name: 'La Merced',
            zipCode: '02613',
          },
          {
            name: 'La Pampa',
            zipCode: '02200',
          },
          {
            name: 'Lacabamba',
            zipCode: '02870',
          },
          {
            name: 'Llaclla',
            zipCode: '02435',
          },
          {
            name: 'Llacllin',
            zipCode: '02645',
          },
          {
            name: 'Llama',
            zipCode: '02275',
          },
          {
            name: 'Llamellin',
            zipCode: '02345',
          },
          {
            name: 'Llapo',
            zipCode: '02840',
          },
          {
            name: 'Llipa',
            zipCode: '02455',
          },
          {
            name: 'Llumpa',
            zipCode: '02289',
          },
          {
            name: 'Lucma',
            zipCode: '02290',
          },
          {
            name: 'Macate',
            zipCode: '02820',
          },
          {
            name: 'Malvas',
            zipCode: '02627',
          },
          {
            name: 'Mancos',
            zipCode: '02148',
          },
          {
            name: 'Mangas',
            zipCode: '02441',
          },
          {
            name: 'Marca',
            zipCode: '02490',
          },
          {
            name: 'Marcara',
            zipCode: '02109',
          },
          {
            name: 'Masin',
            zipCode: '02324',
          },
          {
            name: 'Matacoto',
            zipCode: '02155',
          },
          {
            name: 'Mirgas',
            zipCode: '02350',
          },
          {
            name: 'Moro',
            zipCode: '02730',
          },
          {
            name: 'Musga',
            zipCode: '02273',
          },
          {
            name: 'Nepeña',
            zipCode: '02720',
          },
          {
            name: 'Ocros',
            zipCode: '02460',
          },
          {
            name: 'Olleros',
            zipCode: '02400',
          },
          {
            name: 'Pacllon',
            zipCode: '02426',
          },
          {
            name: 'Pallasca',
            zipCode: '02835',
          },
          {
            name: 'Pampachacra',
            zipCode: '02279',
          },
          {
            name: 'Pamparomas',
            zipCode: '02180',
          },
          {
            name: 'Pampas',
            zipCode: '02605',
          },
          {
            name: 'Pampas Chico',
            zipCode: '02483',
          },
          {
            name: 'Pararin',
            zipCode: '02640',
          },
          {
            name: 'Pariacoto',
            zipCode: '02685',
          },
          {
            name: 'Pariahuanca',
            zipCode: '02113',
          },
          {
            name: 'Parobamba',
            zipCode: '02250',
          },
          {
            name: 'Paucas',
            zipCode: '02375',
          },
          {
            name: 'Pira',
            zipCode: '02600',
          },
          {
            name: 'Piscobamba',
            zipCode: '02265',
          },
          {
            name: 'Pomabamba',
            zipCode: '02260',
          },
          {
            name: 'Ponto',
            zipCode: '02330',
          },
          {
            name: 'Puerto Casma',
            zipCode: '02665',
          },
          {
            name: 'Quiches',
            zipCode: '02234',
          },
          {
            name: 'Quillo',
            zipCode: '02675',
          },
          {
            name: 'Quinuabamba',
            zipCode: '02258',
          },
          {
            name: 'Ragash',
            zipCode: '02228',
          },
          {
            name: 'Rahuapampa',
            zipCode: '02325',
          },
          {
            name: 'Rajan',
            zipCode: '02450',
          },
          {
            name: 'Ranrahirca',
            zipCode: '02152',
          },
          {
            name: 'Rapayan',
            zipCode: '02385',
          },
          {
            name: 'Raquia',
            zipCode: '02489',
          },
          {
            name: 'Recuay',
            zipCode: '02403',
          },
          {
            name: 'Samanco',
            zipCode: '02700',
          },
          {
            name: 'San Juan',
            zipCode: '02170',
          },
          {
            name: 'San Juan de Rontoy',
            zipCode: '02335',
          },
          {
            name: 'San Luis',
            zipCode: '02310',
          },
          {
            name: 'San Marcos',
            zipCode: '02390',
          },
          {
            name: 'San Nicolas',
            zipCode: '02285',
          },
          {
            name: 'Sanachgan',
            zipCode: '02270',
          },
          {
            name: 'Santa',
            zipCode: '02815',
          },
          {
            name: 'Santa Rosa',
            zipCode: '02825',
          },
          {
            name: 'Santiago de Chilcas',
            zipCode: '02465',
          },
          {
            name: 'Santo Toribio',
            zipCode: '02190',
          },
          {
            name: 'Shilla',
            zipCode: '02133',
          },
          {
            name: 'Shupluy',
            zipCode: '02140',
          },
          {
            name: 'Sihuas',
            zipCode: '02220',
          },
          {
            name: 'Succha',
            zipCode: '02616',
          },
          {
            name: 'Sucre',
            zipCode: '02184',
          },
          {
            name: 'Tapacocha',
            zipCode: '02635',
          },
          {
            name: 'Tarica',
            zipCode: '02119',
          },
          {
            name: 'Tauca',
            zipCode: '02845',
          },
          {
            name: 'Ticapampa',
            zipCode: '02407',
          },
          {
            name: 'Ticllos',
            zipCode: '02430',
          },
          {
            name: 'Tinco',
            zipCode: '02135',
          },
          {
            name: 'Uco',
            zipCode: '02370',
          },
          {
            name: 'Ullulluco',
            zipCode: '02245',
          },
          {
            name: 'Umbe',
            zipCode: '02243',
          },
          {
            name: 'Yanac',
            zipCode: '02209',
          },
          {
            name: 'Yanama',
            zipCode: '02162',
          },
          {
            name: 'Yautan',
            zipCode: '02680',
          },
          {
            name: 'Yauya',
            zipCode: '02280',
          },
          {
            name: 'Yungar',
            zipCode: '02103',
          },
          {
            name: 'Yungay',
            zipCode: '02158',
          },
          {
            name: 'Yupan',
            zipCode: '02203',
          },
          {
            name: 'Yuracmarca',
            zipCode: '02195',
          },
        ],
        name: 'Ancash',
      },
      {
        cities: [
          {
            name: 'Abancay',
            zipCode: '03000',
          },
          {
            name: 'Andahuaylas',
            zipCode: '03700',
          },
          {
            name: 'Andarapa',
            zipCode: '03740',
          },
          {
            name: 'Antabamba',
            zipCode: '03465',
          },
          {
            name: 'Ayahuay',
            zipCode: '03450',
          },
          {
            name: 'Ayrihuanca',
            zipCode: '03325',
          },
          {
            name: 'Cachora',
            zipCode: '03110',
          },
          {
            name: 'Capaya',
            zipCode: '03520',
          },
          {
            name: 'Caraybamba',
            zipCode: '03570',
          },
          {
            name: 'Chaccrampa',
            zipCode: '03640',
          },
          {
            name: 'Chacoche',
            zipCode: '03405',
          },
          {
            name: 'Chalhuanca',
            zipCode: '03560',
          },
          {
            name: 'Challhuahuacho',
            zipCode: '03260',
          },
          {
            name: 'Chapimarca',
            zipCode: '03425',
          },
          {
            name: 'Chiara',
            zipCode: '03650',
          },
          {
            name: 'Chincheros',
            zipCode: '03850',
          },
          {
            name: 'Chuquibambilla',
            zipCode: '03310',
          },
          {
            name: 'Circa',
            zipCode: '03305',
          },
          {
            name: 'Cocharcas',
            zipCode: '03820',
          },
          {
            name: 'Colcabamba',
            zipCode: '03500',
          },
          {
            name: 'Cotabambas',
            zipCode: '03230',
          },
          {
            name: 'Cotaruse',
            zipCode: '03580',
          },
          {
            name: 'Coyllurqui',
            zipCode: '03220',
          },
          {
            name: 'Curahuasi',
            zipCode: '03100',
          },
          {
            name: 'Curasco',
            zipCode: '03290',
          },
          {
            name: 'Curpahuasi',
            zipCode: '03315',
          },
          {
            name: 'Haquira',
            zipCode: '03270',
          },
          {
            name: 'Huaccana',
            zipCode: '03880',
          },
          {
            name: 'Huancarama',
            zipCode: '03780',
          },
          {
            name: 'Huancaray',
            zipCode: '03670',
          },
          {
            name: 'Huanipaca',
            zipCode: '03120',
          },
          {
            name: 'Huaquirca',
            zipCode: '03470',
          },
          {
            name: 'Huayana',
            zipCode: '03630',
          },
          {
            name: 'Huayllati',
            zipCode: '03210',
          },
          {
            name: 'Huayllo',
            zipCode: '03530',
          },
          {
            name: 'Kaquiabamba',
            zipCode: '03750',
          },
          {
            name: 'Kishuara',
            zipCode: '03760',
          },
          {
            name: 'Lambrama',
            zipCode: '03300',
          },
          {
            name: 'Lucre',
            zipCode: '03415',
          },
          {
            name: 'Mamara',
            zipCode: '03335',
          },
          {
            name: 'Mara',
            zipCode: '03250',
          },
          {
            name: 'Mollebamba',
            zipCode: '03475',
          },
          {
            name: 'Ocobamba',
            zipCode: '03860',
          },
          {
            name: 'Ongoy',
            zipCode: '03870',
          },
          {
            name: 'Oropesa',
            zipCode: '03340',
          },
          {
            name: 'Pachaconas',
            zipCode: '03455',
          },
          {
            name: 'Pacobamba',
            zipCode: '03770',
          },
          {
            name: 'Pacucha',
            zipCode: '03730',
          },
          {
            name: 'Palpacachi',
            zipCode: '03200',
          },
          {
            name: 'Pampachiri',
            zipCode: '03600',
          },
          {
            name: 'Pataypampa',
            zipCode: '03350',
          },
          {
            name: 'Pichihua',
            zipCode: '03430',
          },
          {
            name: 'Pichirhua',
            zipCode: '03400',
          },
          {
            name: 'Pocohuanca',
            zipCode: '03445',
          },
          {
            name: 'Pomacocha',
            zipCode: '03610',
          },
          {
            name: 'Progreso',
            zipCode: '03280',
          },
          {
            name: 'Ranracancha',
            zipCode: '03830',
          },
          {
            name: 'Sabaino',
            zipCode: '03460',
          },
          {
            name: 'San Antonio',
            zipCode: '03330',
          },
          {
            name: 'San Antonio de Cachi',
            zipCode: '03660',
          },
          {
            name: 'San Jeronimo',
            zipCode: '03701',
          },
          {
            name: 'San Juan de Chacña',
            zipCode: '03420',
          },
          {
            name: 'San Juan de Virundo',
            zipCode: '03360',
          },
          {
            name: 'Santa Maria de Chicmo',
            zipCode: '03800',
          },
          {
            name: 'Santa Rosa',
            zipCode: '03345',
          },
          {
            name: 'Sañayca',
            zipCode: '03550',
          },
          {
            name: 'Soraya',
            zipCode: '03540',
          },
          {
            name: 'Talavera',
            zipCode: '03702',
          },
          {
            name: 'Tambobamba',
            zipCode: '03240',
          },
          {
            name: 'Tamburco',
            zipCode: '03001',
          },
          {
            name: 'Tapairihua',
            zipCode: '03435',
          },
          {
            name: 'Tintay',
            zipCode: '03410',
          },
          {
            name: 'Toraya',
            zipCode: '03510',
          },
          {
            name: 'Turpay',
            zipCode: '03355',
          },
          {
            name: 'Turpo',
            zipCode: '03680',
          },
          {
            name: 'Umamarca',
            zipCode: '03620',
          },
          {
            name: 'Uranmarca',
            zipCode: '03810',
          },
          {
            name: 'Uripa',
            zipCode: '03840',
          },
          {
            name: 'Vilcabamba',
            zipCode: '03320',
          },
          {
            name: 'Yanaca',
            zipCode: '03440',
          },
        ],
        name: 'Apurimac',
      },
      {
        cities: [
          {
            name: 'Acari',
            zipCode: '04550',
          },
          {
            name: 'Achanizo',
            zipCode: '04580',
          },
          {
            name: 'Achoma',
            zipCode: '04135',
          },
          {
            name: 'Alca',
            zipCode: '04830',
          },
          {
            name: 'Andagua',
            zipCode: '04640',
          },
          {
            name: 'Andaray',
            zipCode: '04720',
          },
          {
            name: 'Aplao',
            zipCode: '04605',
          },
          {
            name: 'Arequipa',
            zipCode: '04001',
          },
          {
            name: 'Atico',
            zipCode: '04475',
          },
          {
            name: 'Atiquipa',
            zipCode: '04520',
          },
          {
            name: 'Ayo',
            zipCode: '04645',
          },
          {
            name: 'Bella Union',
            zipCode: '04560',
          },
          {
            name: 'Cabanaconde',
            zipCode: '04124',
          },
          {
            name: 'Cahuacho',
            zipCode: '04750',
          },
          {
            name: 'Callalli',
            zipCode: '04180',
          },
          {
            name: 'Camana',
            zipCode: '04450',
          },
          {
            name: 'Caraveli',
            zipCode: '04740',
          },
          {
            name: 'Cayarani',
            zipCode: '04195',
          },
          {
            name: 'Caylloma',
            zipCode: '04190',
          },
          {
            name: 'Cayma',
            zipCode: '04018',
          },
          {
            name: 'Chachas',
            zipCode: '04660',
          },
          {
            name: 'Chala',
            zipCode: '04500',
          },
          {
            name: 'Characato',
            zipCode: '04000',
          },
          {
            name: 'Charcana',
            zipCode: '04850',
          },
          {
            name: 'Chichas',
            zipCode: '04805',
          },
          {
            name: 'Chiguata',
            zipCode: '04200',
          },
          {
            name: 'Chilcaymarca',
            zipCode: '04650',
          },
          {
            name: 'Chivay',
            zipCode: '04145',
          },
          {
            name: 'Choco',
            zipCode: '04665',
          },
          {
            name: 'Chuquibamba',
            zipCode: '04710',
          },
          {
            name: 'Ciudad Satelite',
            zipCode: '04008',
          },
          {
            name: 'Cocachacra',
            zipCode: '04430',
          },
          {
            name: 'Coporaque',
            zipCode: '04150',
          },
          {
            name: 'Corire',
            zipCode: '04600',
          },
          {
            name: 'Cotahuasi',
            zipCode: '04810',
          },
          {
            name: 'El Cardo',
            zipCode: '04460',
          },
          {
            name: 'El Pedregal',
            zipCode: '04110',
          },
          {
            name: 'Huambo',
            zipCode: '04120',
          },
          {
            name: 'Huanca',
            zipCode: '04118',
          },
          {
            name: 'Huancarqui',
            zipCode: '04610',
          },
          {
            name: 'Ichupampa',
            zipCode: '04155',
          },
          {
            name: 'Imata',
            zipCode: '04220',
          },
          {
            name: 'Iquipi',
            zipCode: '04770',
          },
          {
            name: 'Iray',
            zipCode: '04700',
          },
          {
            name: 'Islay',
            zipCode: '04410',
          },
          {
            name: 'Jacobo Hunter',
            zipCode: '04011',
          },
          {
            name: 'Jaqui',
            zipCode: '04540',
          },
          {
            name: 'La Curva',
            zipCode: '04425',
          },
          {
            name: 'La Joya',
            zipCode: '04405',
          },
          {
            name: 'La Libertad',
            zipCode: '04013',
          },
          {
            name: 'La Pampa',
            zipCode: '04445',
          },
          {
            name: 'Lari',
            zipCode: '04160',
          },
          {
            name: 'Lluta',
            zipCode: '04115',
          },
          {
            name: 'Lomas',
            zipCode: '04570',
          },
          {
            name: 'Maca',
            zipCode: '04130',
          },
          {
            name: 'Machahuay',
            zipCode: '04630',
          },
          {
            name: 'Madrigal',
            zipCode: '04165',
          },
          {
            name: 'Mariano Melgar',
            zipCode: '04006',
          },
          {
            name: 'Mejia',
            zipCode: '04420',
          },
          {
            name: 'Miraflores',
            zipCode: '04004',
          },
          {
            name: 'Mollebaya',
            zipCode: '04300',
          },
          {
            name: 'Mollendo',
            zipCode: '04415',
          },
          {
            name: 'Mungui',
            zipCode: '04815',
          },
          {
            name: 'Ocoña',
            zipCode: '04470',
          },
          {
            name: 'Orcopampa',
            zipCode: '04655',
          },
          {
            name: 'Pampacolca',
            zipCode: '04620',
          },
          {
            name: 'Paucarpata',
            zipCode: '04007',
          },
          {
            name: 'Pocsi',
            zipCode: '04310',
          },
          {
            name: 'Polobaya Grande',
            zipCode: '04320',
          },
          {
            name: 'Punta de Bombon',
            zipCode: '04435',
          },
          {
            name: 'Puyca',
            zipCode: '04835',
          },
          {
            name: 'Quequeña',
            zipCode: '04340',
          },
          {
            name: 'Quicacha',
            zipCode: '04590',
          },
          {
            name: 'Quilca',
            zipCode: '04440',
          },
          {
            name: 'Sabandia',
            zipCode: '04014',
          },
          {
            name: 'Sachaca',
            zipCode: '04002',
          },
          {
            name: 'Salamanca',
            zipCode: '04800',
          },
          {
            name: 'San Gregorio',
            zipCode: '04455',
          },
          {
            name: 'San Jose',
            zipCode: '04465',
          },
          {
            name: 'Santa Isabel de Siguas',
            zipCode: '04108',
          },
          {
            name: 'Santa Rita de Siguas',
            zipCode: '04102',
          },
          {
            name: 'Sayla',
            zipCode: '04855',
          },
          {
            name: 'Selva Alegre',
            zipCode: '04003',
          },
          {
            name: 'Sibayo',
            zipCode: '04175',
          },
          {
            name: 'Socabaya',
            zipCode: '04009',
          },
          {
            name: 'Tambillo',
            zipCode: '04105',
          },
          {
            name: 'Tapay',
            zipCode: '04125',
          },
          {
            name: 'Tarucani',
            zipCode: '04210',
          },
          {
            name: 'Tauria',
            zipCode: '04860',
          },
          {
            name: 'Taurisma',
            zipCode: '04820',
          },
          {
            name: 'Tiabaya',
            zipCode: '04016',
          },
          {
            name: 'Tipan',
            zipCode: '04615',
          },
          {
            name: 'Tisco',
            zipCode: '04185',
          },
          {
            name: 'Tocota',
            zipCode: '04510',
          },
          {
            name: 'Tomepampa',
            zipCode: '04825',
          },
          {
            name: 'Toro',
            zipCode: '04840',
          },
          {
            name: 'Tuti',
            zipCode: '04170',
          },
          {
            name: 'Uchumayo',
            zipCode: '04400',
          },
          {
            name: 'Urasqui',
            zipCode: '04760',
          },
          {
            name: 'Uñon',
            zipCode: '04635',
          },
          {
            name: 'Velinga',
            zipCode: '04845',
          },
          {
            name: 'Viraco',
            zipCode: '04625',
          },
          {
            name: 'Vitor',
            zipCode: '04100',
          },
          {
            name: 'Yanahuara',
            zipCode: '04017',
          },
          {
            name: 'Yanaquihua',
            zipCode: '04730',
          },
          {
            name: 'Yanque',
            zipCode: '04140',
          },
          {
            name: 'Yarabamba',
            zipCode: '04330',
          },
          {
            name: 'Yauca',
            zipCode: '04530',
          },
          {
            name: 'Yura',
            zipCode: '04076',
          },
        ],
        name: 'Arequipa',
      },
      {
        cities: [
          {
            name: 'Accomarca',
            zipCode: '05390',
          },
          {
            name: 'Acocro',
            zipCode: '05305',
          },
          {
            name: 'Acos Vinchos',
            zipCode: '05180',
          },
          {
            name: 'Alcamenca',
            zipCode: '05405',
          },
          {
            name: 'Andamarca',
            zipCode: '05480',
          },
          {
            name: 'Aniso',
            zipCode: '05695',
          },
          {
            name: 'Apongo',
            zipCode: '05440',
          },
          {
            name: 'Asquipata',
            zipCode: '05445',
          },
          {
            name: 'Aucara',
            zipCode: '05470',
          },
          {
            name: 'Ayacucho',
            zipCode: '05003',
          },
          {
            name: 'Belen',
            zipCode: '05345',
          },
          {
            name: 'Cabana',
            zipCode: '05475',
          },
          {
            name: 'Canaria',
            zipCode: '05435',
          },
          {
            name: 'Cangallo',
            zipCode: '05400',
          },
          {
            name: 'Carapo',
            zipCode: '05700',
          },
          {
            name: 'Carhuanca',
            zipCode: '05340',
          },
          {
            name: 'Carmen',
            zipCode: '05000',
          },
          {
            name: 'Cayara',
            zipCode: '05420',
          },
          {
            name: 'Chalcos',
            zipCode: '05350',
          },
          {
            name: 'Chaviña',
            zipCode: '05600',
          },
          {
            name: 'Chiara',
            zipCode: '05315',
          },
          {
            name: 'Chilcas',
            zipCode: '05280',
          },
          {
            name: 'Chilcayoc',
            zipCode: '05355',
          },
          {
            name: 'Chipao',
            zipCode: '05485',
          },
          {
            name: 'Chiquintirca',
            zipCode: '05260',
          },
          {
            name: 'Chumpi',
            zipCode: '05615',
          },
          {
            name: 'Chungui',
            zipCode: '05270',
          },
          {
            name: 'Chuschi',
            zipCode: '05835',
          },
          {
            name: 'Colca',
            zipCode: '05425',
          },
          {
            name: 'Colta',
            zipCode: '05655',
          },
          {
            name: 'Concepcion',
            zipCode: '05330',
          },
          {
            name: 'Coracora',
            zipCode: '05610',
          },
          {
            name: 'Corculla',
            zipCode: '05670',
          },
          {
            name: 'HuacHuas',
            zipCode: '05760',
          },
          {
            name: 'Huacaña',
            zipCode: '05460',
          },
          {
            name: 'Huamanguilla',
            zipCode: '05170',
          },
          {
            name: 'Huamanquiquia',
            zipCode: '05855',
          },
          {
            name: 'Huambalpa',
            zipCode: '05385',
          },
          {
            name: 'Huanca Sancos',
            zipCode: '05710',
          },
          {
            name: 'Huancapi',
            zipCode: '05415',
          },
          {
            name: 'Huancaraylla',
            zipCode: '05410',
          },
          {
            name: 'Huanta',
            zipCode: '05120',
          },
          {
            name: 'Incuyo',
            zipCode: '05625',
          },
          {
            name: 'Lampa',
            zipCode: '05645',
          },
          {
            name: 'Laramate',
            zipCode: '05740',
          },
          {
            name: 'Las Nazarenas',
            zipCode: '05001',
          },
          {
            name: 'Llauta',
            zipCode: '05750',
          },
          {
            name: 'Llochegua',
            zipCode: '05230',
          },
          {
            name: 'Lucanas',
            zipCode: '05530',
          },
          {
            name: 'Luricocha',
            zipCode: '05130',
          },
          {
            name: 'Macachacra',
            zipCode: '05110',
          },
          {
            name: 'Marcabamba',
            zipCode: '05650',
          },
          {
            name: 'Morcolla',
            zipCode: '05455',
          },
          {
            name: 'Nuevo Paccha Huallhua',
            zipCode: '05395',
          },
          {
            name: 'Ocaña',
            zipCode: '05770',
          },
          {
            name: 'Ocros',
            zipCode: '05310',
          },
          {
            name: 'Otoca',
            zipCode: '05790',
          },
          {
            name: 'Oyolo',
            zipCode: '05660',
          },
          {
            name: 'Pacapausa',
            zipCode: '05685',
          },
          {
            name: 'Pacaycasa',
            zipCode: '05100',
          },
          {
            name: 'Paico',
            zipCode: '05365',
          },
          {
            name: 'Pampa Cangallo',
            zipCode: '05845',
          },
          {
            name: 'Pampas',
            zipCode: '05290',
          },
          {
            name: 'Pararca',
            zipCode: '05635',
          },
          {
            name: 'Paras',
            zipCode: '05820',
          },
          {
            name: 'Pausa',
            zipCode: '05640',
          },
          {
            name: 'Pomabamba',
            zipCode: '05840',
          },
          {
            name: 'Pullo',
            zipCode: '05620',
          },
          {
            name: 'Puquio',
            zipCode: '05500',
          },
          {
            name: 'Querobamba',
            zipCode: '05450',
          },
          {
            name: 'Quilcata',
            zipCode: '05630',
          },
          {
            name: 'Quinua',
            zipCode: '05160',
          },
          {
            name: 'Sacsamarca',
            zipCode: '05730',
          },
          {
            name: 'Saisa',
            zipCode: '05560',
          },
          {
            name: 'San Cristobal',
            zipCode: '05550',
          },
          {
            name: 'San Francisco',
            zipCode: '05210',
          },
          {
            name: 'San Francisco de Ravacayco',
            zipCode: '05680',
          },
          {
            name: 'San Javier de Alpabamba',
            zipCode: '05675',
          },
          {
            name: 'San Jose de Secce',
            zipCode: '05140',
          },
          {
            name: 'San Jose de Ushua',
            zipCode: '05665',
          },
          {
            name: 'San Juan',
            zipCode: '05520',
          },
          {
            name: 'San Juan Bautista',
            zipCode: '05002',
          },
          {
            name: 'San Miguel',
            zipCode: '05250',
          },
          {
            name: 'San Pedro',
            zipCode: '05510',
          },
          {
            name: 'San Pedro de Cachi',
            zipCode: '05800',
          },
          {
            name: 'San Pedro de Huaya',
            zipCode: '05430',
          },
          {
            name: 'San Pedro de Larcay',
            zipCode: '05380',
          },
          {
            name: 'San Pedro de Palco',
            zipCode: '05780',
          },
          {
            name: 'San Salvador de Quije',
            zipCode: '05360',
          },
          {
            name: 'Sancos',
            zipCode: '05605',
          },
          {
            name: 'Santa Ana de Huaycahuacho',
            zipCode: '05465',
          },
          {
            name: 'Santa Lucia',
            zipCode: '05570',
          },
          {
            name: 'Santa Rosa',
            zipCode: '05240',
          },
          {
            name: 'Santiago de Lucanamarca',
            zipCode: '05720',
          },
          {
            name: 'Santiago de Paucaray',
            zipCode: '05370',
          },
          {
            name: 'Sarhua',
            zipCode: '05850',
          },
          {
            name: 'Saurama',
            zipCode: '05335',
          },
          {
            name: 'Sivia',
            zipCode: '05220',
          },
          {
            name: 'Socos',
            zipCode: '05810',
          },
          {
            name: 'Soras',
            zipCode: '05375',
          },
          {
            name: 'Tambillo',
            zipCode: '05300',
          },
          {
            name: 'Tambo',
            zipCode: '05200',
          },
          {
            name: 'Tambo Quemado',
            zipCode: '05540',
          },
          {
            name: 'Ticllas',
            zipCode: '05805',
          },
          {
            name: 'Totos',
            zipCode: '05830',
          },
          {
            name: 'Upahuacho',
            zipCode: '05690',
          },
          {
            name: 'Vilcanchos',
            zipCode: '05825',
          },
          {
            name: 'Vilcas Huaman',
            zipCode: '05325',
          },
          {
            name: 'Vinchos',
            zipCode: '05815',
          },
          {
            name: 'Viracochan',
            zipCode: '05150',
          },
          {
            name: 'Vischongo',
            zipCode: '05320',
          },
        ],
        name: 'Ayacucho',
      },
      {
        cities: [
          {
            name: 'Agua Blanca',
            zipCode: '06470',
          },
          {
            name: 'Andabamba',
            zipCode: '06615',
          },
          {
            name: 'Anguia',
            zipCode: '06140',
          },
          {
            name: 'Asuncion',
            zipCode: '06403',
          },
          {
            name: 'Bambamarca',
            zipCode: '06115',
          },
          {
            name: 'Bellavista',
            zipCode: '06815',
          },
          {
            name: 'Bolivar',
            zipCode: '06520',
          },
          {
            name: 'Cachachi',
            zipCode: '06340',
          },
          {
            name: 'Cajabamba',
            zipCode: '06350',
          },
          {
            name: 'Cajamarca',
            zipCode: '06002',
          },
          {
            name: 'Callayuc',
            zipCode: '06710',
          },
          {
            name: 'Calquis',
            zipCode: '06460',
          },
          {
            name: 'Catache',
            zipCode: '06644',
          },
          {
            name: 'Catan',
            zipCode: '06430',
          },
          {
            name: 'Catilluc',
            zipCode: '06495',
          },
          {
            name: 'Cauday',
            zipCode: '06345',
          },
          {
            name: 'Celendin',
            zipCode: '06225',
          },
          {
            name: 'Chadin',
            zipCode: '06155',
          },
          {
            name: 'Chalamarca',
            zipCode: '06145',
          },
          {
            name: 'Chalan',
            zipCode: '06250',
          },
          {
            name: 'Chancay',
            zipCode: '06330',
          },
          {
            name: 'Chancaybaños',
            zipCode: '06610',
          },
          {
            name: 'Chetilla',
            zipCode: '06415',
          },
          {
            name: 'Chiguirip',
            zipCode: '06130',
          },
          {
            name: 'Chilete',
            zipCode: '06420',
          },
          {
            name: 'Chimban',
            zipCode: '06165',
          },
          {
            name: 'Chirinos',
            zipCode: '06840',
          },
          {
            name: 'Chontali',
            zipCode: '06745',
          },
          {
            name: 'Choropampa',
            zipCode: '06160',
          },
          {
            name: 'Choros',
            zipCode: '06785',
          },
          {
            name: 'Chota',
            zipCode: '06120',
          },
          {
            name: 'Chugur',
            zipCode: '06625',
          },
          {
            name: 'Chumuch',
            zipCode: '06255',
          },
          {
            name: 'Cochabamba',
            zipCode: '06650',
          },
          {
            name: 'Colasay',
            zipCode: '06720',
          },
          {
            name: 'Conchan',
            zipCode: '06125',
          },
          {
            name: 'Contumaza',
            zipCode: '06421',
          },
          {
            name: 'Cortegana',
            zipCode: '06260',
          },
          {
            name: 'Cospan',
            zipCode: '06407',
          },
          {
            name: 'Cujillo',
            zipCode: '06775',
          },
          {
            name: 'Cutervo',
            zipCode: '06700',
          },
          {
            name: 'El Prado',
            zipCode: '06465',
          },
          {
            name: 'Encañada',
            zipCode: '06200',
          },
          {
            name: 'Guzmango',
            zipCode: '06431',
          },
          {
            name: 'Huabal',
            zipCode: '06810',
          },
          {
            name: 'Huacapampa',
            zipCode: '06215',
          },
          {
            name: 'Hualgayoc',
            zipCode: '06100',
          },
          {
            name: 'Huambos',
            zipCode: '06653',
          },
          {
            name: 'Huarango',
            zipCode: '06860',
          },
          {
            name: 'Huasmin',
            zipCode: '06240',
          },
          {
            name: 'Ichocan',
            zipCode: '06325',
          },
          {
            name: 'Jaen',
            zipCode: '06800',
          },
          {
            name: 'Jesus',
            zipCode: '06370',
          },
          {
            name: 'La Coipa',
            zipCode: '06825',
          },
          {
            name: 'La Esperanza',
            zipCode: '06611',
          },
          {
            name: 'La Florida',
            zipCode: '06500',
          },
          {
            name: 'La Grama',
            zipCode: '06335',
          },
          {
            name: 'La Libertad de Pallan',
            zipCode: '06245',
          },
          {
            name: 'La Ramada',
            zipCode: '06175',
          },
          {
            name: 'La Sacilia',
            zipCode: '06780',
          },
          {
            name: 'Lajas',
            zipCode: '06600',
          },
          {
            name: 'Las Pirias',
            zipCode: '06805',
          },
          {
            name: 'Licupis',
            zipCode: '06670',
          },
          {
            name: 'Llacanora',
            zipCode: '06300',
          },
          {
            name: 'Llama',
            zipCode: '06665',
          },
          {
            name: 'Llapa',
            zipCode: '06480',
          },
          {
            name: 'Lluchubamba',
            zipCode: '06355',
          },
          {
            name: 'Los Baños del Inca',
            zipCode: '06000',
          },
          {
            name: 'Los Baños del Inca',
            zipCode: '06004',
          },
          {
            name: 'Lucmapampa',
            zipCode: '06220',
          },
          {
            name: 'Magdalena',
            zipCode: '06411',
          },
          {
            name: 'Matara',
            zipCode: '06310',
          },
          {
            name: 'Miracosta',
            zipCode: '06675',
          },
          {
            name: 'Namballe',
            zipCode: '06850',
          },
          {
            name: 'Namora',
            zipCode: '06305',
          },
          {
            name: 'Nanchoc',
            zipCode: '06530',
          },
          {
            name: 'Niepos',
            zipCode: '06510',
          },
          {
            name: 'Ninabamba',
            zipCode: '06621',
          },
          {
            name: 'Oxamarca',
            zipCode: '06210',
          },
          {
            name: 'Paccha',
            zipCode: '06150',
          },
          {
            name: 'Paucamarca',
            zipCode: '06315',
          },
          {
            name: 'Pimpingos',
            zipCode: '06765',
          },
          {
            name: 'Pion',
            zipCode: '06170',
          },
          {
            name: 'Pomahuaca',
            zipCode: '06730',
          },
          {
            name: 'Pucara',
            zipCode: '06725',
          },
          {
            name: 'Pulan',
            zipCode: '06641',
          },
          {
            name: 'Querocotillo',
            zipCode: '06690',
          },
          {
            name: 'Querocoto',
            zipCode: '06683',
          },
          {
            name: 'Sallique',
            zipCode: '06740',
          },
          {
            name: 'San Andres de Cutervo',
            zipCode: '06755',
          },
          {
            name: 'San Benito',
            zipCode: '06435',
          },
          {
            name: 'San Bernardino',
            zipCode: '06445',
          },
          {
            name: 'San Felipe',
            zipCode: '06735',
          },
          {
            name: 'San Gregorio',
            zipCode: '06475',
          },
          {
            name: 'San Ignacio',
            zipCode: '06845',
          },
          {
            name: 'San Jose de Lourdes',
            zipCode: '06855',
          },
          {
            name: 'San Jose del Alto',
            zipCode: '06830',
          },
          {
            name: 'San Juan',
            zipCode: '06400',
          },
          {
            name: 'San Juan de Cutervo',
            zipCode: '06770',
          },
          {
            name: 'San Luis Grande',
            zipCode: '06450',
          },
          {
            name: 'San Luis de Lucma',
            zipCode: '06180',
          },
          {
            name: 'San Marcos',
            zipCode: '06320',
          },
          {
            name: 'San Miguel de Pallaques',
            zipCode: '06455',
          },
          {
            name: 'San Pablo',
            zipCode: '06451',
          },
          {
            name: 'San Silvestre de Cochan',
            zipCode: '06485',
          },
          {
            name: 'Santa Cruz',
            zipCode: '06715',
          },
          {
            name: 'Santa Cruz de Succhabamba',
            zipCode: '06633',
          },
          {
            name: 'Santa Cruz de Toled',
            zipCode: '06425',
          },
          {
            name: 'Santa Rosa',
            zipCode: '06820',
          },
          {
            name: 'Santo Domingo de la Capilla',
            zipCode: '06705',
          },
          {
            name: 'Santo Tomas',
            zipCode: '06760',
          },
          {
            name: 'Saucepampa',
            zipCode: '06640',
          },
          {
            name: 'Sexi',
            zipCode: '06660',
          },
          {
            name: 'Shirac',
            zipCode: '06360',
          },
          {
            name: 'Socota',
            zipCode: '06750',
          },
          {
            name: 'Sorochuco',
            zipCode: '06235',
          },
          {
            name: 'Sucre',
            zipCode: '06205',
          },
          {
            name: 'Tabaconas',
            zipCode: '06835',
          },
          {
            name: 'Tacabamba',
            zipCode: '06135',
          },
          {
            name: 'Tembladera',
            zipCode: '06437',
          },
          {
            name: 'Tocmoche',
            zipCode: '06680',
          },
          {
            name: 'Tongod',
            zipCode: '06630',
          },
          {
            name: 'Trinidad',
            zipCode: '06441',
          },
          {
            name: 'Tumbaden',
            zipCode: '06490',
          },
          {
            name: 'Utco',
            zipCode: '06230',
          },
          {
            name: 'Uticyacu',
            zipCode: '06605',
          },
          {
            name: 'Venecia',
            zipCode: '06365',
          },
          {
            name: 'Yauyucan',
            zipCode: '06620',
          },
        ],
        name: 'Cajamarca',
      },
      {
        cities: [
          {
            name: 'Bellavista',
            zipCode: '07001',
          },
          {
            name: 'Callao',
            zipCode: '07026',
          },
          {
            name: 'Carmen de la Legua Reynoso',
            zipCode: '07006',
          },
          {
            name: 'La Perla',
            zipCode: '07011',
          },
          {
            name: 'La Punta',
            zipCode: '07021',
          },
          {
            name: 'Ventanilla',
            zipCode: '07046',
          },
        ],
        name: 'Callao',
      },
      {
        cities: [
          {
            name: 'Accha',
            zipCode: '08535',
          },
          {
            name: 'Accocunca',
            zipCode: '08330',
          },
          {
            name: 'Acomayo',
            zipCode: '08550',
          },
          {
            name: 'Acopia',
            zipCode: '08295',
          },
          {
            name: 'Acos',
            zipCode: '08545',
          },
          {
            name: 'Ancahuasi',
            zipCode: '08635',
          },
          {
            name: 'Andahuaylillas',
            zipCode: '08210',
          },
          {
            name: 'Anta',
            zipCode: '08615',
          },
          {
            name: 'Cachimayo',
            zipCode: '08605',
          },
          {
            name: 'Caicay',
            zipCode: '08155',
          },
          {
            name: 'Calca',
            zipCode: '08120',
          },
          {
            name: 'Capacmarca',
            zipCode: '08450',
          },
          {
            name: 'Ccapi',
            zipCode: '08505',
          },
          {
            name: 'Ccarhuayo',
            zipCode: '08175',
          },
          {
            name: 'Ccatca',
            zipCode: '08165',
          },
          {
            name: 'Ccorcca',
            zipCode: '08051',
          },
          {
            name: 'Challabamba',
            zipCode: '08140',
          },
          {
            name: 'Chamaca',
            zipCode: '08460',
          },
          {
            name: 'Checacupe',
            zipCode: '08230',
          },
          {
            name: 'Checca',
            zipCode: '08277',
          },
          {
            name: 'Chinchaypujio',
            zipCode: '08620',
          },
          {
            name: 'Chinchero',
            zipCode: '08650',
          },
          {
            name: 'Colcha',
            zipCode: '08530',
          },
          {
            name: 'Colquemarca',
            zipCode: '08440',
          },
          {
            name: 'Colquepata',
            zipCode: '08130',
          },
          {
            name: 'Combapata',
            zipCode: '08238',
          },
          {
            name: 'Condoroma',
            zipCode: '08350',
          },
          {
            name: 'Coporaque',
            zipCode: '08370',
          },
          {
            name: 'Coya',
            zipCode: '08110',
          },
          {
            name: 'Cusco',
            zipCode: '08000',
          },
          {
            name: 'Cusipata',
            zipCode: '08225',
          },
          {
            name: 'Echarate',
            zipCode: '08750',
          },
          {
            name: 'El Descanso',
            zipCode: '08267',
          },
          {
            name: 'Hector Tejada',
            zipCode: '08320',
          },
          {
            name: 'Huancarani',
            zipCode: '08160',
          },
          {
            name: 'Huanoquite',
            zipCode: '08500',
          },
          {
            name: 'Huaro',
            zipCode: '08215',
          },
          {
            name: 'Huarocondo',
            zipCode: '08625',
          },
          {
            name: 'Huayllabamba',
            zipCode: '08670',
          },
          {
            name: 'Huyro',
            zipCode: '08700',
          },
          {
            name: 'Kimbiri',
            zipCode: '08800',
          },
          {
            name: 'Kquelccaybamba',
            zipCode: '08780',
          },
          {
            name: 'Lamay',
            zipCode: '08115',
          },
          {
            name: 'Langui',
            zipCode: '08270',
          },
          {
            name: 'Lares',
            zipCode: '08125',
          },
          {
            name: 'Layo',
            zipCode: '08274',
          },
          {
            name: 'Limatambo',
            zipCode: '08640',
          },
          {
            name: 'Livitaca',
            zipCode: '08470',
          },
          {
            name: 'Llusco',
            zipCode: '08410',
          },
          {
            name: 'Lucma',
            zipCode: '08720',
          },
          {
            name: 'Lucre',
            zipCode: '08207',
          },
          {
            name: 'Machupicchu',
            zipCode: '08680',
          },
          {
            name: 'Marangani',
            zipCode: '08257',
          },
          {
            name: 'Maranura',
            zipCode: '08730',
          },
          {
            name: 'Maras',
            zipCode: '08655',
          },
          {
            name: 'Marcapata',
            zipCode: '08180',
          },
          {
            name: 'Mollepata',
            zipCode: '08645',
          },
          {
            name: 'Mosoc Llacta',
            zipCode: '08290',
          },
          {
            name: 'Ocongate',
            zipCode: '08170',
          },
          {
            name: 'Ocoruro',
            zipCode: '08340',
          },
          {
            name: 'Ollantaytambo',
            zipCode: '08675',
          },
          {
            name: 'Omacha',
            zipCode: '08565',
          },
          {
            name: 'Oropesa',
            zipCode: '08204',
          },
          {
            name: 'Paccaritambo',
            zipCode: '08515',
          },
          {
            name: 'Pampamarca',
            zipCode: '08260',
          },
          {
            name: 'Paruro',
            zipCode: '08520',
          },
          {
            name: 'Paucartambo',
            zipCode: '08135',
          },
          {
            name: 'Pichari',
            zipCode: '08850',
          },
          {
            name: 'Pichigua',
            zipCode: '08310',
          },
          {
            name: 'Pillcopata',
            zipCode: '08145',
          },
          {
            name: 'Pillpinto',
            zipCode: '08540',
          },
          {
            name: 'Pisac',
            zipCode: '08105',
          },
          {
            name: 'Pitumarca',
            zipCode: '08234',
          },
          {
            name: 'Pomacanchi',
            zipCode: '08560',
          },
          {
            name: 'Poroy',
            zipCode: '08600',
          },
          {
            name: 'Pucyura',
            zipCode: '08610',
          },
          {
            name: 'Quebrada Honda',
            zipCode: '08770',
          },
          {
            name: 'Quehue',
            zipCode: '08280',
          },
          {
            name: 'Quellouno',
            zipCode: '08760',
          },
          {
            name: 'Quillabamba',
            zipCode: '08740',
          },
          {
            name: 'Quincemil',
            zipCode: '08185',
          },
          {
            name: 'Quiquijana',
            zipCode: '08222',
          },
          {
            name: 'Quiñota',
            zipCode: '08400',
          },
          {
            name: 'Rondocan',
            zipCode: '08525',
          },
          {
            name: 'San Jeronimo',
            zipCode: '08006',
          },
          {
            name: 'San Pablo',
            zipCode: '08250',
          },
          {
            name: 'San Pedro',
            zipCode: '08245',
          },
          {
            name: 'San Salvador',
            zipCode: '08150',
          },
          {
            name: 'San Sebastian',
            zipCode: '08004',
          },
          {
            name: 'Sangarara',
            zipCode: '08555',
          },
          {
            name: 'Santa Teresa',
            zipCode: '08710',
          },
          {
            name: 'Santiago',
            zipCode: '08001',
          },
          {
            name: 'Santo Tomas',
            zipCode: '08420',
          },
          {
            name: 'Saylla',
            zipCode: '08200',
          },
          {
            name: 'Sicuani',
            zipCode: '08254',
          },
          {
            name: 'Taray',
            zipCode: '08100',
          },
          {
            name: 'Tinta',
            zipCode: '08242',
          },
          {
            name: 'Tungasuca',
            zipCode: '08285',
          },
          {
            name: 'Urcos',
            zipCode: '08219',
          },
          {
            name: 'Urubamba',
            zipCode: '08660',
          },
          {
            name: 'Velille',
            zipCode: '08430',
          },
          {
            name: 'Virginiyoc',
            zipCode: '08360',
          },
          {
            name: 'Wanchaq',
            zipCode: '08002',
          },
          {
            name: 'Yanaoca',
            zipCode: '08264',
          },
          {
            name: 'Yauri',
            zipCode: '08300',
          },
          {
            name: 'Yaurisque',
            zipCode: '08510',
          },
          {
            name: 'Yucay',
            zipCode: '08665',
          },
          {
            name: 'Zurite',
            zipCode: '08630',
          },
        ],
        name: 'Cusco',
      },
      {
        cities: [
          {
            name: 'Acobamba',
            zipCode: '09380',
          },
          {
            name: 'Acobambilla',
            zipCode: '09800',
          },
          {
            name: 'Acoria',
            zipCode: '09100',
          },
          {
            name: 'Acostambo',
            zipCode: '09125',
          },
          {
            name: 'Acraquia',
            zipCode: '09145',
          },
          {
            name: 'Ahuaycha',
            zipCode: '09150',
          },
          {
            name: 'Anchonga',
            zipCode: '09415',
          },
          {
            name: 'Andabamba',
            zipCode: '09310',
          },
          {
            name: 'Anta',
            zipCode: '09375',
          },
          {
            name: 'Antaparco',
            zipCode: '09455',
          },
          {
            name: 'Arma',
            zipCode: '09700',
          },
          {
            name: 'Aurahua',
            zipCode: '09735',
          },
          {
            name: 'Ayavi',
            zipCode: '09605',
          },
          {
            name: 'Caja',
            zipCode: '09390',
          },
          {
            name: 'Callanmarca',
            zipCode: '09425',
          },
          {
            name: 'Capillas',
            zipCode: '09710',
          },
          {
            name: 'Castrovirreyna',
            zipCode: '09725',
          },
          {
            name: 'Ccochaccasa',
            zipCode: '09400',
          },
          {
            name: 'Chinchihuasi',
            zipCode: '09325',
          },
          {
            name: 'Chincho',
            zipCode: '09450',
          },
          {
            name: 'Chupamarca',
            zipCode: '09740',
          },
          {
            name: 'Churcampa',
            zipCode: '09345',
          },
          {
            name: 'Cocas',
            zipCode: '09720',
          },
          {
            name: 'Colcabamba',
            zipCode: '09320',
          },
          {
            name: 'Conayca',
            zipCode: '09870',
          },
          {
            name: 'Congalla',
            zipCode: '09435',
          },
          {
            name: 'Cordova',
            zipCode: '09635',
          },
          {
            name: 'Cuenca',
            zipCode: '09860',
          },
          {
            name: 'Cusicancha',
            zipCode: '09670',
          },
          {
            name: 'Huachocolpa',
            zipCode: '09510',
          },
          {
            name: 'Huachos',
            zipCode: '09705',
          },
          {
            name: 'Huamatambo',
            zipCode: '09750',
          },
          {
            name: 'Huanca Huanca',
            zipCode: '09430',
          },
          {
            name: 'Huancavelica',
            zipCode: '09000',
          },
          {
            name: 'Huando',
            zipCode: '09110',
          },
          {
            name: 'Huaribamba',
            zipCode: '09140',
          },
          {
            name: 'Huayacundo Arma',
            zipCode: '09660',
          },
          {
            name: 'Huayllahuara',
            zipCode: '09840',
          },
          {
            name: 'Huayllay Grande',
            zipCode: '09420',
          },
          {
            name: 'Huaytara',
            zipCode: '09600',
          },
          {
            name: 'Izcuchaca',
            zipCode: '09115',
          },
          {
            name: 'Julcamarca',
            zipCode: '09445',
          },
          {
            name: 'La Esmeralda',
            zipCode: '09315',
          },
          {
            name: 'La Merced',
            zipCode: '09355',
          },
          {
            name: 'Laramarca',
            zipCode: '09640',
          },
          {
            name: 'Laria',
            zipCode: '09880',
          },
          {
            name: 'Lircay',
            zipCode: '09405',
          },
          {
            name: 'Locroja',
            zipCode: '09350',
          },
          {
            name: 'Manta',
            zipCode: '09810',
          },
          {
            name: 'Marcas',
            zipCode: '09395',
          },
          {
            name: 'Mariscal Caceres',
            zipCode: '09120',
          },
          {
            name: 'Mayocc',
            zipCode: '09360',
          },
          {
            name: 'Mollepampa',
            zipCode: '09715',
          },
          {
            name: 'Moya',
            zipCode: '09830',
          },
          {
            name: 'Occoro',
            zipCode: '09890',
          },
          {
            name: 'Ocoyo',
            zipCode: '09650',
          },
          {
            name: 'Pachamarca',
            zipCode: '09335',
          },
          {
            name: 'Palca',
            zipCode: '09105',
          },
          {
            name: 'Pampas',
            zipCode: '09155',
          },
          {
            name: 'Paucara',
            zipCode: '09305',
          },
          {
            name: 'Paucarbamba',
            zipCode: '09330',
          },
          {
            name: 'Paucarbambilla',
            zipCode: '09365',
          },
          {
            name: 'Pazos',
            zipCode: '09135',
          },
          {
            name: 'Pilchaca',
            zipCode: '09850',
          },
          {
            name: 'Pilpichaca',
            zipCode: '09520',
          },
          {
            name: 'Pomacocha',
            zipCode: '09385',
          },
          {
            name: 'Querco',
            zipCode: '09645',
          },
          {
            name: 'Quishuar',
            zipCode: '09210',
          },
          {
            name: 'Quito Arma',
            zipCode: '09665',
          },
          {
            name: 'Rosario',
            zipCode: '09370',
          },
          {
            name: 'Salcabamba',
            zipCode: '09200',
          },
          {
            name: 'Salcahuasi',
            zipCode: '09220',
          },
          {
            name: 'San Francisco de Sangallaico',
            zipCode: '09620',
          },
          {
            name: 'San Juan',
            zipCode: '09755',
          },
          {
            name: 'San Juan de Huirpacancha',
            zipCode: '09630',
          },
          {
            name: 'San Marcos de Rocchac',
            zipCode: '09230',
          },
          {
            name: 'San Pedro de Coris',
            zipCode: '09340',
          },
          {
            name: 'Santa Ana',
            zipCode: '09500',
          },
          {
            name: 'Santiago de Chocorvos',
            zipCode: '09625',
          },
          {
            name: 'Santiago de Quirahuara',
            zipCode: '09655',
          },
          {
            name: 'Santo Domingo de Capillas',
            zipCode: '09615',
          },
          {
            name: 'Santo Tomas de Pata',
            zipCode: '09460',
          },
          {
            name: 'Secclla',
            zipCode: '09440',
          },
          {
            name: 'Surcubamba',
            zipCode: '09240',
          },
          {
            name: 'Tambo',
            zipCode: '09610',
          },
          {
            name: 'Tantara',
            zipCode: '09745',
          },
          {
            name: 'Ticrapo',
            zipCode: '09730',
          },
          {
            name: 'Tintay',
            zipCode: '09260',
          },
          {
            name: 'Vilca',
            zipCode: '09820',
          },
          {
            name: 'Yauli',
            zipCode: '09300',
          },
          {
            name: 'Ñahuimpuquio',
            zipCode: '09130',
          },
        ],
        name: 'Huancavelica',
      },
      {
        cities: [
          {
            name: 'Acomayo',
            zipCode: '10110',
          },
          {
            name: 'Ambo',
            zipCode: '10420',
          },
          {
            name: 'Arancay',
            zipCode: '10820',
          },
          {
            name: 'Aucayacu',
            zipCode: '10170',
          },
          {
            name: 'Baños',
            zipCode: '10631',
          },
          {
            name: 'Cahuac',
            zipCode: '10590',
          },
          {
            name: 'Canchabamba',
            zipCode: '10860',
          },
          {
            name: 'Cauri',
            zipCode: '10540',
          },
          {
            name: 'Cayhuayna',
            zipCode: '10000',
          },
          {
            name: 'Cayna',
            zipCode: '10460',
          },
          {
            name: 'Cayran',
            zipCode: '10031',
          },
          {
            name: 'Chacabamba',
            zipCode: '10580',
          },
          {
            name: 'Chaglla',
            zipCode: '10230',
          },
          {
            name: 'Chaulan',
            zipCode: '10510',
          },
          {
            name: 'Chavin de Pariarca',
            zipCode: '10775',
          },
          {
            name: 'Chavinillo',
            zipCode: '10710',
          },
          {
            name: 'Choras',
            zipCode: '10570',
          },
          {
            name: 'Chupan',
            zipCode: '10730',
          },
          {
            name: 'Chuquis',
            zipCode: '10740',
          },
          {
            name: 'Churubamba',
            zipCode: '10180',
          },
          {
            name: 'Cochabamba',
            zipCode: '10830',
          },
          {
            name: 'Codo del Pozuzo',
            zipCode: '10240',
          },
          {
            name: 'Colpas',
            zipCode: '10470',
          },
          {
            name: 'Conchamarca',
            zipCode: '10400',
          },
          {
            name: 'Daniel Alomias Robles',
            zipCode: '10150',
          },
          {
            name: 'Hermilio Valdizan',
            zipCode: '10160',
          },
          {
            name: 'Honoria',
            zipCode: '10350',
          },
          {
            name: 'Huacar',
            zipCode: '10440',
          },
          {
            name: 'Huacaybamba',
            zipCode: '10840',
          },
          {
            name: 'Huacrachuco',
            zipCode: '10880',
          },
          {
            name: 'Huancapallac',
            zipCode: '10700',
          },
          {
            name: 'Huanuco',
            zipCode: '10001',
          },
          {
            name: 'Huarin',
            zipCode: '10560',
          },
          {
            name: 'Jacas Grande',
            zipCode: '10770',
          },
          {
            name: 'Jesus',
            zipCode: '10530',
          },
          {
            name: 'Jircan',
            zipCode: '10810',
          },
          {
            name: 'Jivia',
            zipCode: '10550',
          },
          {
            name: 'La Union',
            zipCode: '10620',
          },
          {
            name: 'Las Palmas',
            zipCode: '10120',
          },
          {
            name: 'Llata',
            zipCode: '10641',
          },
          {
            name: 'Margos',
            zipCode: '10520',
          },
          {
            name: 'Marias',
            zipCode: '10760',
          },
          {
            name: 'Miraflores',
            zipCode: '10680',
          },
          {
            name: 'Molinos',
            zipCode: '10210',
          },
          {
            name: 'Monzon',
            zipCode: '10800',
          },
          {
            name: 'Mosca',
            zipCode: '10450',
          },
          {
            name: 'Naranjillo',
            zipCode: '10140',
          },
          {
            name: 'Obas',
            zipCode: '10720',
          },
          {
            name: 'Pachas',
            zipCode: '10600',
          },
          {
            name: 'Pampamarca',
            zipCode: '10750',
          },
          {
            name: 'Panao',
            zipCode: '10220',
          },
          {
            name: 'Paucarbamba',
            zipCode: '10002',
          },
          {
            name: 'Pinra',
            zipCode: '10850',
          },
          {
            name: 'Puerto Inca',
            zipCode: '10260',
          },
          {
            name: 'Punchao',
            zipCode: '10685',
          },
          {
            name: 'Puños',
            zipCode: '10670',
          },
          {
            name: 'Queropalca',
            zipCode: '10650',
          },
          {
            name: 'Quivilla',
            zipCode: '10755',
          },
          {
            name: 'Ripan',
            zipCode: '10610',
          },
          {
            name: 'Rondos',
            zipCode: '10626',
          },
          {
            name: 'San Buenaventura',
            zipCode: '10870',
          },
          {
            name: 'San Cristobal de Jacas Chico',
            zipCode: '10705',
          },
          {
            name: 'San Pedro de Chonta',
            zipCode: '10890',
          },
          {
            name: 'San Rafael',
            zipCode: '10430',
          },
          {
            name: 'Santa Maria del Valle',
            zipCode: '10100',
          },
          {
            name: 'Shunqui',
            zipCode: '10605',
          },
          {
            name: 'Sillapata',
            zipCode: '10615',
          },
          {
            name: 'Singa',
            zipCode: '10690',
          },
          {
            name: 'Tantamayo',
            zipCode: '10780',
          },
          {
            keywords: ['Tingo María'],
            name: 'Tingo Maria',
            zipCode: '10130',
          },
          {
            name: 'Tomay Kichwa',
            zipCode: '10410',
          },
          {
            name: 'Tournavista',
            zipCode: '10300',
          },
          {
            name: 'Umari',
            zipCode: '10200',
          },
          {
            name: 'Yanas',
            zipCode: '10745',
          },
          {
            name: 'Yarumayo',
            zipCode: '10500',
          },
          {
            name: 'Yuyapichis',
            zipCode: '10250',
          },
        ],
        keywords: ['Huánuco'],
        name: 'Huanuco',
      },
      {
        cities: [
          {
            name: 'Alto Laran',
            zipCode: '11770',
          },
          {
            name: 'Changuillo',
            zipCode: '11340',
          },
          {
            name: 'Chavin',
            zipCode: '11780',
          },
          {
            name: 'Chincha Alta',
            zipCode: '11701',
          },
          {
            name: 'Chincha Baja',
            zipCode: '11750',
          },
          {
            name: 'El Carmen',
            zipCode: '11740',
          },
          {
            name: 'El Ingenio',
            zipCode: '11350',
          },
          {
            name: 'Guadalupe',
            zipCode: '11500',
          },
          {
            name: 'Huancano',
            zipCode: '11660',
          },
          {
            name: 'Humay',
            zipCode: '11650',
          },
          {
            name: 'Ica',
            zipCode: '11000',
          },
          {
            name: 'Independencia',
            zipCode: '11640',
          },
          {
            name: 'La Tinguiña',
            zipCode: '11003',
          },
          {
            name: 'Llipata',
            zipCode: '11360',
          },
          {
            name: 'Los Aquijes',
            zipCode: '11061',
          },
          {
            name: 'Nazca',
            zipCode: '11400',
          },
          {
            name: 'Ocucaje',
            zipCode: '11240',
          },
          {
            name: 'Palpa',
            zipCode: '11330',
          },
          {
            name: 'Pampa de Tate',
            zipCode: '11220',
          },
          {
            name: 'Pampahuasi',
            zipCode: '11260',
          },
          {
            name: 'Paracas',
            zipCode: '11550',
          },
          {
            name: 'Parcona',
            zipCode: '11001',
          },
          {
            name: 'Pisco',
            zipCode: '11601',
          },
          {
            name: 'Pueblo Nuevo',
            zipCode: '11703',
          },
          {
            name: 'Pueblo Nuevo',
            zipCode: '11200',
          },
          {
            name: 'Rio Grande',
            zipCode: '11320',
          },
          {
            name: 'San Andres',
            zipCode: '11600',
          },
          {
            name: 'San Clemente',
            zipCode: '11630',
          },
          {
            name: 'San Jose de los Molinos',
            zipCode: '11100',
          },
          {
            name: 'San Juan',
            zipCode: '11420',
          },
          {
            name: 'San Juan Bautista',
            zipCode: '11002',
          },
          {
            name: 'San Juan de Yanac',
            zipCode: '11850',
          },
          {
            name: 'San Pedro',
            zipCode: '11700',
          },
          {
            name: 'San Pedro de Huacarpana',
            zipCode: '11800',
          },
          {
            name: 'Santa Cruz',
            zipCode: '11300',
          },
          {
            name: 'Santiago',
            zipCode: '11230',
          },
          {
            name: 'Subtanjalla',
            zipCode: '11004',
          },
          {
            name: 'Sunampe',
            zipCode: '11702',
          },
          {
            name: 'Tambo de Mora',
            zipCode: '11760',
          },
          {
            name: 'Tate de la Capilla',
            zipCode: '11210',
          },
          {
            name: 'Tibillo',
            zipCode: '11310',
          },
          {
            name: 'Tupac Amaru',
            zipCode: '11620',
          },
          {
            name: 'Vista Alegre',
            zipCode: '11401',
          },
        ],
        name: 'Ica',
      },
      {
        cities: [
          {
            name: 'Aco',
            zipCode: '12510',
          },
          {
            name: 'Acobamba',
            zipCode: '12700',
          },
          {
            name: 'Acolla',
            zipCode: '12620',
          },
          {
            name: 'Ahuac',
            zipCode: '12465',
          },
          {
            name: 'Andamarca',
            zipCode: '12235',
          },
          {
            name: 'Apata',
            zipCode: '12140',
          },
          {
            name: 'Ataura',
            zipCode: '12160',
          },
          {
            name: 'Bajo Pichanaqui',
            zipCode: '12866',
          },
          {
            name: 'Canchayllo',
            zipCode: '12555',
          },
          {
            name: 'Carhuacallanga',
            zipCode: '12442',
          },
          {
            name: 'Carhuamayo',
            zipCode: '12740',
          },
          {
            name: 'Chacapalpa',
            zipCode: '12560',
          },
          {
            name: 'Chacapampa',
            zipCode: '12440',
          },
          {
            name: 'Chambara',
            zipCode: '12490',
          },
          {
            name: 'Chicche',
            zipCode: '12451',
          },
          {
            name: 'Chilca',
            zipCode: '12001',
          },
          {
            name: 'Chongos Alto',
            zipCode: '12450',
          },
          {
            name: 'Chongos Bajo',
            zipCode: '12430',
          },
          {
            name: 'Chupaca',
            zipCode: '12455',
          },
          {
            name: 'Chupuro',
            zipCode: '12435',
          },
          {
            name: 'Cochas',
            zipCode: '12225',
          },
          {
            name: 'Colca',
            zipCode: '12436',
          },
          {
            name: 'Comas',
            zipCode: '12220',
          },
          {
            name: 'Concepcion',
            zipCode: '12125',
          },
          {
            name: 'Concho',
            zipCode: '12640',
          },
          {
            name: 'Coviriali',
            zipCode: '12255',
          },
          {
            name: 'Cullhuas',
            zipCode: '12420',
          },
          {
            name: 'El Rosario',
            zipCode: '12550',
          },
          {
            name: 'El Tambo',
            zipCode: '12007',
          },
          {
            name: 'Huachac',
            zipCode: '12480',
          },
          {
            name: 'Huacrapuquio',
            zipCode: '12419',
          },
          {
            name: 'Hualhuas',
            zipCode: '12105',
          },
          {
            name: 'Huamali',
            zipCode: '12155',
          },
          {
            name: 'Huamancaca Chico',
            zipCode: '12425',
          },
          {
            name: 'Huancan',
            zipCode: '12051',
          },
          {
            name: 'Huancani',
            zipCode: '12515',
          },
          {
            name: 'Huancayo',
            zipCode: '12004',
          },
          {
            name: 'Huancayo',
            zipCode: '12000',
          },
          {
            name: 'Huaricolca',
            zipCode: '12645',
          },
          {
            name: 'Huaripampa',
            zipCode: '12530',
          },
          {
            name: 'Huasahuasi',
            zipCode: '12835',
          },
          {
            name: 'Huasicancha',
            zipCode: '12445',
          },
          {
            name: 'Huay Huay',
            zipCode: '12565',
          },
          {
            name: 'Huayucachi',
            zipCode: '12408',
          },
          {
            name: 'Huertas',
            zipCode: '12615',
          },
          {
            name: 'Ingenio',
            zipCode: '12210',
          },
          {
            name: 'Iscos',
            zipCode: '12460',
          },
          {
            name: 'Janjaillo',
            zipCode: '12630',
          },
          {
            name: 'Jarpa',
            zipCode: '12475',
          },
          {
            name: 'Jauja',
            zipCode: '12601',
          },
          {
            name: 'Julcan',
            zipCode: '12175',
          },
          {
            name: 'Junin',
            zipCode: '12730',
          },
          {
            name: 'La Merced',
            zipCode: '12855',
          },
          {
            name: 'La Oroya',
            zipCode: '12575',
          },
          {
            name: 'Lampa',
            zipCode: '12245',
          },
          {
            name: 'Leticia',
            zipCode: '12655',
          },
          {
            name: 'Llaylla',
            zipCode: '12310',
          },
          {
            name: 'Llocllapampa',
            zipCode: '12545',
          },
          {
            name: 'Marcapomacocha',
            zipCode: '12780',
          },
          {
            name: 'Marco',
            zipCode: '12625',
          },
          {
            name: 'Mariposa',
            zipCode: '12250',
          },
          {
            name: 'Masma',
            zipCode: '12165',
          },
          {
            name: 'Masma Chicche',
            zipCode: '12170',
          },
          {
            name: 'Matahuasi',
            zipCode: '12135',
          },
          {
            name: 'Mazamari',
            zipCode: '12300',
          },
          {
            name: 'Mito',
            zipCode: '12505',
          },
          {
            name: 'Molinos',
            zipCode: '12180',
          },
          {
            name: 'Monobamba',
            zipCode: '12850',
          },
          {
            name: 'Morococha',
            zipCode: '12595',
          },
          {
            name: 'Mucllo',
            zipCode: '12230',
          },
          {
            name: 'Muqui',
            zipCode: '12520',
          },
          {
            name: 'Muquiyauyo',
            zipCode: '12525',
          },
          {
            name: 'Ondores',
            zipCode: '12760',
          },
          {
            name: 'Orcotuna',
            zipCode: '12504',
          },
          {
            name: 'Paca',
            zipCode: '12810',
          },
          {
            name: 'Paccha',
            zipCode: '12585',
          },
          {
            name: 'Paccha',
            zipCode: '12535',
          },
          {
            name: 'Palca',
            zipCode: '12830',
          },
          {
            name: 'Palcamayo',
            zipCode: '12710',
          },
          {
            name: 'Pancan',
            zipCode: '12800',
          },
          {
            name: 'Parco',
            zipCode: '12540',
          },
          {
            name: 'Perene',
            zipCode: '12867',
          },
          {
            name: 'Perene',
            zipCode: '12865',
          },
          {
            name: 'Pilcomayo',
            zipCode: '12006',
          },
          {
            name: 'Pomacancha',
            zipCode: '12635',
          },
          {
            name: 'Pucara',
            zipCode: '12845',
          },
          {
            name: 'Pucara',
            zipCode: '12404',
          },
          {
            name: 'Pucucho',
            zipCode: '12150',
          },
          {
            name: 'Puerto Ocopa',
            zipCode: '12330',
          },
          {
            name: 'Quichuay',
            zipCode: '12205',
          },
          {
            name: 'Quilcas',
            zipCode: '12120',
          },
          {
            name: 'Ricran',
            zipCode: '12820',
          },
          {
            name: 'Rio Negro',
            zipCode: '12875',
          },
          {
            name: 'San Agustin',
            zipCode: '12100',
          },
          {
            name: 'San Antonio de Ocopa',
            zipCode: '12215',
          },
          {
            name: 'San Jeronimo de Tunan',
            zipCode: '12115',
          },
          {
            name: 'San Jose de Quero',
            zipCode: '12495',
          },
          {
            name: 'San Lorenzo',
            zipCode: '12145',
          },
          {
            name: 'San Luis de Shuaro',
            zipCode: '12860',
          },
          {
            name: 'San Martin de Pangoa',
            zipCode: '12320',
          },
          {
            name: 'San Miguel',
            zipCode: '12485',
          },
          {
            name: 'San Pedro de Cajas',
            zipCode: '12720',
          },
          {
            name: 'San Pedro de Chunan',
            zipCode: '12805',
          },
          {
            name: 'San Ramon',
            zipCode: '12840',
          },
          {
            name: 'Santa Barbara de Carhuacayan',
            zipCode: '12770',
          },
          {
            name: 'Santa Rosa',
            zipCode: '12200',
          },
          {
            name: 'Santa Rosa de Sacco',
            zipCode: '12576',
          },
          {
            name: 'Santo Domingo de Acobamba',
            zipCode: '12240',
          },
          {
            name: 'Santo Domingo del Prado',
            zipCode: '12130',
          },
          {
            name: 'Sapallanga',
            zipCode: '12400',
          },
          {
            name: 'Satipo',
            zipCode: '12260',
          },
          {
            name: 'Sausa',
            zipCode: '12600',
          },
          {
            name: 'Saño',
            zipCode: '12110',
          },
          {
            name: 'Sicaya',
            zipCode: '12500',
          },
          {
            name: 'Sincos',
            zipCode: '12513',
          },
          {
            name: 'Suitucancha',
            zipCode: '12570',
          },
          {
            name: 'Tapo',
            zipCode: '12825',
          },
          {
            name: 'Tarma',
            zipCode: '12650',
          },
          {
            name: 'Tres de Diciembre',
            zipCode: '12428',
          },
          {
            name: 'Ulcumayo',
            zipCode: '12750',
          },
          {
            name: 'Viques',
            zipCode: '12415',
          },
          {
            name: 'Yanacancha',
            zipCode: '12470',
          },
          {
            name: 'Yauli',
            zipCode: '12815',
          },
          {
            name: 'Yauli',
            zipCode: '12590',
          },
          {
            name: 'Yauyos',
            zipCode: '12602',
          },
        ],
        name: 'Junin',
      },
      {
        cities: [
          {
            name: 'Agallpampa',
            zipCode: '13135',
          },
          {
            name: 'Angasmarca',
            zipCode: '13160',
          },
          {
            name: 'Aricapampa',
            zipCode: '13340',
          },
          {
            name: 'Ascope',
            zipCode: '13770',
          },
          {
            name: 'Bambamarca',
            zipCode: '13400',
          },
          {
            name: 'Bolivar',
            zipCode: '13420',
          },
          {
            name: 'Buenos Aires',
            zipCode: '13009',
          },
          {
            name: 'Buldibuyo',
            zipCode: '13515',
          },
          {
            name: 'Cachicadan',
            zipCode: '13155',
          },
          {
            name: 'Calamarca',
            zipCode: '13185',
          },
          {
            name: 'Carabamba',
            zipCode: '13195',
          },
          {
            name: 'Casa Grande',
            zipCode: '13760',
          },
          {
            name: 'Cascas',
            zipCode: '13780',
          },
          {
            name: 'Challas',
            zipCode: '13535',
          },
          {
            name: 'Chao',
            zipCode: '13630',
          },
          {
            name: 'Charat',
            zipCode: '13210',
          },
          {
            name: 'Chepen',
            zipCode: '13870',
          },
          {
            name: 'Chicama',
            zipCode: '13700',
          },
          {
            name: 'Chillia',
            zipCode: '13550',
          },
          {
            name: 'Chocope',
            zipCode: '13710',
          },
          {
            name: 'Chugay',
            zipCode: '13330',
          },
          {
            name: 'Compin',
            zipCode: '13260',
          },
          {
            name: 'Curgos',
            zipCode: '13360',
          },
          {
            name: 'El Porvenir',
            zipCode: '13004',
          },
          {
            name: 'Florencia de Mora',
            zipCode: '13003',
          },
          {
            name: 'Guadalupe',
            zipCode: '13840',
          },
          {
            name: 'Guadalupito',
            zipCode: '13640',
          },
          {
            name: 'Huamachuco',
            zipCode: '13300',
          },
          {
            name: 'Huancaspata',
            zipCode: '13530',
          },
          {
            name: 'Huanchaco',
            zipCode: '13000',
          },
          {
            name: 'Huaranchal',
            zipCode: '13230',
          },
          {
            name: 'Huaso',
            zipCode: '13190',
          },
          {
            name: 'Huaylillas',
            zipCode: '13520',
          },
          {
            name: 'Huayo',
            zipCode: '13555',
          },
          {
            name: 'Jequetepeque',
            zipCode: '13820',
          },
          {
            name: 'Julcan',
            zipCode: '13180',
          },
          {
            name: 'La Cuesta',
            zipCode: '13120',
          },
          {
            name: 'La Esperanza',
            zipCode: '13002',
          },
          {
            name: 'Laredo',
            zipCode: '13100',
          },
          {
            name: 'Longotea',
            zipCode: '13440',
          },
          {
            name: 'Lucma',
            zipCode: '13240',
          },
          {
            name: 'Mache',
            zipCode: '13175',
          },
          {
            name: 'Magdalena de Cao',
            zipCode: '13750',
          },
          {
            name: 'Marcabal',
            zipCode: '13320',
          },
          {
            name: 'Moche',
            zipCode: '13600',
          },
          {
            name: 'Mollebamba',
            zipCode: '13165',
          },
          {
            name: 'Mollepata',
            zipCode: '13170',
          },
          {
            name: 'Nuevo Condormarca',
            zipCode: '13410',
          },
          {
            name: 'Ongon',
            zipCode: '13560',
          },
          {
            name: 'Otuzco',
            zipCode: '13200',
          },
          {
            name: 'Pacanga',
            zipCode: '13860',
          },
          {
            name: 'Pacasmayo',
            zipCode: '13810',
          },
          {
            name: 'Paijan',
            zipCode: '13720',
          },
          {
            name: 'Paranday',
            zipCode: '13115',
          },
          {
            name: 'Parcoy',
            zipCode: '13510',
          },
          {
            name: 'Pataz',
            zipCode: '13500',
          },
          {
            name: 'Pias',
            zipCode: '13505',
          },
          {
            name: 'Poroto',
            zipCode: '13125',
          },
          {
            name: 'Pueblo Nuevo',
            zipCode: '13850',
          },
          {
            name: 'Puerto de Malabrigo',
            zipCode: '13730',
          },
          {
            name: 'Quiruvilca',
            zipCode: '13140',
          },
          {
            name: 'Salaverry',
            zipCode: '13610',
          },
          {
            name: 'Salpo',
            zipCode: '13130',
          },
          {
            name: 'San Jose',
            zipCode: '13830',
          },
          {
            name: 'San Pedro de Lloc',
            zipCode: '13800',
          },
          {
            name: 'Sanagoran',
            zipCode: '13310',
          },
          {
            name: 'Santa Cruz de Chuca',
            zipCode: '13150',
          },
          {
            name: 'Santiago de Cao',
            zipCode: '13740',
          },
          {
            name: 'Santiago de Chuco',
            zipCode: '13145',
          },
          {
            name: 'Sarin',
            zipCode: '13370',
          },
          {
            name: 'Sartimbamba',
            zipCode: '13350',
          },
          {
            name: 'Sayapullo',
            zipCode: '13250',
          },
          {
            name: 'Simbal',
            zipCode: '13105',
          },
          {
            name: 'Sinsicap',
            zipCode: '13110',
          },
          {
            name: 'Sitabamba',
            zipCode: '13380',
          },
          {
            name: 'Taurija',
            zipCode: '13545',
          },
          {
            name: 'Tayabamba',
            zipCode: '13525',
          },
          {
            name: 'Trujillo',
            zipCode: '13001',
          },
          {
            name: 'Uchucmarca',
            zipCode: '13450',
          },
          {
            name: 'Ucuncha',
            zipCode: '13430',
          },
          {
            name: 'Urpay',
            zipCode: '13540',
          },
          {
            name: 'Usquil',
            zipCode: '13220',
          },
          {
            name: 'Viru',
            zipCode: '13620',
          },
        ],
        name: 'La Libertad',
      },
      {
        cities: [
          {
            name: 'Cayalti',
            zipCode: '14720',
          },
          {
            name: 'Cañaris',
            zipCode: '14500',
          },
          {
            name: 'Chiclayo',
            zipCode: '14001',
          },
          {
            name: 'Chochope',
            zipCode: '14220',
          },
          {
            name: 'Chongoyape',
            zipCode: '14620',
          },
          {
            name: 'Eten',
            zipCode: '14820',
          },
          {
            name: 'Eten Puerto',
            zipCode: '14810',
          },
          {
            name: 'Ferreñafe',
            zipCode: '14311',
          },
          {
            name: 'Illimo',
            zipCode: '14130',
          },
          {
            name: 'Incahuasi',
            zipCode: '14400',
          },
          {
            name: 'Jayanca',
            zipCode: '14150',
          },
          {
            name: 'Jose Leonardo Ortiz',
            zipCode: '14002',
          },
          {
            name: 'La Victoria',
            zipCode: '14007',
          },
          {
            name: 'Lambayeque',
            zipCode: '14013',
          },
          {
            name: 'Manuel Antonio Mesones Muro',
            zipCode: '14330',
          },
          {
            name: 'Mochumi',
            zipCode: '14110',
          },
          {
            name: 'Mocupe',
            zipCode: '14700',
          },
          {
            name: 'Monsefu',
            zipCode: '14830',
          },
          {
            name: 'Morrope',
            zipCode: '14160',
          },
          {
            name: 'Motupe',
            zipCode: '14200',
          },
          {
            name: 'Nueva Arica',
            zipCode: '14730',
          },
          {
            name: 'Olmos',
            zipCode: '14210',
          },
          {
            name: 'Oyotun',
            zipCode: '14740',
          },
          {
            name: 'Pacora',
            zipCode: '14140',
          },
          {
            name: 'Patapo',
            zipCode: '14610',
          },
          {
            name: 'Picsi',
            zipCode: '14300',
          },
          {
            name: 'Pimentel',
            zipCode: '14012',
          },
          {
            name: 'Pitipo',
            zipCode: '14340',
          },
          {
            name: 'Pomalca',
            zipCode: '14006',
          },
          {
            name: 'Pucala',
            zipCode: '14630',
          },
          {
            name: 'Pueblo Nuevo',
            zipCode: '14310',
          },
          {
            name: 'Reque',
            zipCode: '14800',
          },
          {
            name: 'Salas',
            zipCode: '14230',
          },
          {
            name: 'San Jose',
            zipCode: '14000',
          },
          {
            name: 'Santa Rosa',
            zipCode: '14840',
          },
          {
            name: 'Saña',
            zipCode: '14710',
          },
          {
            name: 'Tucume',
            zipCode: '14120',
          },
          {
            name: 'Tuman',
            zipCode: '14600',
          },
        ],
        name: 'Lambayeque',
      },
      {
        cities: [
          {
            name: 'Acos',
            zipCode: '15215',
          },
          {
            name: 'Alis',
            zipCode: '15786',
          },
          {
            name: 'Ambar',
            zipCode: '15182',
          },
          {
            name: 'Ancon',
            zipCode: '15123',
          },
          {
            name: 'Andajes',
            zipCode: '15266',
          },
          {
            name: 'Antioquia',
            zipCode: '15586',
          },
          {
            name: 'Arahuay',
            zipCode: '15340',
          },
          {
            name: 'Asia',
            zipCode: '15689',
          },
          {
            name: 'Aucallama',
            zipCode: '15125',
          },
          {
            name: 'Ayauca',
            zipCode: '15765',
          },
          {
            name: 'Ayaviri',
            zipCode: '15675',
          },
          {
            name: 'Azangaro',
            zipCode: '15740',
          },
          {
            name: 'Barranca',
            zipCode: '15169',
          },
          {
            name: 'Barranco',
            zipCode: '15049',
          },
          {
            name: 'Barrio Obrero Industrial',
            zipCode: '15101',
          },
          {
            name: 'Breña',
            zipCode: '15082',
          },
          {
            name: 'Cacra',
            zipCode: '15750',
          },
          {
            name: 'Cajatambo',
            zipCode: '15195',
          },
          {
            name: 'Calango',
            zipCode: '15615',
          },
          {
            name: 'Caleta de Carquin',
            zipCode: '15138',
          },
          {
            name: 'Callahuanca',
            zipCode: '15505',
          },
          {
            name: 'Canta',
            zipCode: '15360',
          },
          {
            name: 'Carabayllo',
            zipCode: '15121',
          },
          {
            name: 'Carac',
            zipCode: '15221',
          },
          {
            name: 'Carampoma',
            zipCode: '15525',
          },
          {
            name: 'Carania',
            zipCode: '15781',
          },
          {
            name: 'Catahuasi',
            zipCode: '15760',
          },
          {
            name: 'Caujul',
            zipCode: '15265',
          },
          {
            name: 'Cerro Azul',
            zipCode: '15716',
          },
          {
            name: 'Chaclacayo',
            zipCode: '15472',
          },
          {
            name: 'Chaclla',
            zipCode: '15510',
          },
          {
            name: 'Chancay',
            zipCode: '15130',
          },
          {
            name: 'Chicla',
            zipCode: '15564',
          },
          {
            name: 'Chilca',
            zipCode: '15870',
          },
          {
            name: 'Chocos',
            zipCode: '15736',
          },
          {
            name: 'Chorrillos',
            zipCode: '15057',
          },
          {
            name: 'Chosica',
            zipCode: '15461',
          },
          {
            name: 'Churin',
            zipCode: '15270',
          },
          {
            name: 'Cieneguilla',
            zipCode: '15593',
          },
          {
            name: 'Ciudad de Dios',
            zipCode: '15058',
          },
          {
            name: 'Coayllo',
            zipCode: '15685',
          },
          {
            name: 'Cocachacra',
            zipCode: '15545',
          },
          {
            name: 'Cochamarca',
            zipCode: '15250',
          },
          {
            name: 'Cochas',
            zipCode: '15621',
          },
          {
            name: 'Colonia',
            zipCode: '15770',
          },
          {
            name: 'Copa',
            zipCode: '15197',
          },
          {
            name: 'Cruz Blanca',
            zipCode: '15135',
          },
          {
            name: 'El Agustino',
            zipCode: '15003',
          },
          {
            name: 'Gorgor',
            zipCode: '15190',
          },
          {
            name: 'Hongos',
            zipCode: '15753',
          },
          {
            name: 'Huacho',
            zipCode: '15136',
          },
          {
            name: 'Hualmay',
            zipCode: '15137',
          },
          {
            name: 'Huamantanga',
            zipCode: '15355',
          },
          {
            name: 'Huampara',
            zipCode: '15670',
          },
          {
            name: 'Huancapon',
            zipCode: '15191',
          },
          {
            name: 'Huancaya',
            zipCode: '15796',
          },
          {
            name: 'Huangascar',
            zipCode: '15748',
          },
          {
            name: 'Huantan',
            zipCode: '15780',
          },
          {
            name: 'Huanza',
            zipCode: '15535',
          },
          {
            name: 'Huaral',
            zipCode: '15200',
          },
          {
            name: 'Huarochiri',
            zipCode: '15635',
          },
          {
            name: 'Huaros',
            zipCode: '15365',
          },
          {
            name: 'Huaura',
            zipCode: '15139',
          },
          {
            name: 'Huañec',
            zipCode: '15661',
          },
          {
            name: 'Ihuari',
            zipCode: '15245',
          },
          {
            name: 'Imperial',
            zipCode: '15700',
          },
          {
            name: 'Independencia',
            zipCode: '15331',
          },
          {
            name: 'Jesus Maria',
            zipCode: '15073',
          },
          {
            name: 'Jucul',
            zipCode: '15285',
          },
          {
            name: 'La Libertad',
            zipCode: '15312',
          },
          {
            name: 'La Molina',
            zipCode: '15012',
          },
          {
            name: 'La Victoria',
            zipCode: '15018',
          },
          {
            name: 'Lachaqui',
            zipCode: '15345',
          },
          {
            name: 'Lahuaytambo',
            zipCode: '15577',
          },
          {
            name: 'Lampian',
            zipCode: '15220',
          },
          {
            name: 'Langa',
            zipCode: '15580',
          },
          {
            name: 'Laraos',
            zipCode: '15530',
          },
          {
            name: 'Las Palmeras',
            zipCode: '15301',
          },
          {
            name: 'Lima',
            zipCode: '15001',
          },
          {
            name: 'Lince',
            zipCode: '15046',
          },
          {
            name: 'Lincha',
            zipCode: '15755',
          },
          {
            name: 'Lunahuana',
            zipCode: '15727',
          },
          {
            name: 'Lurin',
            zipCode: '15846',
          },
          {
            name: 'Madean',
            zipCode: '15742',
          },
          {
            name: 'Magdalena del Mar',
            zipCode: '15086',
          },
          {
            name: 'Mala',
            zipCode: '15608',
          },
          {
            name: 'Manas',
            zipCode: '15185',
          },
          {
            name: 'Maray',
            zipCode: '15280',
          },
          {
            name: 'Mariatana',
            zipCode: '15630',
          },
          {
            name: 'Matucana',
            zipCode: '15556',
          },
          {
            name: 'Miraflores',
            zipCode: '15047',
          },
          {
            name: 'Navan',
            zipCode: '15260',
          },
          {
            name: 'Nuevo Imperial',
            zipCode: '15723',
          },
          {
            name: 'Omas',
            zipCode: '15681',
          },
          {
            name: 'Oyon',
            zipCode: '15274',
          },
          {
            name: 'Pacaran',
            zipCode: '15730',
          },
          {
            name: 'Pacaraos',
            zipCode: '15230',
          },
          {
            name: 'Paccho',
            zipCode: '15255',
          },
          {
            name: 'Pachacamac',
            zipCode: '15823',
          },
          {
            name: 'Paramonga',
            zipCode: '15178',
          },
          {
            name: 'Pativilca',
            zipCode: '15174',
          },
          {
            name: 'Pirca',
            zipCode: '15225',
          },
          {
            name: 'Pucusana',
            zipCode: '15865',
          },
          {
            name: 'Pueblo Libre',
            zipCode: '15084',
          },
          {
            name: 'Puente Piedra',
            zipCode: '15116',
          },
          {
            name: 'Punta Hermosa',
            zipCode: '15845',
          },
          {
            name: 'Punta Negra',
            zipCode: '15850',
          },
          {
            name: 'Quilmana',
            zipCode: '15712',
          },
          {
            name: 'Quinches',
            zipCode: '15665',
          },
          {
            name: 'Quinocay',
            zipCode: '15620',
          },
          {
            name: 'Ricardo Palma',
            zipCode: '15536',
          },
          {
            name: 'Rimac',
            zipCode: '15093',
          },
          {
            name: 'San Agustin de Huayopampa',
            zipCode: '15205',
          },
          {
            name: 'San Andres de Tupicocha',
            zipCode: '15571',
          },
          {
            name: 'San Antonio',
            zipCode: '15600',
          },
          {
            name: 'San Bartolo',
            zipCode: '15855',
          },
          {
            name: 'San Bartolome',
            zipCode: '15550',
          },
          {
            name: 'San Buenaventura',
            zipCode: '15350',
          },
          {
            name: 'San Damian',
            zipCode: '15575',
          },
          {
            name: 'San Francisco de Borja',
            zipCode: '15021',
          },
          {
            name: 'San Isidro',
            zipCode: '15036',
          },
          {
            name: 'San Joaquin',
            zipCode: '15655',
          },
          {
            name: 'San Jose de los Chorrillos',
            zipCode: '15585',
          },
          {
            name: 'San Juan de Iris',
            zipCode: '15520',
          },
          {
            name: 'San Juan de Lanca',
            zipCode: '15540',
          },
          {
            name: 'San Juan de Lurigancho',
            zipCode: '15401',
          },
          {
            name: 'San Juan de Miraflores',
            zipCode: '15457',
          },
          {
            name: 'San Juan de Tantaranche',
            zipCode: '15650',
          },
          {
            name: 'San Lorenzo de Huachupampa',
            zipCode: '15516',
          },
          {
            name: 'San Lorenzo de Putinza',
            zipCode: '15763',
          },
          {
            name: 'San Lorenzo de Quinti',
            zipCode: '15640',
          },
          {
            name: 'San Luis',
            zipCode: '15719',
          },
          {
            name: 'San Mateo',
            zipCode: '15560',
          },
          {
            name: 'San Miguel',
            zipCode: '15087',
          },
          {
            name: 'San Pedro',
            zipCode: '15641',
          },
          {
            name: 'San Pedro de Casta',
            zipCode: '15515',
          },
          {
            name: 'San Pedro de Pilas',
            zipCode: '15680',
          },
          {
            name: 'San Vicente de Cañete',
            zipCode: '15701',
          },
          {
            name: 'Sangallaya',
            zipCode: '15625',
          },
          {
            name: 'Santa Anita',
            zipCode: '15007',
          },
          {
            name: 'Santa Cruz',
            zipCode: '15246',
          },
          {
            name: 'Santa Cruz de Andamarca',
            zipCode: '15235',
          },
          {
            name: 'Santa Cruz de Flores',
            zipCode: '15605',
          },
          {
            name: 'Santa Eulalia',
            zipCode: '15500',
          },
          {
            name: 'Santa Maria del Mar',
            zipCode: '15861',
          },
          {
            name: 'Santa Rosa',
            zipCode: '15476',
          },
          {
            name: 'Santiago de Anchucaya',
            zipCode: '15645',
          },
          {
            name: 'Santiago de Surco',
            zipCode: '15024',
          },
          {
            name: 'Santiago de Tuna',
            zipCode: '15570',
          },
          {
            name: 'Santo Domingo de los Olleros',
            zipCode: '15590',
          },
          {
            name: 'Sayan',
            zipCode: '15237',
          },
          {
            name: 'Sumbilca',
            zipCode: '15210',
          },
          {
            name: 'Supe',
            zipCode: '15162',
          },
          {
            name: 'Supe Puerto',
            zipCode: '15161',
          },
          {
            name: 'Surco',
            zipCode: '15555',
          },
          {
            name: 'Surquillo',
            zipCode: '15038',
          },
          {
            name: 'Tanta',
            zipCode: '15660',
          },
          {
            name: 'Tauripampa',
            zipCode: '15768',
          },
          {
            name: 'Tomas',
            zipCode: '15790',
          },
          {
            name: 'Tupe',
            zipCode: '15761',
          },
          {
            name: 'Vegueta',
            zipCode: '15157',
          },
          {
            name: 'Villa Maria del Triunfo',
            zipCode: '15809',
          },
          {
            name: 'Villa el Salvador',
            zipCode: '15828',
          },
          {
            name: 'Vitarte',
            zipCode: '15479',
          },
          {
            name: 'Vitis',
            zipCode: '15795',
          },
          {
            name: 'Viñac',
            zipCode: '15745',
          },
          {
            name: 'Yangas',
            zipCode: '15335',
          },
          {
            name: 'Yauyos',
            zipCode: '15775',
          },
          {
            name: 'Zuñiga',
            zipCode: '15735',
          },
        ],
        keywords: ['Provincia de Lima'],
        name: 'Lima',
      },
      {
        cities: [
          {
            name: 'Alianza Cristiana',
            zipCode: '16750',
          },
          {
            name: 'Angamos',
            zipCode: '16350',
          },
          {
            name: 'Bagazan',
            zipCode: '16320',
          },
          {
            name: 'Balsapuerto',
            zipCode: '16510',
          },
          {
            name: 'Belen',
            zipCode: '16001',
          },
          {
            name: 'Bretaña',
            zipCode: '16410',
          },
          {
            name: 'Caballococha',
            zipCode: '16240',
          },
          {
            name: 'Concordia',
            zipCode: '16560',
          },
          {
            name: 'Contamana',
            zipCode: '16480',
          },
          {
            name: 'Dos de Mayo',
            zipCode: '16440',
          },
          {
            name: 'Flor de Punga',
            zipCode: '16400',
          },
          {
            name: 'Francisco de Orellana',
            zipCode: '16210',
          },
          {
            name: 'Iberia',
            zipCode: '16370',
          },
          {
            name: 'Inahuaya',
            zipCode: '16460',
          },
          {
            name: 'Indiana',
            zipCode: '16200',
          },
          {
            name: 'Intuto',
            zipCode: '16810',
          },
          {
            name: 'Iquitos',
            zipCode: '16002',
          },
          {
            name: 'Islandia',
            zipCode: '16250',
          },
          {
            name: 'Jeberos',
            zipCode: '16520',
          },
          {
            name: 'Jenaro Herrera',
            zipCode: '16330',
          },
          {
            name: 'Lagunas',
            zipCode: '16550',
          },
          {
            name: 'Mazan',
            zipCode: '16100',
          },
          {
            name: 'Nauta',
            zipCode: '16300',
          },
          {
            name: 'Nueva Alejandria',
            zipCode: '16360',
          },
          {
            name: 'Orellana',
            zipCode: '16450',
          },
          {
            name: 'Pampa Hermosa',
            zipCode: '16470',
          },
          {
            name: 'Pantoja',
            zipCode: '16130',
          },
          {
            name: 'Parinari',
            zipCode: '16570',
          },
          {
            name: 'Pebas',
            zipCode: '16220',
          },
          {
            name: 'Puerto Alegria',
            zipCode: '16630',
          },
          {
            name: 'Punchana',
            zipCode: '16003',
          },
          {
            name: 'Requena',
            zipCode: '16340',
          },
          {
            name: 'San Antonio del Estrecho',
            zipCode: '16110',
          },
          {
            name: 'San Juan',
            zipCode: '16007',
          },
          {
            name: 'San Lorenzo',
            zipCode: '16600',
          },
          {
            name: 'San Pablo de Loreto',
            zipCode: '16230',
          },
          {
            name: 'Santa Clotilde',
            zipCode: '16120',
          },
          {
            name: 'Santa Cruz',
            zipCode: '16540',
          },
          {
            name: 'Santa Elena',
            zipCode: '16380',
          },
          {
            name: 'Santa Isabel',
            zipCode: '16430',
          },
          {
            name: 'Santa Maria de Cahuapanas',
            zipCode: '16610',
          },
          {
            name: 'Santa Maria de Nanay',
            zipCode: '16800',
          },
          {
            name: 'Saramiriza',
            zipCode: '16620',
          },
          {
            name: 'Shucushuyacu',
            zipCode: '16530',
          },
          {
            name: 'Soplin Vargas',
            zipCode: '16140',
          },
          {
            name: 'Tamanco',
            zipCode: '16420',
          },
          {
            name: 'Tamshiyacu',
            zipCode: '16310',
          },
          {
            name: 'Tiruntan',
            zipCode: '16490',
          },
          {
            name: 'Ullpayacu',
            zipCode: '16700',
          },
          {
            name: 'Villa Trompeteros',
            zipCode: '16820',
          },
          {
            name: 'Yurimaguas',
            zipCode: '16500',
          },
        ],
        name: 'Loreto',
      },
      {
        cities: [
          {
            name: 'Boca Colorado',
            zipCode: '17600',
          },
          {
            name: 'Boca Manu',
            zipCode: '17800',
          },
          {
            name: 'Huepetuhe',
            zipCode: '17550',
          },
          {
            name: 'Iberia',
            zipCode: '17250',
          },
          {
            name: 'Iñapari',
            zipCode: '17300',
          },
          {
            name: 'Las Piedras',
            zipCode: '17100',
          },
          {
            name: 'Mazuko',
            zipCode: '17500',
          },
          {
            name: 'Puerto Maldonado',
            zipCode: '17000',
          },
          {
            name: 'Puerto Rosario de Laberinto',
            zipCode: '17400',
          },
          {
            name: 'Salvacion',
            zipCode: '17700',
          },
          {
            name: 'San Lorenzo',
            zipCode: '17200',
          },
        ],
        name: 'Madre de Dios',
      },
      {
        cities: [
          {
            name: 'Calacoa',
            zipCode: '18420',
          },
          {
            name: 'Carumas',
            zipCode: '18400',
          },
          {
            name: 'Chojata',
            zipCode: '18500',
          },
          {
            name: 'Coalaque',
            zipCode: '18210',
          },
          {
            name: 'Cuchumbaya',
            zipCode: '18410',
          },
          {
            name: 'El Algarrobal',
            zipCode: '18620',
          },
          {
            name: 'Ichuña',
            zipCode: '18530',
          },
          {
            name: 'Ilo',
            zipCode: '18600',
          },
          {
            name: 'La Capilla',
            zipCode: '18230',
          },
          {
            name: 'Lloque',
            zipCode: '18510',
          },
          {
            name: 'Matalaque',
            zipCode: '18310',
          },
          {
            name: 'Moquegua',
            zipCode: '18000',
          },
          {
            name: 'Omate',
            zipCode: '18200',
          },
          {
            name: 'Pueblo Nuevo',
            zipCode: '18610',
          },
          {
            name: 'Puquina',
            zipCode: '18220',
          },
          {
            name: 'Quinistaquillas',
            zipCode: '18300',
          },
          {
            name: 'Samegua',
            zipCode: '18001',
          },
          {
            name: 'Torata',
            zipCode: '18100',
          },
          {
            name: 'Ubinas',
            zipCode: '18320',
          },
          {
            name: 'Yunga',
            zipCode: '18520',
          },
        ],
        name: 'Moquegua',
      },
      {
        cities: [
          {
            name: 'Cerro de Pasco',
            zipCode: '19000',
          },
          {
            name: 'Chacayan',
            zipCode: '19720',
          },
          {
            name: 'Chontabamba',
            zipCode: '19210',
          },
          {
            name: 'Goyllarisquizga',
            zipCode: '19710',
          },
          {
            name: 'Huachon',
            zipCode: '19220',
          },
          {
            name: 'Huancabamba',
            zipCode: '19240',
          },
          {
            name: 'Huariaca',
            zipCode: '19120',
          },
          {
            name: 'Huayllay',
            zipCode: '19500',
          },
          {
            name: 'Iscozacin',
            zipCode: '19320',
          },
          {
            name: 'Ninacaca',
            zipCode: '19420',
          },
          {
            name: 'Oxapampa',
            zipCode: '19230',
          },
          {
            name: 'Pallanchacra',
            zipCode: '19110',
          },
          {
            name: 'Paucar',
            zipCode: '19750',
          },
          {
            name: 'Paucartambo',
            zipCode: '19200',
          },
          {
            name: 'Pozuzo',
            zipCode: '19250',
          },
          {
            name: 'Puerto Bermudez',
            zipCode: '19310',
          },
          {
            name: 'San Antonio de Rancas',
            zipCode: '19031',
          },
          {
            name: 'San Pedro de Pillao',
            zipCode: '19650',
          },
          {
            name: 'Santa Ana de Tusi',
            zipCode: '19700',
          },
          {
            name: 'Tapuc',
            zipCode: '19740',
          },
          {
            name: 'Ticlacayan',
            zipCode: '19130',
          },
          {
            name: 'Tinyahuarco',
            zipCode: '19400',
          },
          {
            name: 'Vicco',
            zipCode: '19410',
          },
          {
            name: 'Vilcabamba',
            zipCode: '19730',
          },
          {
            name: 'Villa Rica',
            zipCode: '19300',
          },
          {
            name: 'Yanacancha',
            zipCode: '19001',
          },
          {
            name: 'Yanahuanca',
            zipCode: '19600',
          },
          {
            name: 'Yarusyacan',
            zipCode: '19100',
          },
        ],
        name: 'Pasco',
      },
      {
        cities: [
          {
            name: 'Amotape',
            zipCode: '20730',
          },
          {
            name: 'Ayabaca',
            zipCode: '20540',
          },
          {
            name: 'Bellavista',
            zipCode: '20101',
          },
          {
            name: 'Bellavista de la Union',
            zipCode: '20650',
          },
          {
            name: 'Bernal',
            zipCode: '20670',
          },
          {
            name: 'Bigote',
            zipCode: '20410',
          },
          {
            name: 'Buenos Aires',
            zipCode: '20380',
          },
          {
            name: 'Canchaque',
            zipCode: '20430',
          },
          {
            name: 'Castilla',
            zipCode: '20002',
          },
          {
            name: 'Catacaos',
            zipCode: '20006',
          },
          {
            name: 'Chalaco',
            zipCode: '20350',
          },
          {
            name: 'Chulucanas',
            zipCode: '20300',
          },
          {
            name: 'Cucungara',
            zipCode: '20600',
          },
          {
            name: 'Dos Pueblos',
            zipCode: '20660',
          },
          {
            name: 'El Alto',
            zipCode: '20830',
          },
          {
            name: 'El Arenal',
            zipCode: '20720',
          },
          {
            name: 'Frias',
            zipCode: '20340',
          },
          {
            name: 'Huancabamba',
            zipCode: '20440',
          },
          {
            name: 'Huarmaca',
            zipCode: '20470',
          },
          {
            name: 'Jilili',
            zipCode: '20520',
          },
          {
            name: 'La Arena',
            zipCode: '20620',
          },
          {
            name: 'La Huaca',
            zipCode: '20780',
          },
          {
            name: 'La Matanza',
            zipCode: '20370',
          },
          {
            name: 'La Union',
            zipCode: '20621',
          },
          {
            name: 'Lagunas',
            zipCode: '20550',
          },
          {
            name: 'Lancones',
            zipCode: '20150',
          },
          {
            name: 'Las Lomas',
            zipCode: '20210',
          },
          {
            name: 'Lobitos',
            zipCode: '20820',
          },
          {
            name: 'Los Organos',
            zipCode: '20840',
          },
          {
            name: 'Mancora',
            zipCode: '20850',
          },
          {
            name: 'Marcavelica',
            zipCode: '20120',
          },
          {
            name: 'Montero',
            zipCode: '20510',
          },
          {
            name: 'Morropon',
            zipCode: '20310',
          },
          {
            name: 'Negritos',
            zipCode: '20800',
          },
          {
            name: 'Pacaipampa',
            zipCode: '20560',
          },
          {
            name: 'Paimas',
            zipCode: '20500',
          },
          {
            name: 'Paita',
            zipCode: '20700',
          },
          {
            name: 'Paltashaco',
            zipCode: '20320',
          },
          {
            name: 'Piura',
            zipCode: '20001',
          },
          {
            name: 'Querecotillo',
            zipCode: '20140',
          },
          {
            name: 'Salitral',
            zipCode: '20400',
          },
          {
            name: 'Salitral',
            zipCode: '20130',
          },
          {
            name: 'San Cristo',
            zipCode: '20680',
          },
          {
            name: 'San Felipe de Vichayal',
            zipCode: '20740',
          },
          {
            name: 'San Jacinto',
            zipCode: '20760',
          },
          {
            name: 'San Lucas',
            zipCode: '20710',
          },
          {
            name: 'San Miguel del Faique',
            zipCode: '20460',
          },
          {
            name: 'Santo Domingo',
            zipCode: '20330',
          },
          {
            name: 'Sapalache',
            zipCode: '20450',
          },
          {
            name: 'Sapillica',
            zipCode: '20230',
          },
          {
            name: 'Sechura',
            zipCode: '20690',
          },
          {
            name: 'Sicchez',
            zipCode: '20530',
          },
          {
            name: 'Sinchao',
            zipCode: '20630',
          },
          {
            name: 'Sojo',
            zipCode: '20770',
          },
          {
            name: 'Sondor',
            zipCode: '20480',
          },
          {
            name: 'Sondorillo',
            zipCode: '20490',
          },
          {
            name: 'Sullana',
            zipCode: '20100',
          },
          {
            name: 'Suyo',
            zipCode: '20220',
          },
          {
            name: 'Talara',
            zipCode: '20810',
          },
          {
            name: 'Tamarindo',
            zipCode: '20750',
          },
          {
            name: 'Tambo Grande',
            zipCode: '20200',
          },
          {
            name: 'Tunal',
            zipCode: '20420',
          },
          {
            name: 'Vice',
            zipCode: '20640',
          },
          {
            name: 'Yamango',
            zipCode: '20360',
          },
        ],
        name: 'Piura',
      },
      {
        cities: [
          {
            name: 'Achaya',
            zipCode: '21180',
          },
          {
            name: 'Acora',
            zipCode: '21510',
          },
          {
            name: 'Ajoyani',
            zipCode: '21240',
          },
          {
            name: 'Amantani',
            zipCode: '21127',
          },
          {
            name: 'Ananea',
            zipCode: '21355',
          },
          {
            name: 'Anapia',
            zipCode: '21565',
          },
          {
            name: 'Antauta',
            zipCode: '21205',
          },
          {
            name: 'Arapa',
            zipCode: '21169',
          },
          {
            name: 'Asillo',
            zipCode: '21149',
          },
          {
            name: 'Atuncolla',
            zipCode: '21113',
          },
          {
            name: 'Ayapata',
            zipCode: '21260',
          },
          {
            name: 'Ayaviri',
            zipCode: '21865',
          },
          {
            name: 'Ayrampuni',
            zipCode: '21335',
          },
          {
            name: 'Azangaro',
            zipCode: '21157',
          },
          {
            name: 'Cabana',
            zipCode: '21700',
          },
          {
            name: 'Cabanilla',
            zipCode: '21710',
          },
          {
            name: 'Calapuja',
            zipCode: '21130',
          },
          {
            name: 'Caminaca',
            zipCode: '21175',
          },
          {
            name: 'Capachica',
            zipCode: '21123',
          },
          {
            name: 'Capazo',
            zipCode: '21650',
          },
          {
            name: 'Caracoto',
            zipCode: '21107',
          },
          {
            name: 'Chucuito',
            zipCode: '21520',
          },
          {
            name: 'Chupa',
            zipCode: '21320',
          },
          {
            name: 'Coasa',
            zipCode: '21245',
          },
          {
            name: 'Coata',
            zipCode: '21119',
          },
          {
            name: 'Cojata',
            zipCode: '21410',
          },
          {
            name: 'Conduriri',
            zipCode: '21670',
          },
          {
            name: 'Conima',
            zipCode: '21450',
          },
          {
            name: 'Copani',
            zipCode: '21570',
          },
          {
            name: 'Corani',
            zipCode: '21265',
          },
          {
            name: 'Crucero',
            zipCode: '21215',
          },
          {
            name: 'Cupi',
            zipCode: '21845',
          },
          {
            name: 'Cuyocuyo',
            zipCode: '21360',
          },
          {
            name: 'Desaguadero',
            zipCode: '21610',
          },
          {
            name: 'Deustua',
            zipCode: '21720',
          },
          {
            name: 'Estacion de Pucara',
            zipCode: '21139',
          },
          {
            name: 'Huacullani',
            zipCode: '21620',
          },
          {
            name: 'Huancane',
            zipCode: '21315',
          },
          {
            name: 'Huata',
            zipCode: '21116',
          },
          {
            name: 'Huatasani',
            zipCode: '21325',
          },
          {
            name: 'Huayrapata',
            zipCode: '21440',
          },
          {
            name: 'Ilave',
            zipCode: '21500',
          },
          {
            name: 'Inchupalla',
            zipCode: '21330',
          },
          {
            name: 'Juli',
            zipCode: '21530',
          },
          {
            name: 'Juliaca',
            zipCode: '21100',
          },
          {
            name: 'Juncal',
            zipCode: '21760',
          },
          {
            name: 'Kelluyo',
            zipCode: '21630',
          },
          {
            name: 'Lampa',
            zipCode: '21800',
          },
          {
            name: 'Lanlacuni Bajo',
            zipCode: '21275',
          },
          {
            name: 'Laraqueri',
            zipCode: '21575',
          },
          {
            name: 'Limbani',
            zipCode: '21225',
          },
          {
            name: 'Llalli',
            zipCode: '21835',
          },
          {
            name: 'Macari',
            zipCode: '21875',
          },
          {
            name: 'Macusani',
            zipCode: '21250',
          },
          {
            name: 'Marcaja',
            zipCode: '21555',
          },
          {
            name: 'Massiapo',
            zipCode: '21370',
          },
          {
            name: 'Mazo Cruz',
            zipCode: '21660',
          },
          {
            name: 'Mañazo',
            zipCode: '21730',
          },
          {
            name: 'Moho',
            zipCode: '21430',
          },
          {
            name: 'Muñani',
            zipCode: '21345',
          },
          {
            name: 'Nicasio',
            zipCode: '21135',
          },
          {
            name: 'Nuñoa',
            zipCode: '21895',
          },
          {
            name: 'Ocuviri',
            zipCode: '21825',
          },
          {
            name: 'Ollachea',
            zipCode: '21270',
          },
          {
            name: 'Orurillo',
            zipCode: '21153',
          },
          {
            name: 'Palca',
            zipCode: '21805',
          },
          {
            name: 'Paratia',
            zipCode: '21780',
          },
          {
            name: 'Patambuco',
            zipCode: '21220',
          },
          {
            name: 'Paucarcolla',
            zipCode: '21110',
          },
          {
            name: 'Phara',
            zipCode: '21230',
          },
          {
            name: 'Pilcuyo',
            zipCode: '21525',
          },
          {
            name: 'Pisacoma',
            zipCode: '21640',
          },
          {
            name: 'Plateria',
            zipCode: '21515',
          },
          {
            name: 'Pomata',
            zipCode: '21535',
          },
          {
            name: 'Potoni',
            zipCode: '21210',
          },
          {
            name: 'Pucara',
            zipCode: '21136',
          },
          {
            name: 'Puno',
            zipCode: '21000',
          },
          {
            name: 'Pusi',
            zipCode: '21310',
          },
          {
            name: 'Putina',
            zipCode: '21340',
          },
          {
            name: 'Putina Punco',
            zipCode: '21380',
          },
          {
            name: 'Quiaca',
            zipCode: '21390',
          },
          {
            name: 'Quilcapuncu',
            zipCode: '21350',
          },
          {
            name: 'Rosaspata',
            zipCode: '21420',
          },
          {
            name: 'Saman',
            zipCode: '21300',
          },
          {
            name: 'San Anton',
            zipCode: '21200',
          },
          {
            name: 'San Jose',
            zipCode: '21162',
          },
          {
            name: 'San Juan de Cuturapi',
            zipCode: '21540',
          },
          {
            name: 'San Juan de Salinas',
            zipCode: '21166',
          },
          {
            name: 'San Juan del Oro',
            zipCode: '21375',
          },
          {
            name: 'San Miguel de Ollaraya',
            zipCode: '21550',
          },
          {
            name: 'Sandia',
            zipCode: '21365',
          },
          {
            name: 'Santa Lucia',
            zipCode: '21770',
          },
          {
            name: 'Santa Rosa',
            zipCode: '21885',
          },
          {
            name: 'Santiago de Pupuja',
            zipCode: '21143',
          },
          {
            name: 'Sina',
            zipCode: '21395',
          },
          {
            name: 'Tambillo',
            zipCode: '21255',
          },
          {
            name: 'Taraco',
            zipCode: '21305',
          },
          {
            name: 'Tilali',
            zipCode: '21460',
          },
          {
            name: 'Tinicachi',
            zipCode: '21560',
          },
          {
            name: 'Tiquillaca',
            zipCode: '21750',
          },
          {
            name: 'Tirapata',
            zipCode: '21146',
          },
          {
            name: 'Umachiri',
            zipCode: '21855',
          },
          {
            name: 'Usicayos',
            zipCode: '21235',
          },
          {
            name: 'Vilavila',
            zipCode: '21815',
          },
          {
            name: 'Vilque',
            zipCode: '21740',
          },
          {
            name: 'Vilque Chico',
            zipCode: '21400',
          },
          {
            name: 'Yanahuaya',
            zipCode: '21385',
          },
          {
            name: 'Yunguyo',
            zipCode: '21545',
          },
          {
            name: 'Zepita',
            zipCode: '21600',
          },
        ],
        name: 'Puno',
      },
      {
        cities: [
          {
            name: 'Agua Blanca',
            zipCode: '22710',
          },
          {
            name: 'Bajo Naranjillo',
            zipCode: '22860',
          },
          {
            name: 'Barranquita',
            zipCode: '22240',
          },
          {
            name: 'Bellavista',
            zipCode: '22740',
          },
          {
            name: 'Buenos Aires',
            zipCode: '22410',
          },
          {
            name: 'Cacatachi',
            zipCode: '22160',
          },
          {
            name: 'Calzada',
            zipCode: '22800',
          },
          {
            name: 'Campanilla',
            zipCode: '22520',
          },
          {
            name: 'Caspisapa',
            zipCode: '22440',
          },
          {
            name: 'Chazuta',
            zipCode: '22310',
          },
          {
            name: 'Cuzco',
            zipCode: '22490',
          },
          {
            name: 'Cuñumbuqui',
            zipCode: '22180',
          },
          {
            name: 'El Eslabon',
            zipCode: '22640',
          },
          {
            name: 'Habana',
            zipCode: '22805',
          },
          {
            name: 'Huicungo',
            zipCode: '22620',
          },
          {
            name: 'Huimbayoc',
            zipCode: '22260',
          },
          {
            name: 'Jepelacio',
            zipCode: '22100',
          },
          {
            name: 'Juan Guerra',
            zipCode: '22400',
          },
          {
            name: 'Juanjui',
            zipCode: '22600',
          },
          {
            name: 'La Banda',
            zipCode: '22200',
          },
          {
            name: 'Lamas',
            zipCode: '22150',
          },
          {
            name: 'Ledoy',
            zipCode: '22510',
          },
          {
            name: 'Monte Cristo',
            zipCode: '22570',
          },
          {
            name: 'Morales',
            zipCode: '22202',
          },
          {
            name: 'Moyobamba',
            zipCode: '22001',
          },
          {
            name: 'Naranjos',
            zipCode: '22865',
          },
          {
            name: 'Navarro',
            zipCode: '22255',
          },
          {
            name: 'Nueva Cajamarca',
            zipCode: '22845',
          },
          {
            name: 'Nuevo Lima',
            zipCode: '22480',
          },
          {
            name: 'Nuevo Progreso',
            zipCode: '22550',
          },
          {
            name: 'Pachiza',
            zipCode: '22610',
          },
          {
            name: 'Pajarillo',
            zipCode: '22500',
          },
          {
            name: 'Papaplaya',
            zipCode: '22250',
          },
          {
            name: 'Pasarraya',
            zipCode: '22670',
          },
          {
            name: 'Pelejo',
            zipCode: '22245',
          },
          {
            name: 'Picota',
            zipCode: '22430',
          },
          {
            name: 'Pilluana',
            zipCode: '22350',
          },
          {
            name: 'Pinto Recodo',
            zipCode: '22140',
          },
          {
            name: 'Piscoyacu',
            zipCode: '22650',
          },
          {
            name: 'Polvora',
            zipCode: '22530',
          },
          {
            name: 'Pongo de Caynarachi',
            zipCode: '22235',
          },
          {
            name: 'Posic',
            zipCode: '22835',
          },
          {
            name: 'Pucacaca',
            zipCode: '22420',
          },
          {
            name: 'Puerto Rico',
            zipCode: '22450',
          },
          {
            name: 'Rioja',
            zipCode: '22825',
          },
          {
            name: 'Roque',
            zipCode: '22110',
          },
          {
            name: 'Rumisapa',
            zipCode: '22170',
          },
          {
            name: 'Sacanche',
            zipCode: '22630',
          },
          {
            name: 'San Antonio',
            zipCode: '22215',
          },
          {
            name: 'San Cristobal de Sisa',
            zipCode: '22460',
          },
          {
            name: 'San Fernando',
            zipCode: '22855',
          },
          {
            name: 'San Jose de Sisa',
            zipCode: '22700',
          },
          {
            name: 'San Martin',
            zipCode: '22770',
          },
          {
            name: 'San Pablo',
            zipCode: '22730',
          },
          {
            name: 'San Rafael',
            zipCode: '22470',
          },
          {
            name: 'San Roque de Cumbaza',
            zipCode: '22220',
          },
          {
            name: 'Santa Rosa',
            zipCode: '22720',
          },
          {
            name: 'Saposoa',
            zipCode: '22660',
          },
          {
            name: 'Sauce',
            zipCode: '22330',
          },
          {
            name: 'Segunda Jerusalen',
            zipCode: '22840',
          },
          {
            name: 'Shamboyacu',
            zipCode: '22370',
          },
          {
            name: 'Shanao',
            zipCode: '22130',
          },
          {
            name: 'Shapaja',
            zipCode: '22300',
          },
          {
            name: 'Shatoja',
            zipCode: '22760',
          },
          {
            name: 'Soritor',
            zipCode: '22810',
          },
          {
            name: 'Tabalosos',
            zipCode: '22120',
          },
          {
            name: 'Tarapoto',
            zipCode: '22201',
          },
          {
            name: 'Tingo de Ponasa',
            zipCode: '22360',
          },
          {
            name: 'Tingo de Saposoa',
            zipCode: '22750',
          },
          {
            name: 'Tocache',
            zipCode: '22540',
          },
          {
            name: 'Tres Unidos',
            zipCode: '22340',
          },
          {
            name: 'Uchiza',
            zipCode: '22560',
          },
          {
            name: 'Utcurarca',
            zipCode: '22320',
          },
          {
            name: 'Yantalo',
            zipCode: '22000',
          },
          {
            name: 'Yantalo',
            zipCode: '22051',
          },
          {
            name: 'Yorongos',
            zipCode: '22820',
          },
          {
            name: 'Yuracyacu',
            zipCode: '22850',
          },
          {
            name: 'Zapatero',
            zipCode: '22190',
          },
        ],
        name: 'San Martin',
      },
      {
        cities: [
          {
            name: 'Alfonso Ugarte',
            zipCode: '23003',
          },
          {
            name: 'Cairani',
            zipCode: '23440',
          },
          {
            name: 'Calana',
            zipCode: '23041',
          },
          {
            name: 'Camilaca',
            zipCode: '23850',
          },
          {
            name: 'Candarave',
            zipCode: '23420',
          },
          {
            name: 'Chucatamani',
            zipCode: '23240',
          },
          {
            name: 'Ciudad Nueva',
            zipCode: '23002',
          },
          {
            name: 'Curibaya',
            zipCode: '23480',
          },
          {
            name: 'Estique',
            zipCode: '23120',
          },
          {
            name: 'Estique Pampa',
            zipCode: '23100',
          },
          {
            name: 'Huanuara',
            zipCode: '23460',
          },
          {
            name: 'Ilabaya',
            zipCode: '23800',
          },
          {
            name: 'Ite',
            zipCode: '23700',
          },
          {
            name: 'La Esperanza',
            zipCode: '23001',
          },
          {
            name: 'La Esperanza',
            zipCode: '23006',
          },
          {
            name: 'Las Yaras',
            zipCode: '23650',
          },
          {
            name: 'Locumba',
            zipCode: '23750',
          },
          {
            name: 'Pachia',
            zipCode: '23500',
          },
          {
            name: 'Palca',
            zipCode: '23550',
          },
          {
            name: 'Pocollay',
            zipCode: '23000',
          },
          {
            name: 'Quilahuani',
            zipCode: '23400',
          },
          {
            name: 'Sama Grande',
            zipCode: '23600',
          },
          {
            name: 'Sitajara',
            zipCode: '23300',
          },
          {
            name: 'Susapaya',
            zipCode: '23350',
          },
          {
            name: 'Tacna',
            zipCode: '23004',
          },
          {
            name: 'Tarata',
            zipCode: '23200',
          },
          {
            name: 'Tarucachi',
            zipCode: '23140',
          },
          {
            name: 'Ticaco',
            zipCode: '23220',
          },
        ],
        name: 'Tacna',
      },
      {
        cities: [
          {
            name: 'Aguas Verdes',
            zipCode: '24100',
          },
          {
            name: 'Caleta Cruz',
            zipCode: '24520',
          },
          {
            name: 'Cancas',
            zipCode: '24560',
          },
          {
            name: 'Cañaveral',
            zipCode: '24450',
          },
          {
            name: 'Matapalo',
            zipCode: '24250',
          },
          {
            name: 'Pampas de Hospital',
            zipCode: '24350',
          },
          {
            name: 'Papayal',
            zipCode: '24200',
          },
          {
            name: 'San Jacinto',
            zipCode: '24400',
          },
          {
            name: 'San Juan de la Virgen',
            zipCode: '24300',
          },
          {
            name: 'San Pedro de los Incas',
            zipCode: '24500',
          },
          {
            name: 'Tumbes',
            zipCode: '24000',
          },
          {
            name: 'Zarumilla',
            zipCode: '24150',
          },
          {
            name: 'Zorritos',
            zipCode: '24540',
          },
        ],
        name: 'Tumbes',
      },
      {
        cities: [
          {
            name: 'Aguaytia',
            zipCode: '25550',
          },
          {
            name: 'Atalaya',
            zipCode: '25200',
          },
          {
            name: 'Bolognesi',
            zipCode: '25220',
          },
          {
            name: 'Breu',
            zipCode: '25300',
          },
          {
            name: 'Campo Verde',
            zipCode: '25500',
          },
          {
            name: 'Curimana',
            zipCode: '25600',
          },
          {
            name: 'Esperanza',
            zipCode: '25400',
          },
          {
            name: 'Iparia',
            zipCode: '25230',
          },
          {
            name: 'Masisea',
            zipCode: '25100',
          },
          {
            name: 'Nueva Requena',
            zipCode: '25700',
          },
          {
            name: 'Pucallpa',
            zipCode: '25000',
          },
          {
            name: 'Puerto Callao',
            zipCode: '25003',
          },
          {
            name: 'San Alejandro',
            zipCode: '25530',
          },
          {
            name: 'San Fernando',
            zipCode: '25001',
          },
          {
            name: 'Sepahua',
            zipCode: '25210',
          },
        ],
        name: 'Ucayali',
      },
    ],
  },
  {
    code: 'PH',
    name: 'Philippines',
    phone: '63',
  },
  {
    code: 'PN',
    name: 'Pitcairn',
    phone: '870',
  },
  {
    code: 'PL',
    name: 'Poland',
    phone: '48',
  },
  {
    code: 'PT',
    name: 'Portugal',
    numberFormat: {
      code: 'pt-PT',
      currency: 'EUR',
    },
    phone: '351',
  },
  {
    code: 'PR',
    name: 'Puerto Rico',
    phone: '1',
  },
  {
    code: 'QA',
    name: 'Qatar',
    phone: '974',
  },
  {
    code: 'RE',
    name: 'Reunion',
    phone: '262',
  },
  {
    code: 'RO',
    name: 'Romania',
    phone: '40',
  },
  {
    code: 'RU',
    name: 'Russia',
    numberFormat: {
      code: 'ru-RU',
      currency: 'RUB',
    },
    phone: '7',
  },
  {
    code: 'RW',
    name: 'Rwanda',
    phone: '250',
  },
  {
    code: 'BL',
    name: 'Saint Barthelemy',
    phone: '590',
  },
  {
    code: 'SH',
    name: 'Saint Helena',
    phone: '290',
  },
  {
    code: 'KN',
    name: 'Saint Kitts and Nevis',
    phone: '1-869',
  },
  {
    code: 'LC',
    name: 'Saint Lucia',
    phone: '1-758',
  },
  {
    code: 'MF',
    name: 'Saint Martin (French part)',
    phone: '590',
  },
  {
    code: 'PM',
    name: 'Saint Pierre and Miquelon',
    phone: '508',
  },
  {
    code: 'VC',
    name: 'Saint Vincent and the Grenadines',
    phone: '1-784',
  },
  {
    code: 'WS',
    name: 'Samoa',
    phone: '685',
  },
  {
    code: 'SM',
    name: 'San Marino',
    phone: '378',
  },
  {
    code: 'ST',
    name: 'Sao Tome and Principe',
    phone: '239',
  },
  {
    code: 'SA',
    name: 'Saudi Arabia',
    numberFormat: {
      code: 'ar-SA',
      currency: 'AED',
    },
    phone: '966',
  },
  {
    code: 'SN',
    name: 'Senegal',
    phone: '221',
  },
  {
    code: 'RS',
    name: 'Serbia',
    phone: '381',
  },
  {
    code: 'SC',
    name: 'Seychelles',
    phone: '248',
  },
  {
    code: 'SL',
    name: 'Sierra Leone',
    phone: '232',
  },
  {
    code: 'SG',
    name: 'Singapore',
    phone: '65',
  },
  {
    code: 'SX',
    name: 'Sint Maarten (Dutch part)',
    phone: '1-721',
  },
  {
    code: 'SK',
    name: 'Slovakia',
    phone: '421',
  },
  {
    code: 'SI',
    name: 'Slovenia',
    phone: '386',
  },
  {
    code: 'SB',
    name: 'Solomon Islands',
    phone: '677',
  },
  {
    code: 'SO',
    name: 'Somalia',
    phone: '252',
  },
  {
    code: 'ZA',
    name: 'South Africa',
    phone: '27',
  },
  {
    code: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
    phone: '500',
  },
  {
    code: 'SS',
    name: 'South Sudan',
    phone: '211',
  },
  {
    code: 'ES',
    name: 'Spain',
    numberFormat: {
      code: 'es-ES',
      currency: 'EUR',
    },
    phone: '34',
  },
  {
    code: 'LK',
    name: 'Sri Lanka',
    phone: '94',
  },
  {
    code: 'SD',
    name: 'Sudan',
    phone: '249',
  },
  {
    code: 'SR',
    name: 'Suriname',
    phone: '597',
  },
  {
    code: 'SJ',
    name: 'Svalbard and Jan Mayen',
    phone: '47',
  },
  {
    code: 'SZ',
    name: 'Swaziland',
    phone: '268',
  },
  {
    code: 'SE',
    name: 'Sweden',
    phone: '46',
  },
  {
    code: 'CH',
    name: 'Switzerland',
    phone: '41',
  },
  {
    code: 'SY',
    name: 'Syrian Arab Republic',
    phone: '963',
  },
  {
    code: 'TW',
    name: 'Taiwan, Province of China',
    phone: '886',
  },
  {
    code: 'TJ',
    name: 'Tajikistan',
    phone: '992',
  },
  {
    code: 'TH',
    name: 'Thailand',
    phone: '66',
  },
  {
    code: 'TL',
    name: 'Timor-Leste',
    phone: '670',
  },
  {
    code: 'TG',
    name: 'Togo',
    phone: '228',
  },
  {
    code: 'TK',
    name: 'Tokelau',
    phone: '690',
  },
  {
    code: 'TO',
    name: 'Tonga',
    phone: '676',
  },
  {
    code: 'TT',
    name: 'Trinidad and Tobago',
    phone: '1-868',
  },
  {
    code: 'TN',
    name: 'Tunisia',
    phone: '216',
  },
  {
    code: 'TR',
    name: 'Turkey',
    phone: '90',
  },
  {
    code: 'TM',
    name: 'Turkmenistan',
    phone: '993',
  },
  {
    code: 'TC',
    name: 'Turks and Caicos Islands',
    phone: '1-649',
  },
  {
    code: 'TV',
    name: 'Tuvalu',
    phone: '688',
  },
  {
    code: 'VI',
    name: 'US Virgin Islands',
    phone: '1-340',
  },
  {
    code: 'UG',
    name: 'Uganda',
    phone: '256',
  },
  {
    code: 'UA',
    name: 'Ukraine',
    phone: '380',
  },
  {
    code: 'AE',
    name: 'United Arab Emirates',
    phone: '971',
  },
  {
    code: 'GB',
    name: 'United Kingdom',
    phone: '44',
  },
  {
    code: 'TZ',
    name: 'United Republic of Tanzania',
    phone: '255',
  },
  {
    code: 'US',
    name: 'United States',
    numberFormat: {
      code: 'en-US',
      currency: 'USD',
    },
    phone: '1',
    suggested: true,
  },
  {
    code: 'UY',
    name: 'Uruguay',
    phone: '598',
  },
  {
    code: 'UZ',
    name: 'Uzbekistan',
    phone: '998',
  },
  {
    code: 'VU',
    name: 'Vanuatu',
    phone: '678',
  },
  {
    code: 'VE',
    name: 'Venezuela',
    phone: '58',
  },
  {
    code: 'VN',
    name: 'Vietnam',
    numberFormat: {
      code: 'vi-VN',
      currency: 'VND',
    },
    phone: '84',
  },
  {
    code: 'WF',
    name: 'Wallis and Futuna',
    phone: '681',
  },
  {
    code: 'EH',
    name: 'Western Sahara',
    phone: '212',
  },
  {
    code: 'YE',
    name: 'Yemen',
    phone: '967',
  },
  {
    code: 'ZM',
    name: 'Zambia',
    phone: '260',
  },
  {
    code: 'ZW',
    name: 'Zimbabwe',
    phone: '263',
  },
];
